export default {
  Account: {
    labels: {
      friendly_id: 'Friendly',
      owner: 'Owner',
      name: 'Account name',
      billing_email: 'Billing email',
      subdomain: 'Account ID',
      account_id: 'Account ID',
      region: 'Region',
      gravatar_email: 'Gravatar email',
    },
  },
  User: {
    labels: {
      email: 'Email',
      password: 'Password',
      name: 'Name',
      location: 'Location',
      time_zone: 'Time zone',
      notification_settings: 'Notification settings',
      gravatar_email: 'Gravatar email',
      base: '',
      reset_password_token: 'Reset password token',
      invitation_token: 'Invitation token',
      confirmation_token: 'Confirmation token',
    },
  },
  Cluster: {
    labels: {
      status: 'Status',
      name: 'Name',
      owner: 'Owner',
      account: 'Account',
      nodes: 'Nodes',
      size: 'Size',
      mode: 'Mode',
      description: 'Description',
      stack: 'Stack',
      region: 'Region',
      master_spot_price: 'Master spot price',
      slave_spot_price: 'Slave spot price',
      master_spot_percentage: 'Master spot percentage',
      slave_spot_percentage: 'Slave spot percentage',
      name_node_host: 'NameNode host',
      job_tracker_host: 'JobTracker host',
      oozie_host: 'Oozie host',
      oozie_port: 'Oozie port',
      name_node_port: 'NameNode port',
      job_tracker_port: 'JobTracker port',
      time_to_idle: 'Time to idle',
    },
  },
  NewCluster: {
    labels: {
      status: 'Status',
      name: 'Name',
      owner: 'Owner',
      account: 'Account',
      nodes: 'Nodes',
      size: 'Size',
      mode: 'Mode',
      description: 'Description',
      stack: 'Stack',
      region: 'Region',
      master_spot_price: 'Master spot price',
      slave_spot_price: 'Slave spot price',
      master_spot_percentage: 'Master spot percentage',
      slave_spot_percentage: 'Slave spot percentage',
      name_node_host: 'NameNode host',
      job_tracker_host: 'JobTracker host',
      oozie_host: 'Oozie host',
      oozie_port: 'Oozie port',
      name_node_port: 'NameNode port',
      job_tracker_port: 'JobTracker port',
      time_to_idle: 'Time to idle',
    },
  },
  Package: {
    labels: {
      status: 'Status',
      owner: 'Owner',
      account: 'Account',
      name: 'Name',
      description: 'Description',
      data_flow_json: 'Data flow json',
      flow_type: 'Flow type',
    },
  },
  NewPackage: {
    labels: {
      status: 'Status',
      owner: 'Owner',
      account: 'Account',
      name: 'Name',
      description: 'Description',
      data_flow_json: 'Data flow json',
      flow_type: 'Flow type',
    },
  },
  Job: {
    labels: {
      ancestry: 'Ancestry',
      status: 'Status',
      cluster_id: 'Cluster',
      job_id: 'Package ID',
      account: 'Account',
      owner: 'Owner',
      cluster: 'Cluster',
      job: 'Package',
    },
  },
  Schedule: {
    labels: {
      friendly_id: 'Friendly',
      status: 'Status',
      owner: 'Owner',
      account: 'Account',
      name: 'Name',
      interval_amount: 'Interval amount',
      interval_unit: 'Interval unit',
      task: 'Task',
      start_at: 'Start',
      next_run_at: 'Next run',
      reuse_cluster_strategy: 'Reuse cluster strategy',
      recurrence_count: 'Recurrences',
      description: 'Description',
      schedule_expression: '',
      invalid_cron_message: 'Please fill in a valid expression.',
    },
  },
  NewSchedule: {
    labels: {
      friendly_id: 'Friendly',
      status: 'Status',
      owner: 'Owner',
      account: 'Account',
      name: 'Name',
      interval_amount: 'Interval amount',
      interval_unit: 'Interval unit',
      task: 'Task',
      start_at: 'Start',
      next_run_at: 'Next run',
      reuse_cluster_strategy: 'Reuse cluster strategy',
      recurrence_count: 'Recurrences',
      description: 'Description',
    },
  },
  JobValidation: {
    labels: {
      status: 'Status',
      owner: 'Owner',
      account: 'Account',
      job: 'Package',
    },
  },
  Key: {
    labels: {
      name: 'Name',
      owner: 'Owner',
      public_key: 'Public key',
      fingerprint: 'Fingerprint',
      comment: 'Comment',
    },
  },
  CloudStorageConnection: {
    labels: {
      account: 'Account',
      owner: 'Owner',
      type: 'Type',
      username: 'User name',
      password: 'Password',
      name: 'Name',
      tunnel_type: 'Access type',
      local_port: 'Local port',
      status: 'Status',
      ssh_host: 'SSH Hostname',
      ssh_username: 'SSH User name',
      ssh_port: 'SSH Port',
    },
  },
  DatabaseConnection: {
    labels: {
      account: 'Account',
      owner: 'Owner',
      type: 'Type',
      name: 'Name',
      tunnel_type: 'Access type',
      local_port: 'Local port',
      host: 'Hostname',
      port: 'Port',
      username: 'User name',
      password: 'Password',
      status: 'Status',
      ssh_host: 'SSH Hostname',
      ssh_username: 'SSH User name',
      ssh_port: 'SSH Port',
    },
  },
  WebHook: {
    labels: {
      owner: 'Owner',
      account: 'Account',
      name: 'Name',
      insecure_ssl: 'Insecure SSL',
      basic_auth: 'Use basic authentication',
      url: 'Webhook URL',
      salt: 'Salt',
      basic_auth_data: 'Data for Basic Authentication (user:password encoded with base64)',
    },
  },
  SlackHook: {
    labels: {
      owner: 'Owner',
      account: 'Account',
      name: 'Name',
      url: 'Slack webhook URL',
    },
  },
  PagerDutyHook: {
    labels: {
      owner: 'Owner',
      account: 'Account',
      name: 'Name',
      service_key: 'Service key',
      pd_account: 'Account name',
      service_name: 'Service name',
    },
  },
  EmailHook: {
    labels: {
      owner: 'Owner',
      account: 'Account',
      name: 'Name',
      emails: 'Emails',
    },
  },
  PostgresDatabaseConnection: {
    labels: {
      ssl: 'Ssl',
      account: 'Account',
      owner: 'Owner',
      type: 'Type',
      name: 'Name',
      tunnel_type: 'Access type',
      local_port: 'Local port',
      host: 'Hostname',
      port: 'Port',
      username: 'User name',
      password: 'Password',
      status: 'Status',
      ssh_host: 'SSH Hostname',
      ssh_username: 'SSH User name',
      ssh_port: 'SSH Port',
    },
  },
  RedshiftDatabaseConnection: {
    labels: {
      ssl: 'Ssl',
      region: 'Region',
      account: 'Account',
      owner: 'Owner',
      type: 'Type',
      name: 'Name',
      tunnel_type: 'Access type',
      local_port: 'Local port',
      host: 'Hostname',
      port: 'Port',
      username: 'User name',
      password: 'Password',
      database: 'Database',
      status: 'Status',
      ssh_host: 'SSH Hostname',
      ssh_username: 'SSH User name',
      ssh_port: 'SSH Port',
    },
  },
  SnowflakeDatabaseConnection: {
    labels: {
      warehouse: 'Warehouse',
      region: 'Region',
      account: 'Account',
      owner: 'Owner',
      type: 'Type',
      name: 'Name',
      tunnel_type: 'Access type',
      local_port: 'Local port',
      account_name: 'Account name',
      host: 'Account name',
      port: 'Port',
      username: 'User name',
      password: 'Password',
      database: 'Database',
      status: 'Status',
      ssh_host: 'SSH Hostname',
      ssh_username: 'SSH User name',
      ssh_port: 'SSH Port',
    },
  },
  MysqlDatabaseConnection: {
    labels: {
      account: 'Account',
      owner: 'Owner',
      type: 'Type',
      name: 'Name',
      tunnel_type: 'Access type',
      local_port: 'Local port',
      host: 'Hostname',
      port: 'Port',
      username: 'User name',
      password: 'Password',
      database: 'Database',
      status: 'Status',
      ssh_host: 'SSH Hostname',
      ssh_username: 'SSH User name',
      ssh_port: 'SSH Port',
    },
  },
  VerticaDatabaseConnection: {
    title: 'Vertica',
    labels: {
      account: 'Account',
      owner: 'Owner',
      type: 'Type',
      name: 'Name',
      tunnel_type: 'Access type',
      local_port: 'Local port',
      host: 'Hostname',
      port: 'Port',
      username: 'User name',
      password: 'Password',
      database: 'Database',
      status: 'Status',
    },
  },
  HanaDatabaseConnection: {
    labels: {
      account: 'Account',
      owner: 'Owner',
      type: 'Type',
      name: 'Name',
      tunnel_type: 'Access type',
      local_port: 'Local port',
      host: 'Hostname',
      port: 'Port',
      username: 'User name',
      password: 'Password',
      status: 'Status',
      ssh_host: 'SSH Hostname',
      ssh_username: 'SSH User name',
      ssh_port: 'SSH Port',
    },
  },
  HerokuPostgresDatabaseConnection: {
    labels: {
      ssl: 'Ssl',
      account: 'Account',
      owner: 'Owner',
      type: 'Type',
      name: 'Name',
      tunnel_type: 'Access type',
      local_port: 'Local port',
      host: 'Hostname',
      port: 'Port',
      username: 'User name',
      password: 'Password',
      status: 'Status',
      ssh_host: 'SSH Hostname',
      ssh_username: 'SSH User name',
      ssh_port: 'SSH Port',
    },
  },
  MongoDatabaseConnection: {
    labels: {
      account: 'Account',
      owner: 'Owner',
      type: 'Type',
      name: 'Name',
      database: 'Database',
      local_port: 'Local port',
      ssl: 'Ssl',
      tunnel_type: 'Access type',
      host: 'Hostname',
      port: 'Port',
      username: 'User name',
      password: 'Password',
      status: 'Status',
      ssh_host: 'SSH Hostname',
      ssh_username: 'SSH User name',
      ssh_port: 'SSH Port',
    },
  },
  SqlServerDatabaseConnection: {
    labels: {
      account: 'Account',
      owner: 'Owner',
      type: 'Type',
      name: 'Name',
      tunnel_type: 'Access type',
      local_port: 'Local port',
      host: 'Hostname',
      port: 'Port',
      username: 'User name',
      password: 'Password',
      status: 'Status',
      ssh_host: 'SSH Hostname',
      ssh_username: 'SSH User name',
      ssh_port: 'SSH Port',
    },
  },
  AzureSynapseAnalyticsDatabaseConnection: {
    labels: {
      account: 'Account',
      owner: 'Owner',
      type: 'Type',
      name: 'Name',
      tunnel_type: 'Access type',
      local_port: 'Local port',
      host: 'Hostname',
      port: 'Port',
      username: 'User name',
      password: 'Password',
      status: 'Status',
      ssh_host: 'SSH Hostname',
      ssh_username: 'SSH User name',
      ssh_port: 'SSH Port',
    },
  },
  BigQueryDatabaseConnection: {
    labels: {
      account: 'Account',
      type: 'Type',
      name: 'Name',
      region: 'Region',
      owner: 'Owner',
      tunnel_type: 'Access type',
      local_port: 'Local port',
      host: 'Project ID',
      port: 'Port',
      username: 'User name',
      password: 'Password',
      status: 'Status',
      database: 'Dataset ID',
      ssh_host: 'SSH Hostname',
      ssh_username: 'SSH User name',
      ssh_port: 'SSH Port',
    },
  },
  GoogleCloudSqlDatabaseConnection: {
    labels: {
      account: 'Account',
      owner: 'Owner',
      type: 'Type',
      name: 'Name',
      tunnel_type: 'Access type',
      local_port: 'Local port',
      host: 'Hostname',
      port: 'Port',
      username: 'User name',
      password: 'Password',
      database: 'Database',
      status: 'Status',
      ssh_host: 'SSH Hostname',
      ssh_username: 'SSH User name',
      ssh_port: 'SSH Port',
    },
  },
  SegmentDatabaseConnection: {
    labels: {
      ssl: 'Ssl',
      region: 'Region',
      account: 'Account',
      owner: 'Owner',
      type: 'Type',
      name: 'Name',
      tunnel_type: 'Access type',
      local_port: 'Local port',
      host: 'Hostname',
      port: 'Port',
      username: 'User name',
      password: 'Password (Read-Only)',
      status: 'Status',
      ssh_host: 'SSH Hostname',
      ssh_username: 'SSH User name',
      ssh_port: 'SSH Port',
    },
  },
  Db2DatabaseConnection: {
    labels: {
      ssl: 'Ssl',
      account: 'Account',
      owner: 'Owner',
      type: 'Type',
      name: 'Name',
      tunnel_type: 'Access type',
      local_port: 'Local port',
      host: 'Hostname',
      port: 'Port',
      username: 'User name',
      password: 'Password',
      status: 'Status',
      ssh_host: 'SSH Hostname',
      ssh_username: 'SSH User name',
      ssh_port: 'SSH Port',
    },
  },
  AmazonS3Connection: {
    labels: {
      username: 'Access key ID',
      password: 'Secret access key',
      account: 'Account',
      owner: 'Owner',
      type: 'Type',
      name: 'Name',
      tunnel_type: 'Access type',
      local_port: 'Local port',
      status: 'Status',
    },
  },
  AzureBlobStorageConnection: {
    labels: {
      username: 'Storage Account Name',
      password: 'Access Key',
      account: 'Account',
      owner: 'Owner',
      type: 'Type',
      name: 'Name',
      tunnel_type: 'Access type',
      local_port: 'Local port',
      status: 'Status',
    },
  },
  SwiftConnection: {
    labels: {
      authentication_service: 'Authentication endpoint',
      private_authentication_service: 'Private authentication endpoint',
      auth_method: 'Authentication method',
      account: 'Account',
      owner: 'Owner',
      type: 'Type',
      username: 'User name',
      password: 'API Key',
      name: 'Name',
      tunnel_type: 'Access type',
      local_port: 'Local port',
      status: 'Status',
    },
  },
  SoftlayerObjectStorageConnection: {
    labels: {
      authentication_service: 'Authentication endpoint',
      private_authentication_service: 'Private authentication endpoint',
      auth_method: 'Authentication method',
      region: 'Region',
      account: 'Account',
      owner: 'Owner',
      type: 'Type',
      username: 'User name',
      password: 'API key (Password)',
      name: 'Name',
      tunnel_type: 'Access type',
      local_port: 'Local port',
      status: 'Status',
    },
  },
  GoogleCloudStorageConnection: {
    labels: {
      project_id: 'Project ID',
      account: 'Account',
      owner: 'Owner',
      type: 'Type',
      username: 'User name',
      password: 'Password',
      name: 'Name',
      tunnel_type: 'Access type',
      local_port: 'Local port',
      status: 'Status',
    },
  },
  RackspaceCloudFilesConnection: {
    labels: {
      authentication_service: 'Authentication Endpoint',
      private_authentication_service: 'Private authentication endpoint',
      auth_method: 'Authentication Method',
      auth_type: 'Auth type',
      region: 'Region',
      account: 'Account',
      owner: 'Owner',
      type: 'Type',
      username: 'User name',
      password: 'API Key',
      name: 'Name',
      tunnel_type: 'Access type',
      local_port: 'Local port',
      status: 'Status',
    },
  },
  HdfsConnection: {
    labels: {
      name_node_host: 'NameNode hostname',
      httpfs_host: 'HttpFS hostname',
      httpfs_port: 'HttpFS port',
      name_node_port: 'NameNode port',
      account: 'Account',
      owner: 'Owner',
      type: 'Type',
      username: 'User name',
      password: 'Password',
      name: 'Name',
      tunnel_type: 'Access type',
      local_port: 'Local port',
      status: 'Status',
    },
  },
  GoogleAdwordsConnection: {
    labels: {
      password: 'Token',
      expires_at: 'Expires at',
      expires: 'Expires',
      account: 'Account',
      owner: 'Owner',
      type: 'Type',
      username: 'Authorizing user',
      name: 'Name',
      tunnel_type: 'Access type',
      local_port: 'Local port',
      status: 'Status',
    },
  },
  GoogleAnalyticsConnection: {
    labels: {
      password: 'Token',
      expires_at: 'Expires at',
      expires: 'Expires',
      account: 'Account',
      owner: 'Owner',
      type: 'Type',
      username: 'Authorizing user',
      name: 'Name',
      tunnel_type: 'Access type',
      local_port: 'Local port',
      status: 'Status',
    },
  },
  BingAdsConnection: {
    labels: {
      password: 'Token',
      expires_at: 'Expires at',
      expires: 'Expires',
      account: 'Account',
      owner: 'Owner',
      type: 'Type',
      username: 'Authorizing user',
      name: 'Name',
      tunnel_type: 'Access type',
      local_port: 'Local port',
      status: 'Status',
    },
  },
  SftpConnection: {
    labels: {
      host: 'Hostname',
      port: 'Port',
      username: 'User name',
      password: 'Password',
      auth_method: 'Authentication method',
      account: 'Account',
      owner: 'Owner',
      type: 'Type',
      name: 'Name',
      tunnel_type: 'Access type',
      local_port: 'Local port',
      status: 'Status',
      ssh_host: 'SSH Hostname',
      ssh_username: 'SSH User name',
      ssh_port: 'SSH Port',
    },
  },
  FtpsConnection: {
    labels: {
      host: 'Hostname',
      port: 'Port',
      username: 'User name',
      password: 'Password',
      account: 'Account',
      owner: 'Owner',
      type: 'Type',
      name: 'Name',
      status: 'Status',
    },
  },
  SalesforceConnection: {
    labels: {
      password: 'Token',
      expires_at: 'Expires at',
      expires: 'Expires',
      environment: 'Environment',
      account: 'Account',
      owner: 'Owner',
      type: 'Type',
      username: 'Authorizing user',
      name: 'Name',
      tunnel_type: 'Access type',
      local_port: 'Local port',
      status: 'Status',
      code: 'Authorizing code',
    },
  },
  NetSuiteDestinationConnection: {
    labels: {
      status: 'Status',
      account_id: 'Account ID',
      consumer_key: 'Consumer Key',
      consumer_secret: 'Consumer Secret',
      token_id: 'Token ID',
      token_secret: 'Token Secret',
    },
  },
  NetSuiteConnection: {
    labels: {
      username: 'User name',
      password: 'Password',
      account: 'Account',
      owner: 'Owner',
      type: 'Type',
      name: 'Name',
      tunnel_type: 'Access type',
      local_port: 'Local port',
      status: 'Status',
      host: 'Service host',
      port: 'Service port',
      net_suite_account_id: 'Account ID',
      role_id: 'Role ID',
      database: 'Service data source',
    },
  },
  GoogleCloudSpannerDatabaseConnection: {
    labels: {
      username: 'User name',
      password: 'Password',
      account: 'Account',
      owner: 'Owner',
      type: 'Type',
      name: 'Name',
      tunnel_type: 'Access type',
      local_port: 'Local port',
      status: 'Status',
      database: 'Database',
      host: 'Project ID',
      instance_id: 'Instance ID',
      ssh_host: 'SSH Hostname',
      ssh_username: 'SSH User name',
      ssh_port: 'SSH Port',
    },
  },
  GoogleCloudPostgresDatabaseConnection: {
    labels: {
      account: 'Account',
      owner: 'Owner',
      type: 'Type',
      name: 'Name',
      tunnel_type: 'Access type',
      local_port: 'Local port',
      host: 'Hostname',
      port: 'Port',
      username: 'User name',
      password: 'Password',
      database: 'Database',
      status: 'Status',
      ssh_host: 'SSH Hostname',
      ssh_username: 'SSH User name',
      ssh_port: 'SSH Port',
    },
  },
  FacebookAdsInsightsConnection: {
    labels: {
      password: 'Token',
      expires_at: 'Expires at',
      expires: 'Expires',
      account: 'Account',
      owner: 'Owner',
      type: 'Type',
      username: 'Authorizing user',
      name: 'Name',
      tunnel_type: 'Access type',
      local_port: 'Local port',
      status: 'Status',
    },
  },
  IntercomConnection: {
    labels: {
      password: 'Token',
      expires_at: 'Expires at',
      expires: 'Expires',
      account: 'Account',
      owner: 'Owner',
      type: 'Type',
      username: 'Authorizing user',
      name: 'Name',
      tunnel_type: 'Access type',
      local_port: 'Local port',
      status: 'Status',
      ssh_host: 'SSH Hostname',
      ssh_username: 'SSH User name',
      ssh_port: 'SSH Port',
    },
  },
  OracleDatabaseConnection: {
    labels: {
      ssl: 'Ssl',
      region: 'Region',
      account: 'Account',
      owner: 'Owner',
      type: 'Type',
      name: 'Name',
      tunnel_type: 'Access type',
      local_port: 'Local port',
      host: 'Hostname',
      port: 'Port',
      username: 'User name',
      password: 'Password',
      database: 'Database',
      status: 'Status',
      ssh_host: 'SSH Hostname',
      ssh_username: 'SSH User name',
      ssh_port: 'SSH Port',
    },
  },
  PipedriveConnection: {
    labels: {
      password: 'Token',
      expires_at: 'Expires at',
      expires: 'Expires',
      account: 'Account',
      owner: 'Owner',
      type: 'Type',
      username: 'Authorizing user',
      name: 'Name',
      tunnel_type: 'Access type',
      local_port: 'Local port',
      status: 'Status',
      ssh_host: 'SSH Hostname',
      ssh_username: 'SSH User name',
      ssh_port: 'SSH Port',
    },
  },
  XeroConnection: {
    labels: {
      password: 'Token',
      expires_at: 'Expires at',
      expires: 'Expires',
      account: 'Account',
      owner: 'Owner',
      type: 'Type',
      username: 'Authorizing user',
      name: 'Name',
      tunnel_type: 'Access type',
      local_port: 'Local port',
      status: 'Status',
      ssh_host: 'SSH Hostname',
      ssh_username: 'SSH User name',
      ssh_port: 'SSH Port',
    },
  },
  YouTubeConnection: {
    labels: {
      password: 'Token',
      expires_at: 'Expires at',
      expires: 'Expires',
      account: 'Account',
      owner: 'Owner',
      type: 'Type',
      username: 'Authorizing user',
      name: 'Name',
      tunnel_type: 'Access type',
      local_port: 'Local port',
      status: 'Status',
      ssh_host: 'SSH Hostname',
      ssh_username: 'SSH User name',
      ssh_port: 'SSH Port',
    },
  },
  GoogleSheetsConnection: {
    labels: {
      password: 'Token',
      expires_at: 'Expires at',
      expires: 'Expires',
      account: 'Account',
      owner: 'Owner',
      type: 'Type',
      username: 'Authorizing user',
      name: 'Name',
      tunnel_type: 'Access type',
      local_port: 'Local port',
      status: 'Status',
      ssh_host: 'SSH Hostname',
      ssh_username: 'SSH User name',
      ssh_port: 'SSH Port',
    },
  },
  GoogleDriveConnection: {
    labels: {
      password: 'Token',
      expires_at: 'Expires at',
      expires: 'Expires',
      account: 'Account',
      owner: 'Owner',
      type: 'Type',
      username: 'Authorizing user',
      name: 'Name',
      tunnel_type: 'Access type',
      local_port: 'Local port',
      status: 'Status',
      ssh_host: 'SSH Hostname',
      ssh_username: 'SSH User name',
      ssh_port: 'SSH Port',
    },
  },
  InstagramConnection: {
    labels: {
      password: 'Token',
      expires_at: 'Expires at',
      expires: 'Expires',
      account: 'Account',
      owner: 'Owner',
      type: 'Type',
      username: 'Authorizing user',
      name: 'Name',
      tunnel_type: 'Access type',
      local_port: 'Local port',
      status: 'Status',
      ssh_host: 'SSH Hostname',
      ssh_username: 'SSH User name',
      ssh_port: 'SSH Port',
    },
  },
  ShopifyConnection: {
    labels: {
      password: 'Token',
      expires_at: 'Expires at',
      expires: 'Expires',
      account: 'Account',
      owner: 'Owner',
      type: 'Type',
      username: 'Authorizing user',
      name: 'Name',
      tunnel_type: 'Access type',
      local_port: 'Local port',
      status: 'Status',
      shop: 'Store address',
      ssh_host: 'SSH Hostname',
      ssh_username: 'SSH User name',
      ssh_port: 'SSH Port',
    },
  },
  AthenaDatabaseConnection: {
    labels: {
      name: 'Name',
      region: 'Region',
      s3_staging_dir: 'S3 Staging Directory',
      username: 'Access key ID',
      password: 'Secret access key',
    },
  },
  'Xplenty::JobAuthoring::Components::Component': {
    labels: {
      id: 'ID',
      xy: 'Xy',
      name: 'Name',
    },
  },
  'Xplenty::JobAuthoring::Components::SnowflakeDestinationComponent': {
    labels: {
      table_name: 'table name',
    },
  },
  'Xplenty::JobAuthoring::Components::SpannerDestinationComponent': {
    labels: {
      table_name: 'table name',
    },
  },
  'Xplenty::JobAuthoring::Components::AdwordsSourceComponent': {
    labels: {
      id: 'ID',
      xy: 'Xy',
      name: 'Name',
      alias: 'Name',
      cloud_storage_connection_id: 'AdWords connection',
      customer_ids: 'Customer ids',
      customer_id_field_alias: 'Customer id field alias',
      schema: 'Fields',
      cloud_storage_connection: 'Cloud storage connection',
      report_date_range_type: 'Report date range type',
      report_date_range_min: 'Report date range min',
      report_date_range_max: 'Report date range max',
      api_version: 'Api version',
    },
  },
  'Xplenty::JobAuthoring::Components::FacebookAdsInsightsSourceComponent': {
    labels: {
      report_date_range_type: 'Report date range type',
      report_date_range_min: 'Report date range min',
      report_date_range_max: 'Report date range max',
    },
  },
  'Xplenty::JobAuthoring::Components::AggregateComponent': {
    labels: {
      id: 'ID',
      xy: 'Xy',
      name: 'Name',
      alias: 'Name',
      input_alias: 'Input alias',
      aggregated_fields: 'Aggregated fields',
      grouped_fields: 'Group by',
      parallel: 'Parallel',
    },
  },
  'Xplenty::JobAuthoring::Components::DatabaseDestinationComponentBase': {
    labels: {
      id: 'ID',
      xy: 'Xy',
      name: 'Name',
      alias: 'Alias',
      input_alias: 'Input alias',
      database_connection_id: 'Database connection',
      table_name: 'Table name',
      column_mappings: 'Column mappings',
      database_connection: 'Database connection',
      operation_type: 'Operation type',
    },
  },
  'Xplenty::JobAuthoring::Components::AmazonRedshiftDestinationComponent': {
    labels: {
      id: 'ID',
      xy: 'Xy',
      name: 'Name',
      alias: 'Alias',
      input_alias: 'Input alias',
      database_connection_id: 'Database connection',
      table_name: 'Table name',
      column_mappings: 'Column mappings',
      database_connection: 'Database connection',
      operation_type: 'Operation type',
      max_errors: 'Max errors',
      replacement_char: 'Replacement character',
      comp_rows: 'compression sample size value',
      comp_update: 'Compression',
      intermediate_compression_type: 'Intermediate compression type',
    },
  },
  'Xplenty::JobAuthoring::Components::DatabaseSourceComponentBase': {
    labels: {
      id: 'ID',
      xy: 'Xy',
      name: 'Name',
      alias: 'Alias',
      database_connection_id: 'Database connection',
      table_name: 'Table name',
      query: 'Query',
      schema: 'Schema',
      database_connection: 'Database connection',
    },
  },
  'Xplenty::JobAuthoring::Components::AmazonRedshiftSourceComponent': {
    labels: {
      id: 'ID',
      xy: 'Xy',
      name: 'Name',
      alias: 'Alias',
      database_connection_id: 'Database connection',
      table_name: 'Table name',
      query: 'Query',
      schema: 'Schema',
      database_connection: 'Database connection',
    },
  },
  'Xplenty::JobAuthoring::Components::AnalyticsSourceComponent': {
    labels: {
      id: 'ID',
      xy: 'Xy',
      name: 'Name',
      alias: 'Alias',
      cloud_storage_connection_id: 'Cloud storage connection',
      profile_ids: 'Profile ids',
      profile_id_field_alias: 'Profile id field alias',
      account_id_field_alias: 'Account id field alias',
      account_name_field_alias: 'Account name field alias',
      property_name_field_alias: 'Property name field alias',
      profile_name_field_alias: 'Profile name field alias',
      schema: 'Schema',
      cloud_storage_connection: 'Cloud storage connection',
      report_date_range_type: 'Report date range type',
      report_date_range_min: 'Report date range min',
      report_date_range_max: 'Report date range max',
    },
  },
  'Xplenty::JobAuthoring::Components::AssertComponent': {
    labels: {
      id: 'ID',
      xy: 'Xy',
      name: 'Name',
      alias: 'Name',
      input_alias: 'Input alias',
      predicates: 'Conditions',
      message: 'Assertion message',
    },
  },

  'Xplenty::JobAuthoring::Components::SpannerSourceComponent': {
    labels: {
      id: 'ID',
      xy: 'Xy',
      name: 'Name',
      alias: 'Alias',
      input_alias: 'Input alias',
      database_connection_id: 'Database connection',
      table_name: 'Table name',
      query: 'Query',
      column_mappings: 'Column mappings',
      database_connection: 'Database connection',
      operation_type: 'Operation type',
      max_bad_records: 'Max bad records',
    },
  },

  'Xplenty::JobAuthoring::Components::NetSuiteSourceComponent': {
    labels: {
      id: 'ID',
      xy: 'Xy',
      name: 'Name',
      alias: 'Alias',
      input_alias: 'Input alias',
      database_connection_id: 'Database connection',
      table_name: 'Table name',
      column_mappings: 'Column mappings',
      database_connection: 'Database connection',
      operation_type: 'Operation type',
      max_bad_records: 'Max bad records',
    },
  },

  'Xplenty::JobAuthoring::Components::BigQueryDestinationComponent': {
    labels: {
      id: 'ID',
      xy: 'Xy',
      name: 'Name',
      alias: 'Alias',
      input_alias: 'Input alias',
      database_connection_id: 'Database connection',
      table_name: 'Table name',
      column_mappings: 'Column mappings',
      database_connection: 'Database connection',
      operation_type: 'Operation type',
      max_bad_records: 'Max bad records',
    },
  },
  'Xplenty::JobAuthoring::Components::BigQuerySourceComponent': {
    labels: {
      id: 'ID',
      xy: 'Xy',
      name: 'Name',
      alias: 'Alias',
      database_connection_id: 'Database connection',
      table_name: 'Table name',
      query: 'Query',
      schema: 'Schema',
      database_connection: 'Database connection',
    },
  },
  'Xplenty::JobAuthoring::Components::BingAdsSourceComponent': {
    labels: {
      id: 'ID',
      xy: 'Xy',
      name: 'Name',
      alias: 'Alias',
      cloud_storage_connection_id: 'Cloud storage connection',
      accounts_campaigns: 'Accounts campaigns',
      schema: 'Schema',
      report_type: 'Report type',
      report_aggregation_type: 'Report aggregation type',
      time_period_date_field_alias: 'Time period date field alias',
      time_period_hour_field_alias: 'Time period hour field alias',
      cloud_storage_connection: 'Cloud storage connection',
      report_date_range_type: 'Report date range type',
      report_date_range_min: 'Report date range min',
      report_date_range_max: 'Report date range max',
    },
  },
  'Xplenty::JobAuthoring::Components::CloneComponent': {
    labels: {
      id: 'ID',
      xy: 'Xy',
      name: 'Name',
      alias: 'Name',
      input_alias: 'Input alias',
    },
  },
  'Xplenty::JobAuthoring::Components::FileDestinationComponent': {
    labels: {
      id: 'ID',
      xy: 'Xy',
      name: 'Name',
      alias: 'Alias',
      input_alias: 'Input alias',
      path: 'Path',
      destination_type: 'Destination type',
      compression_type: 'Compression type',
    },
  },
  'Xplenty::JobAuthoring::Components::CloudStorageDestinationComponent': {
    labels: {
      id: 'ID',
      xy: 'Xy',
      name: 'Name',
      alias: 'Alias',
      input_alias: 'Input alias',
      path: 'Path',
      destination_type: 'Destination type',
      compression_type: 'Compression type',
      bucket: 'Bucket',
      cloud_storage_connection_id: 'Cloud storage connection',
      cloud_storage_connection: 'Cloud storage connection',
    },
  },
  'Xplenty::JobAuthoring::Components::SourceComponent': {
    labels: {
      id: 'ID',
      xy: 'Xy',
      name: 'Name',
      alias: 'Alias',
      path: 'Path',
      schema: 'Fields',
      before_action: 'Before action',
      record_type: 'Record type',
      record_delimiter: 'Record delimiter',
      record_settings: 'Record settings',
    },
  },
  'Xplenty::JobAuthoring::Components::CloudStorageSourceComponent': {
    labels: {
      id: 'ID',
      xy: 'Xy',
      name: 'Name',
      alias: 'Name',
      path: 'Path',
      schema: 'Fields',
      before_action: 'Before action',
      record_type: 'Record type',
      record_delimiter: 'Record delimiter',
      record_settings: 'Record settings',
      bucket: 'Bucket name',
      cloud_storage_connection_id: 'Cloud storage connection',
      cloud_storage_connection: 'Cloud storage connection',
    },
  },
  'Xplenty::JobAuthoring::Components::CrossJoinComponent': {
    labels: {
      id: 'ID',
      xy: 'Xy',
      name: 'Name',
      alias: 'Alias',
      left_input_alias: 'Left input alias',
      right_input_alias: 'Right input alias',
      parallel: 'Parallel',
    },
  },
  'Xplenty::JobAuthoring::Components::CubeComponent': {
    labels: {
      id: 'ID',
      xy: 'Xy',
      name: 'Name',
      alias: 'Alias',
      input_alias: 'Input alias',
      aggregated_fields: 'Aggregated fields',
      grouped_fields: 'Grouped fields',
      parallel: 'Parallel',
    },
  },
  'Xplenty::JobAuthoring::Components::DatabaseDestinationComponent': {
    labels: {
      id: 'ID',
      xy: 'Xy',
      name: 'Name',
      alias: 'Alias',
      input_alias: 'Input alias',
      database_connection_id: 'Database connection',
      table_name: 'Table name',
      query: 'Query',
      column_mappings: 'Column mappings',
      database_connection: 'Database connection',
      operation_type: 'Operation type',
      batch_size: 'Batch size',
      parallel: 'Parallel',
    },
  },
  'Xplenty::JobAuthoring::Components::DatabaseSourceComponent': {
    labels: {
      id: 'ID',
      xy: 'Xy',
      name: 'Name',
      alias: 'Name',
      database_connection_id: 'Database connection',
      table_name: 'Table name',
      query: 'Query',
      schema: 'Schema',
      database_connection: 'Database connection',
      parallel: 'Max connections',
    },
  },
  'Xplenty::JobAuthoring::Components::DistinctComponent': {
    labels: {
      id: 'ID',
      xy: 'Xy',
      name: 'Name',
      alias: 'Name',
      input_alias: 'Input alias',
      parallel: 'Parallel',
    },
  },
  'Xplenty::JobAuthoring::Components::FilterComponent': {
    labels: {
      id: 'ID',
      xy: 'Xy',
      name: 'Name',
      alias: 'Name',
      input_alias: 'Input alias',
      predicates: 'Conditions',
    },
  },
  'Xplenty::JobAuthoring::Components::JoinComponent': {
    labels: {
      id: 'ID',
      xy: 'Xy',
      name: 'Name',
      alias: 'Alias',
      join_type: 'Join type',
      relations: 'Left or right',
      parallel: 'Parallel',
      optimization_type: 'Optimization type',
    },
  },
  'Xplenty::JobAuthoring::Components::WorkflowComponent': {
    labels: {
      id: 'ID',
      xy: 'Xy',
      name: 'Name',
      alias: 'Alias',
      operator: 'Operator',
    },
  },
  'Xplenty::JobAuthoring::Components::KillWorkflowComponent': {
    labels: {
      id: 'ID',
      xy: 'Xy',
      name: 'Name',
      alias: 'Alias',
      operator: 'Operator',
    },
  },
  'Xplenty::JobAuthoring::Components::LimitComponent': {
    labels: {
      id: 'ID',
      xy: 'Xy',
      name: 'Name',
      alias: 'Name',
      input_alias: 'Input alias',
      n: 'Limit',
      partitioned_fields: 'Partitioned fields',
      ordered_fields: 'Ordered fields',
      parallel: 'Parallel',
    },
  },
  'Xplenty::JobAuthoring::Components::MongoDestinationComponent': {
    labels: {
      id: 'ID',
      xy: 'Xy',
      name: 'Name',
      alias: 'Alias',
      input_alias: 'Input alias',
      database_connection_id: 'Database connection',
      table_name: 'Collection name',
      column_mappings: 'Column mappings',
      database_connection: 'Database connection',
      operation_type: 'Operation type',
    },
  },
  'Xplenty::JobAuthoring::Components::MongoSourceComponent': {
    labels: {
      id: 'ID',
      xy: 'Xy',
      name: 'Name',
      alias: 'Alias',
      database_connection_id: 'Database connection',
      table_name: 'Source Collection',
      schema: 'Schema',
      database_connection: 'Database connection',
    },
  },
  'Xplenty::JobAuthoring::Components::RankComponent': {
    labels: {
      id: 'ID',
      xy: 'Xy',
      name: 'Name',
      alias: 'Alias',
      input_alias: 'Input alias',
      field_alias: 'Field alias',
      fields: 'Fields',
      dense: 'Dense',
    },
  },
  'Xplenty::JobAuthoring::Components::RestApiSourceComponent': {
    labels: {
      id: 'ID',
      xy: 'Xy',
      name: 'Name',
      alias: 'Alias',
      url: 'Url',
      method: 'Method',
      response_type: 'Response type',
      schema: 'Schema',
    },
  },
  'Xplenty::JobAuthoring::Components::RunPackageComponent': {
    labels: {
      id: 'ID',
      xy: 'Xy',
      name: 'Name',
      alias: 'Alias',
      operator: 'Operator',
      package_id: 'Package',
      account: 'Account',
      package: 'Package',
    },
  },
  'Xplenty::JobAuthoring::Components::SalesforceSourceComponent': {
    labels: {
      id: 'ID',
      xy: 'Xy',
      name: 'Name',
      alias: 'Alias',
      cloud_storage_connection_id: 'Cloud storage connection',
      object_name: 'Object name',
      schema: 'Schema',
      cloud_storage_connection: 'Cloud storage connection',
      query: 'Query',
    },
  },
  'Xplenty::JobAuthoring::Components::SalesforceDestinationComponent': {
    labels: {
      object_name: 'Object name',
      query: 'Query',
      id_field: 'Upsert key',
    },
  },
  'Xplenty::JobAuthoring::Components::NetsuiteDestinationComponent': {
    labels: {
      id: 'ID',
      xy: 'Xy',
      name: 'Name',
      alias: 'Alias',
      input_alias: 'Input alias',
      id_field: 'ID field',
      cloud_storage_connection_id: 'Cloud storage connection',
      object_name: 'Object name',
      column_mappings: 'Column mappings',
      cloud_storage_connection: 'Cloud storage connection',
      operation_type: 'Operation type',
      max_errors: 'Max bad records',
    },
  },
  'Xplenty::JobAuthoring::Components::SampleComponent': {
    labels: {
      id: 'ID',
      xy: 'Xy',
      name: 'Name',
      alias: 'Alias',
      input_alias: 'Input alias',
      percentage: 'Percentage',
    },
  },
  'Xplenty::JobAuthoring::Components::SelectComponent': {
    labels: {
      id: 'ID',
      xy: 'Xy',
      name: 'Name',
      alias: 'Alias',
      input_alias: 'Input alias',
      fields: 'Fields',
    },
  },
  'Xplenty::JobAuthoring::Components::SortComponent': {
    labels: {
      id: 'ID',
      xy: 'Xy',
      name: 'Name',
      alias: 'Name',
      input_alias: 'Input alias',
      fields: 'Fields',
      parallel: 'Parallel',
    },
  },
  'Xplenty::JobAuthoring::Components::SplitComponent': {
    labels: {
      id: 'ID',
      xy: 'Xy',
      name: 'Name',
      input_alias: 'Input alias',
      relations: 'Relations',
      otherwise_alias: 'Otherwise',
    },
  },
  'Xplenty::JobAuthoring::Components::StartWorkflowComponent': {
    labels: {
      id: 'ID',
      xy: 'Xy',
      name: 'Name',
      alias: 'Alias',
      operator: 'Operator',
    },
  },
  'Xplenty::JobAuthoring::Components::StickyNoteComponent': {
    labels: {
      id: 'ID',
      xy: 'Xy',
      name: 'Name',
      description: 'Description',
    },
  },
  'Xplenty::JobAuthoring::Components::UnionComponent': {
    labels: {
      id: 'ID',
      xy: 'Xy',
      name: 'Name',
      alias: 'Alias',
      left_input_alias: 'Left input alias',
      right_input_alias: 'Right input alias',
      fields: 'Fields',
    },
  },
  'Xplenty::JobAuthoring::Components::WindowComponent': {
    labels: {
      id: 'ID',
      xy: 'Xy',
      name: 'Name',
      alias: 'Alias',
      input_alias: 'Input alias',
      partitioned_fields: 'Partitioned fields',
      ordered_fields: 'Ordered fields',
      windowed_fields: 'Windowed fields',
      parallel: 'Parallel',
    },
  },
  ExecuteSqlComponent: {
    labels: {
      query: 'Query',
    },
  },
  UserPasswordChange: {
    labels: {
      current_password: 'Current password',
      new_password: 'New password',
      password: 'New password',
      password_confirm: 'Confirm new password',
    },
  },
  errors: {
    messages: {
      user: {
        registrations: {
          signup: {
            already_exist: 'User with this email already exists',
          }
        }
      }
    },
    common: {
      required: 'Please fill in { fieldName }.',
    },
    email: {
      wrong_format: 'Please fill in a valid email address.',
    },
    auth: {
      wrong_email_or_password: 'Invalid credentials.',
    },
    LengthValidator: {
      maximum: "Sorry, { fieldName } must be no more than { maximum } characters long.",
      minimum: "Sorry, { fieldName } must be at least { minimum } and no more than { maximum } characters long.",
      minimum_and_maximum: "Sorry, { fieldName } must be at least { minimum } characters long.",
      is: "Sorry, { fieldName } must be { is } characters long.",
    },
    MaxLengthValidator:
      "Sorry, that's a bit too long! { fieldName } must be no more than { maximum } characters long.",
    MinLengthValidator:
      "Sorry, that's a bit too short! { fieldName } must be at least { minimum } characters long.",
    PresenceValidator: 'Please fill in { fieldName }.',
    FormatValidator: 'Please fill in a valid { fieldName }.',
    ExclusionValidator: "Sorry, you can't use that value. Please try another one.",
    AbsenceValidator: 'Please leave out { fieldName }.',
    NumericalityValidator: "Sorry, that's not a valid { fieldName }.",
    InclusionValidator: "Sorry, that's not an acceptable value.",
    UniquenessValidator: '"{ value }" is already taken.',
    MatchValidator: '{ fieldName } does not match.',
    KeywordsValidator: 'Field name contains illegal keyword or characters.',
    UniqueComponentNameValidator: 'Component name must be unique.',
  },
  response: {
    '400': {
      title: 'Bad request',
      message: 'Oops, something went wrong.',
    },
    '401': {
      title: 'Access denied',
      message: "Seems like you don't have the required permissions to access this page.",
    },
    '402': {
      title: 'Payment required',
      message: 'You must confirm your billing info to use this API.',
    },
    '403': {
      title: 'Forbidden',
      message: 'Sorry, you are not allowed to perform this action.',
    },
    '404': {
      title: 'Page not found',
      message: 'This is probably not the place you were looking for.',
      resource_not_found_message: 'The requested resource was not found.',
      resource_not_found_message_exact: 'The requested {item} with id: {id} was not found.',
      resources_not_found_message_exact: 'An error occurred while loading {item}s.',
    },
    '406': {
      title: 'Error',
      message: 'Sorry, we were unable to perform this action.',
    },
    '415': {
      title: 'Error',
      message: 'Sorry, we were unable to perform this action.',
    },
    '422': {
      title: 'Error',
      message: 'Sorry, we were unable to perform this action.',
      message_wrong_flow_type:
        'Import is invalid. Unable to import dataflow package JSON to a workflow, or vice versa.',
      invalid_json_message: 'Sorry, the input is not a valid JSON.',
    },
    '429': {
      title: 'Too many requests',
      message: 'Oops, the request exceeded the rate limitations. Try again in a few minutes.',
    },
    '500': {
      title: 'Internal server error',
      message: 'Oops, an internal error occurred in the request. Try again in a few minutes.',
    },
    '502': {
      title: 'Bad gateway',
      message: 'Oops, seems like the Prepforce by Integrate.io servers are up, but overloaded with requests. Try again later.',
    },
    '503': {
      title: 'Service unavailable',
      message: 'Oops, seems like the Prepforce by Integrate.io servers are up, but overloaded with requests. Try again later.',
    },
    timeout: {
      title: 'Timeout',
      message: 'Timeout was reached',
    },
  },
  generic: {
    labels: {
      optional: '(optional)',
      note: 'Note:',
    },
    tooltips: {
      'click-to-copy': 'Click to copy',
    },
    welcome: {
      title: 'Welcome to Prepforce by Integrate.io!',
      message: 'Prepforce requires minimal setup with one of our solution engineers.',
      reschedule:
        "If you would rather reschedule, setup a time <a href='https://app.xplenty.com/help/schedule?email={ email }' target='_blank'>here</a>.",
      started: {
        title: 'Alright 👍',
        message:
          '<p><b>Ben</b>, our solution engineer, will be with you shortly.</p><p>In the meantime, feel free to poke around the app.</p>',
      },
      buttons: {
        yes: "Alright, let's start now",
        no: 'Or, schedule a setup session',
      },
    },
  },
  units: {
    minutes: 'minutes',
    hours: 'hours',
    days: 'days',
    weeks: 'weeks',
    months: 'months',
  },
  presets: {
    daily: 'Every day at 8 AM',
    weekly: 'Every Monday at 8 AM',
    monthly: 'Every first of the month at 8 AM',
    weekdaily: 'Every weekday at 8 AM',
  },
  'password-strength': {
    'pwd-very-weak': 'Very weak',
    'pwd-weak': 'Weak',
    'pwd-better': 'Getting better',
    'pwd-good': 'Good',
    'pwd-strong': 'Strong',
  },
  app: {
    lead: 'Welcome!',
    actions: {
      sign_out: 'Sign out',
      new_account: 'New account',
    },
    controller: {
      modals: {
        shortcuts: {
          actions: {
            title: 'Keyboard shortcuts',
            close: 'Close',
          },
        },
      },
    },
    router: {
      titles: {
        app: 'Welcome!',
        app_auth: '',
        app_auth_signin: 'Sign in',
        app_auth_signup: 'Sign up',
        app_auth_forgot: 'Password reset',
        app_auth_reset: 'Password reset',
        app_auth_thankyou: 'Thank you for signing up',
        app_auth_invitation: 'Invitation',
        app_account: '',
        app_account_dashboard: 'Dashboard',
        app_account_connections: 'Connections',
        app_account_connections_new: 'New connection',
        app_account_connections_item: 'Connection',
        app_account_connections_type_item: 'Connection',
        app_account_connections_type_new: 'New connection',
        app_account_connections_type_edit: 'Edit connection',
        app_account_packages: 'Packages',
        app_account_workspaces: 'Workspace',
        app_account_packages_new: 'New package',
        app_account_packages_item: 'Package',
        app_account_clusters: 'Clusters',
        app_account_clusters_new: 'New cluster',
        app_account_clusters_item: 'Cluster',
        app_account_clusters_item_edit: 'Edit cluster',
        app_account_deliveries: 'Deliveries',
        app_account_deliveries_new: 'New delivery',
        app_account_jobs: 'Jobs',
        app_account_jobs_new: 'Run job',
        app_account_jobs_item: 'Job',
        app_account_jobs_item_general: 'Job',
        app_account_jobs_item_outputs: 'Job outputs',
        app_account_jobs_item_variables: 'Job variables',
        app_account_jobs_item_progress: 'Job progress',
        app_account_jobs_item_errors: 'Job errors',
        app_account_jobs_item_tasks: 'Job tasks',
        app_account_schedules: 'Schedules',
        app_account_schedules_new: 'New schedule',
        app_account_schedules_item: 'Schedule',
        app_account_schedules_item_edit: 'Edit schedule',
        app_account_console: 'Console',
        app_account_settings: 'Settings',
        app_account_settings_account: 'Settings',
        app_account_settings_account_info: 'Profile',
        app_account_settings_account_delete: 'Close account',
        app_account_settings_account_plans: 'Billing',
        app_account_settings_account_members: 'Members',
        app_account_settings_account_members_new: 'Invite member',
        app_account_settings_account_hooks: 'Service hooks',
        app_account_settings_account_hooks_new: 'New service hook',
        app_account_settings_account_hooks_type: 'Service hooks',
        app_account_settings_account_hooks_type_new: 'New service hook',
        app_account_settings_account_hooks_type_edit: 'Edit service hook',
        app_account_settings_account_usage: 'Account usage',
        app_account_settings_my: 'Your settings',
        app_account_settings_my_info: 'Profile',
        app_account_settings_my_password: 'Password',
        app_account_settings_my_notifications: 'Notifications',
        app_account_settings_my_keys: 'SSH Public Keys',
        app_account_settings_my_keys_list: 'SSH Public Keys',
        app_account_settings_my_keys_new: 'New SSH Public Key',
        app_account_settings_my_accounts: 'Accounts',
        app_account_settings_my_accounts_list: 'Accounts',
        app_account_settings_my_accounts_new: 'New account',
        app_account_settings_my_accounts_leave: 'Leave account',
        app_account_settings_my_language: 'Language',
        app_account_settings_developer_tokens: 'Access tokens',
        '401': 'Access denied',
        '404': 'Page not found',
        '500': 'Internal server error',
        '503': 'Service unavailable',
        app_welcome: 'Welcome!',
      },
    },
  },
  regions: {
    'gcloud::europe-west1': {
      text: 'Google Cloud - Western Europe',
      short: 'Western Europe',
      group: 'Google Cloud',
    },
    'gcloud::us-east1': {
      text: 'Google Cloud - Eastern US',
      short: 'Eastern US',
      group: 'Google Cloud',
    },
    'gcloud::us-central1': {
      text: 'Google Cloud - Central US',
      short: 'Central US',
      group: 'Google Cloud',
    },
    'gcloud::us-central2': {
      text: 'Google Cloud - Central US 2',
      short: 'Central US 2',
      group: 'Google Cloud',
    },
    'gcloud::asia-east1': {
      text: 'Google Cloud - East Asia',
      short: 'East Asia',
      group: 'Google Cloud',
    },
    'gcloud::asia-northeast1': {
      text: 'Google Cloud - Tokyo',
      short: 'Tokyo',
      group: 'Google Cloud',
    },
    'mellanox::il': {
      text: 'Mellanox - Israel',
      short: 'Israel',
      group: 'Mellanox Cloud',
    },
    'att::iad1': {
      text: 'AT&T - Ashburn IDC',
      short: 'Ashburn IDC',
      group: 'AT&T Silver Lining',
    },
    'att::dpa1': {
      text: 'AT&T - Lisle (DPA1)',
      short: 'Lisle (DPA1)',
      group: 'AT&T Silver Lining',
    },
    'att::sql1': {
      text: 'AT&T - Redwood City IDC',
      short: 'Redwood City IDC',
      group: 'AT&T Silver Lining',
    },
    'att::horizon': {
      text: 'AT&T - US (Horizon)',
      short: 'US (Horizon)',
      group: 'AT&T Cloud',
    },
    'rackspace::dfw': {
      text: 'Rackspace - Dallas (DFW)',
      short: 'Dallas (DFW)',
      group: 'Rackspace Cloud Servers',
    },
    'rackspace::ord': {
      text: 'Rackspace - Chicago (ORD)',
      short: 'Chicago (ORD)',
      group: 'Rackspace Cloud Servers',
    },
    'rackspace::iad': {
      text: 'Rackspace - Northern Virginia (IAD)',
      short: 'Northern Virginia (IAD)',
      group: 'Rackspace Cloud Servers',
    },
    'rackspace::lon': {
      text: 'Rackspace - London (LON)',
      short: 'London (LON)',
      group: 'Rackspace Cloud Servers',
    },
    'rackspace::syd': {
      text: 'Rackspace - Sydney (SYD)',
      short: 'Sydney (SYD)',
      group: 'Rackspace Cloud Servers',
    },
    'rackspace::hkg': {
      text: 'Rackspace - Hong Kong (HKG)',
      short: 'Hong Kong (HKG)',
      group: 'Rackspace Cloud Servers',
    },
    'rackspace-performance::dfw': {
      text: 'Rackspace (Performance) - Dallas (DFW)',
      short: 'Dallas (Performance DFW)',
      group: 'Rackspace Cloud Servers (Performance)',
    },
    'amazon-web-services::us-east-1': {
      text: 'AWS - US East (N. Virginia)',
      short: 'US East (Northern Virginia)',
      group: 'Amazon Web Services',
    },
    'amazon-web-services::us-east-2': {
      text: 'AWS - US East (Ohio)',
      short: 'US East (Ohio)',
      group: 'Amazon Web Services',
    },
    'amazon-web-services::us-east-1::m3xlarge': {
      text: 'AWS (Performance) - US East (N. Virginia)',
      short: 'US East (Performance Northern Virginia)',
      group: 'Amazon Web Services (Performance)',
    },
    'amazon-web-services::us-west-1': {
      text: 'AWS - US West (N. California)',
      short: 'US West (Northern California)',
      group: 'Amazon Web Services',
    },
    'amazon-web-services::us-west-2': {
      text: 'AWS - US West (Oregon)',
      short: 'US West (Oregon)',
      group: 'Amazon Web Services',
    },
    'amazon-web-services::eu-west-1': {
      text: 'AWS - EU (Ireland)',
      short: 'EU (Ireland)',
      group: 'Amazon Web Services',
    },
    'amazon-web-services::eu-central-1': {
      text: 'AWS - EU (Frankfurt)',
      short: 'EU (Frankfurt)',
      group: 'Amazon Web Services',
    },
    'amazon-web-services::ap-south-1': {
      text: 'AWS - Asia Pacific (Mumbai)',
      short: 'Asia Pacific (Mumbai)',
      group: 'Amazon Web Services',
    },
    'amazon-web-services::ap-southeast-1': {
      text: 'AWS - Asia Pacific (Singapore)',
      short: 'Asia Pacific (Singapore)',
      group: 'Amazon Web Services',
    },
    'amazon-web-services::ap-southeast-2': {
      text: 'AWS - Asia Pacific (Sydney)',
      short: 'Asia Pacific (Sydney)',
      group: 'Amazon Web Services',
    },
    'amazon-web-services::ap-northeast-1': {
      text: 'AWS - Asia Pacific (Tokyo)',
      short: 'Asia Pacific (Tokyo)',
      group: 'Amazon Web Services',
    },
    'amazon-web-services::ap-northeast-2': {
      text: 'AWS - Asia Pacific (Seoul)',
      short: 'Asia Pacific (Seoul)',
      group: 'Amazon Web Services',
    },
    'amazon-web-services::sa-east-1': {
      text: 'AWS - South America (São Paulo)',
      short: 'South America (São Paulo)',
      group: 'Amazon Web Services',
    },
    'soft-layer::dal05': {
      text: 'SoftLayer - Dallas 5 (DAL05)',
      short: 'Dallas 5 (DAL05)',
      group: 'SoftLayer CloudLayer',
    },
    'soft-layer::ams01': {
      text: 'SoftLayer - Amsterdam 1 (AMS01)',
      short: 'Amsterdam 1 (AMS01)',
      group: 'SoftLayer CloudLayer',
    },
    'soft-layer::sng01': {
      text: 'SoftLayer - Singapore 1 (SNG01)',
      short: 'Singapore 1 (SNG01)',
      group: 'SoftLayer CloudLayer',
    },
    'xplenty::us1': {
      text: 'ETL & Reverse ETL - US 1',
      short: 'US 1',
      group: 'ETL & Reverse ETL',
    },
    'xplenty::us2': {
      text: 'ETL & Reverse ETL - US 2',
      short: 'US 2',
      group: 'ETL & Reverse ETL',
    },
    'xplenty::eu1': {
      text: 'ETL & Reverse ETL - EU 1',
      short: 'EU 1',
      group: 'ETL & Reverse ETL',
    },
    'xplenty::eu2': {
      text: 'ETL & Reverse ETL - EU 2',
      short: 'EU 2',
      group: 'ETL & Reverse ETL',
    },
    dublin: {
      text: 'Dublin, Ireland',
      short: 'Dublin, Ireland',
      group: 'Europe',
    },
    sydney: {
      text: 'Sydney, Australia',
      short: 'Sydney, Australia',
      group: 'Asia Pacific',
    },
    tokyo: {
      text: 'Tokyo, Japan',
      short: 'Tokyo, Japan',
      group: 'Asia Pacific',
    },
    oregon: {
      text: 'Oregon, United States',
      short: 'Oregon, United States',
      group: 'United States',
    },
    virginia: {
      text: 'Virginia, United States',
      short: 'Virginia, United States',
      group: 'United States',
    },
  },
  'help-menu': {
    labels: {
      live_support: 'Live support',
      documentation: 'Knowledge base',
      console: 'Prepforce by Integrate.io Console',
      status_page: 'View status page',
      keyboard_shortcuts: 'Keyboard shortcuts ...',
      schedule_setup_session: 'Schedule setup session',
    },
    live_support_message: '',
  },
  dashboard: {
    title: 'Dashboard',
  },
  'data-preview': {
    title: 'Get data preview',
    errors: {
      response_too_big: 'Response is too big (Over 5 MB). Data preview cannot be displayed',
    },
  },
  'confirmation-dialog': {
    title: 'Are you sure?',
    hint: 'This action is not reversible.',
    actions: {
      yes: 'Yes',
      no: 'No',
    },
  },
  'account-picker': {
    labels: {
      whos: 'Your accounts:',
      switch: 'Switch to <strong>{ name }</strong>',
    },
  },
  'packages-picker': {
    'list-comment':
      "All packages will be executed in parallel making use of the cluster's parallel processing capacity.",
    'edit-workspace': 'Only packages that do not belong to a workspace can be added.',
    'workspace-creation': 'You can also add packages later by editing the workspace after creation.',
    'add-package': 'Add package',
    form: {
      title: 'Choose a package and set variables',
      buttons: {
        cancel: 'Cancel',
        save: 'Save',
      },
    },
  },
  'base-editor': {
    tooltip: {
      'component-name-error': 'Component name invalid',
    },
    wizard: {
      steps: {
        connection: 'Connection',
        options: 'Options',
        definition: 'Definition',
        schema_fields: 'Schema',
        column_mapping: 'Column mapping',
      },
    },
    state: {
      connections: 'Connection',
      options: 'Definition',
      schema_fields: 'Fields',
    },
    form: {
      labels: {
        name_the_component: 'Name the component',
        what_next: 'What’s next?',
      },
    },
  },
  'component-editor': {
    'step-connection': {
      source: {
        closed: 'Input connection',
        active: 'Choose input connection',
      },
      destination: {
        closed: 'Target connection',
        active: 'Choose target connection',
      },
    },
    'step-editor': {
      cloud_storage_source_component: {
        closed: 'Source properties',
        active: 'Define your source location, format and action',
      },
      database_source_component: {
        closed: 'Source properties',
        active: 'Define your source table or query',
      },
      spanner_source_component: {
        closed: 'Source properties',
        active: 'Define your source table or query',
      },
      analytics_source_component: {
        closed: 'Source properties',
        active: 'Source properties',
      },
      analytics_ga4_source_component: {
        closed: 'Source properties',
        active: 'Source properties',
      },
      adwords_source_component: {
        closed: 'Source properties',
        active: 'Source properties',
      },
      big_query_source_component: {
        closed: 'Source properties',
        active: 'Define your source table or query',
      },
      amazon_redshift_source_component: {
        closed: 'Source properties',
        active: 'Define your source table or query',
      },
      mongo_source_component: {
        closed: 'Source properties',
        active: 'Define your source collection',
      },
      net_suite_source_component: {
        closed: 'Source properties',
        active: 'Define your source table',
      },
      bing_ads_source_component: {
        closed: 'Source properties',
        active: 'Source properties',
      },

      facebook_ads_insights_source_component: {
        closed: 'Source properties',
        active: 'Source properties',
      },
      salesforce_source_component: {
        closed: 'Source properties',
        active: 'Source properties',
      },
      cloud_storage_destination_component: {
        closed: 'Destination properties',
        active: 'Define your destination location, format and action',
      },
      union_component: {
        closed: 'Input fields mapping',
        active: 'Input fields mapping',
      },
      rest_api_source_component: {
        closed: 'Request and response',
        active: 'Configure request and response',
      },
      database_destination_component: {
        closed: 'Destination properties',
        active: 'Define your destination properties',
      },
      snowflake_destination_component: {
        closed: 'Destination properties',
        active: 'Define your destination properties',
      },
      rest_api_destination_component: {
        closed: 'Request & response configuration',
        active: 'Configure request & response',
      },
      amazon_redshift_destination_component: {
        closed: 'Destination properties',
        active: 'Define your destination properties',
      },
      big_query_destination_component: {
        closed: 'Destination properties',
        active: 'Define your destination properties',
      },
      spanner_destination_component: {
        closed: 'Destination properties',
        active: 'Define your destination properties',
      },
      mongo_destination_component: {
        closed: 'Destination properties',
        active: 'Define your destination properties',
      },
      salesforce_destination_component: {
        closed: 'Destination properties',
        active: 'Define your destination properties',
      },
      salesforce_soap_destination_component: {
        closed: 'Destination properties',
        active: 'Define your destination properties',
      },
      netsuite_soap_destination_component: {
        closed: 'Destination properties',
        active: 'Define your destination properties',
      },
      hubspot_destination_component: {
        closed: 'Destination properties',
        active: 'Define your destination properties',
      },
      google_ads_destination_component: {
        closed: 'Destination properties',
        active: 'Define your destination properties',
      },
      facebook_ads_destination_component: {
        closed: 'Destination properties',
        active: 'Define your destination properties',
      },
      tiktok_ads_destination_component: {
        closed: 'Destination properties',
        active: 'Define your destination properties',
      },
      join_component: {
        closed: 'Join properties',
        active: 'Configure Join properties',
      },
    },
    'step-schema': {
      cloud_storage_source_component: {
        closed: 'Schema',
        active: 'Select input fields',
      },
      database_source_component: {
        closed: 'Schema',
        active: 'Select input columns',
      },
      spanner_source_component: {
        closed: 'Schema',
        active: 'Select input columns',
      },
      analytics_source_component: {
        closed: 'Schema',
        active: 'Select input fields',
      },
      analytics_ga4_source_component: {
        closed: 'Schema',
        active: 'Select input fields',
      },
      adwords_source_component: {
        closed: 'Schema',
        active: 'Select input fields',
      },
      big_query_source_component: {
        closed: 'Schema',
        active: 'Select input columns',
      },
      amazon_redshift_source_component: {
        closed: 'Schema',
        active: 'Select input columns',
      },
      mongo_source_component: {
        closed: 'Schema',
        active: 'Select input columns',
      },
      net_suite_source_component: {
        closed: 'Schema',
        active: 'Select input columns',
      },
      bing_ads_source_component: {
        closed: 'Schema',
        active: 'Select input fields',
      },
      facebook_ads_insights_source_component: {
        closed: 'Schema',
        active: 'Select input fields',
      },
      salesforce_source_component: {
        closed: 'Schema',
        active: 'Select input fields',
      },
      rest_api_source_component: {
        closed: 'Response Schema',
        active: 'Select input fields',
      },
    },
    'step-order': {
      union_component: {
        closed: 'Union inputs',
        active: 'Union inputs',
      },
      join_component: {
        closed: 'Join inputs',
        active: 'Join inputs',
      },
    },
    'step-schema-mapping': {
      rest_api_destination_component: {
        closed: 'Request payload configuration & preview',
        active: 'Request payload configuration & preview',
      },
      salesforce_destination_component: {
        closed: 'Schema mapping',
        active: 'Map input to target table columns',
      },
      salesforce_soap_destination_component: {
        closed: 'Schema mapping',
        active: 'Map input to target table columns',
      },
      netsuite_soap_destination_component: {
        closed: 'Schema mapping',
        active: 'Map input to target table columns',
      },
      hubspot_destination_component: {
        closed: 'Schema mapping',
        active: 'Map input to target table columns',
      },
      facebook_ads_destination_component: {
        closed: 'Schema mapping',
        active: 'Map input to target table columns',
      },
      tiktok_ads_destination_component: {
        closed: 'Schema mapping',
        active: 'Map input to target table columns',
      },
      database_destination_component: {
        closed: 'Schema Mapping',
        active: 'Map input to target table columns',
      },
      snowflake_destination_component: {
        closed: 'Schema Mapping',
        active: 'Map input to target table columns',
      },
      amazon_redshift_destination_component: {
        closed: 'Schema Mapping',
        active: 'Map input to target table columns',
      },
      big_query_destination_component: {
        closed: 'Schema Mapping',
        active: 'Map input to target table columns',
      },
      spanner_destination_component: {
        closed: 'Schema Mapping',
        active: 'Map input to target table columns',
      },
      mongo_destination_component: {
        closed: 'Schema Mapping',
        active: 'Map input to target table columns',
      },
      google_ads_destination_component: {
        closed: 'Schema Mapping',
        active: 'Map input to target table columns',
      },
    },
  },
  'schema-mapping-database': {
    headers: {
      'input-fields': 'Input Field',
      'destination-column': 'Destination Column',
      key: 'Key',
    },
  },
  'schema-mapping-salesforce': {
    headers: {
      'input-field': 'Input Field',
      'destination-field': 'Destination Field',
      'referenced-object': 'Referenced Object',
      'referenced-field': 'Referenced Field',
    },
  },
  'schema-mapping-netsuite': {
    headers: {
      'input-field': 'Input Field',
      'destination-field': 'Destination Field',
    },
  },
  'schema-mapping-hubspot': {
    headers: {
      'input-field': 'Input Field',
      'destination-field': 'Destination Field',
    },
  },
  'schema-mapping-google-ads': {
    headers: {
      'input-field': 'Input Field',
      'destination-field': 'Destination Field',
    },
  },
  'schema-mapping-facebook-ads': {
    headers: {
      'input-field': 'Input Field',
      'destination-field': 'Destination Field',
    },
  },
  'schema-mapping-tiktok-ads': {
    headers: {
      'input-field': 'Input Field',
      'destination-field': 'Destination Field',
    },
  },
  'adwords-source-editor': {
    title: 'Source settings',
    form: {
      labels: {
        customer_ids: 'Customer IDs',
        field_name: 'Customer ID field name',
        report_type: 'Report type',
        report_date_range_field: 'Date range field',
        api_version: 'API version',
        report_fields: 'Report fields',
        all_customers: 'All customers',
        specific_customers: 'Specific customers',
        custom: 'Custom',
      },
      placeholders: {
        customer_ids: 'Customer IDs',
        field_name: 'Customer ID field name',
      },
      hints: {
        date_range:
          'If you use variables, make sure to use the date format yyyyMMdd. Calendar widget might not show correct date for variables.',
        customer_ids:
          'Use a variable or a comma separated list of customer IDs. Type comma or press enter to add customer ID. Keep empty to read data from all customers.',
      },
      errors: {
        api_version: 'Selected API version {api_version} is sunset. Switch to latest version and test your package.',
        report_type: 'Selected report type {report} doesn’t exist in list of available reports.',
      },
      dates: {
        title: 'Dates',
        labels: {
          range: 'Date range',
        },
        values: {
          custom_date: 'Custom date range ...',
          today: 'Today',
          yesterday: 'Yesterday',
          this_week_sun_today: 'This week (Sun - Sat)',
          this_week_mon_today: 'This week (Mon - Today)',
          last_7_days: 'Last 7 days',
          last_week_sun_sat: 'Last week (Sun - Sat)',
          last_week_mon_sun: 'Last week (Mon - Sun)',
          last_week: 'Last week (Mon - Sun)',
          last_business_week: 'Last business week (Mon - Fri)',
          last_14_days: 'Last 14 days',
          this_month: 'This month',
          last_30_days: 'Last 30 days',
          last_month: 'Last month',
          all_time: 'All time',
        },
      },
    },
  },
  salesforce_source_component: {
    form: {
      labels: {
        object_name: 'Source object',
      },
    },
  },
  salesforce_destination_component: {
    form: {
      labels: {
        object_name: 'Target object',
      },
    },
  },
  salesforce_soap_destination_component: {
    form: {
      labels: {
        object_name: 'Target object',
      },
    },
  },
  google_ads_destination_component: {
    form: {
      labels: {
        object_name: 'Target object',
      },
    },
  },
  netsuite_soap_destination_component: {
    form: {
      labels: {
        object_name: 'Target object',
      },
    },
  },
  hubspot_destination_component: {
    form: {
      labels: {
        object_name: 'Target object',
      },
    },
  },
  facebook_ads_destination_component: {
    form: {
      labels: {
        object_name: 'Target object',
      },
    },
  },
  tiktok_ads_destination_component: {
    form: {
      labels: {
        object_name: 'Target object',
      },
    },
  },
  'aggregate-editor': {
    form: {
      labels: {
        group_by: 'Grouping fields',
        aggregate_fields: 'Aggregate functions',
      },
      radiolist: {
        group_by: {
          group_all: 'Treat entire input as one group',
          group_by: 'Group input data by field values',
        },
      },
      errors: {
        duplicate_fields: 'Alias cannot appear in both grouping fields and aggregate functions',
      },
    },
  },
  'window-editor': {
    form: {
      labels: {
        group_by: 'Data partitioning',
        data_order: 'Data order',
        windowed_fields: 'Append window functions to input fields:',
      },
      radiolist: {
        group_by: {
          group_all: 'Treat entire input as a single partition',
          group_by: 'Partition input data by fields',
        },
        data_order: {
          no_sort: 'Don’t sort input data',
          sort: 'Sort partition by fields',
        },
      },
      errors: {
        duplicate_fields: 'Alias already exists in input schema',
      },
    },
  },
  'execute-sql-editor': {
    form: {
      buttons: {
        edit_variables: 'Edit package variables',
        test_query: 'Test Query',
      },
      labels: {
        query: 'Query',
        result_type: 'Result type',
        result_variable: 'Map result to variable',
      },
      selects: {
        result_type: {
          options: {
            none: 'No Result',
            string: 'String',
            int: 'Int',
            long: 'Long',
            float: 'Float',
            double: 'Double',
            boolean: 'Boolean',
            datetime: 'DateTime',
          },
        },
      },
    },
    query_error_message: 'Data not available.',
  },
  'database-destination-advanced-options': {
    title: 'Advanced options',
    labels: {
      split_by_field: 'Split data insertion by input field',
      parallel: 'Max parallel connections',
      batch_size: 'Batch Size',
      max_errors: 'Maximum errors',
      max_bad_records: 'Maximum errors',
      single_transaction_per_batch: 'Transactions',
      intermediate_compression_type: 'Intermediate compression',
      truncate_columns: 'Truncate Columns',
      trim_blanks: 'Trim white space',
      empty_as_null: 'Load empty data as null',
      blank_as_null: 'Load blank data as null',
      null_string: 'Null string',
      replacement_char: 'Replacement character for invalid UTF-8 characters',
      round_decimals: 'Round decimal values',
      explicit_ids: 'Input contains explicit identity values',
      comp_rows: 'Compression sample size',
      comp_update: 'Apply compression during data copy',
      identity_insert: 'Insert values to identity column (SQL Server)'
    },
    placeholders: {
      split_by_field: 'Split data insertion by input field',
      parallel: 'Max parallel connections',
      max_errors: 'Maximum errors',
      max_bad_records: 'Maximum errors',
      batch_size: 'Batch Size',
      null_string: '',
      replacement_char: '',
      comp_rows: 'Compression sample size',
    },
    radio: {
      single_transaction_per_batch: {
        transaction_per_connection: 'Transaction per connection',
        transaction_per_batch: 'Transaction per batch',
      },
    },
    selects: {
      intermediate_compression_type: {
        options: {
          none: 'None',
          gzip: 'Gzip',
        },
      },
      comp_update: {
        options: {
          auto: 'Auto',
          on: 'On',
          off: 'Off',
        },
        hint: {
          auto: 'Apply automatic compression only if table is empty and all table columns have RAW or no encoding.',
          on: 'Apply automatic compression only if table is empty regardless of table columns encoding.',
          off: 'Automatic compression is disabled.',
        },
      },
    },
    hint: {
      input_data_will_be_spilt:
        'Input data will be spilt to buckets by input field and inserted in parallel by the defined maximum number of parallel connections.',
      truncate_columns: 'Truncates string input to target column maximum length.',
      trim_blanks: 'Trims trailing white space input.',
      empty_as_null: 'If field data is an empty string, load it as null.',
      blank_as_null: 'If field data contains only white space, load it as null.',
      replacement_character: '',
      null_string: 'Loads specified null string as null.',
      round_decimals: 'Rounds decimal input to target column scale.',
      explicit_ids: 'Use if target table contains an identity column and you’d like to override auto-generated values.',
      comp_rows: 'Specifies the number of rows to be used as the sample size for compression analysis.',
      intermediate_compression_type:
        'Data is written to Amazon S3 before loading into Redshift. Compression may be required if intermediate files are too large and may affect performance.',
      identity_insert: 'Use if you would like to insert values to an identity column. Prepforce will set IDENTITY_INSERT to ON before the query.'
    },
  },
  'database-definition': {
    titles: {
      definition: 'Definition',
    },
    form: {
      mongo_source_component: {
        labels: {
          access_mode: 'Access mode',
          query: 'Query',
          schema_name: 'Source schema',
          collection: 'Source collection',
          table_name: 'Source table',
          source_action: 'Source action',
          split_by_column: 'Split by column',
          parallel: 'Max Connections',
          where_clause: 'Filter query (MongoDB Extended Json)',
          null_string: 'Null string',
          replace_null: 'Replace NULL strings with:',
        },
        placeholders: {
          schema_name: 'Source schema',
          collection: 'Source collection',
          table_name: 'Source table',
          split_by_column: 'Split by column',
          parallel: 'Max Connections',
          where_clause: 'Filter query (MongoDB Extended Json)',
          null_string: 'Null string',
        },
      },
      database_source_component: {
        labels: {
          access_mode: 'Access mode',
          query: 'Query',
          schema_name: 'Source schema',
          table_name: 'Source table / view',
          where_clause: 'Where clause',
          split_by_column: 'Split query by key column',
          parallel: 'Max parallel connections',
        },
        placeholders: {
          schema_name: 'Select a schema',
          schema_name_rich: 'Click to view existing schemas',
          table_name: 'Select a table / view',
          table_name_rich: 'Click to view existing tables',
          split_by_column: 'Split query by key column',
          parallel: 'Max parallel connections',
        },
      },
      database_destination_component: {
        labels: {
          access_mode: 'Access mode',
          query: 'Query',
          schema_name: 'Target schema',
          table_name: 'Target table / view',
          where_clause: 'Where clause',
          split_by_column: 'Split query by key column',
          parallel: 'Max parallel connections',
        },
        placeholders: {
          schema_name: 'Select a schema',
          schema_name_rich: 'Click to view existing schemas',
          table_name: 'Select a table / view',
          table_name_rich: 'Click to view existing tables',
          split_by_column: 'Split query by key column',
          parallel: 'Max parallel connections',
        },
      },
      amazon_redshift_destination_component: {
        labels: {
          access_mode: 'Access mode',
          query: 'Query',
          schema_name: 'Target schema',
          table_name: 'Target table / view',
          where_clause: 'Where clause',
          split_by_column: 'Split query by key column',
          parallel: 'Max parallel connections',
        },
        placeholders: {
          schema_name: 'Select a schema',
          schema_name_rich: 'Click to view existing schemas',
          table_name: 'Select a table / view',
          table_name_rich: 'Click to view existing tables',
          split_by_column: 'Split query by key column',
          parallel: 'Max parallel connections',
        },
      },
      snowflake_destination_component: {
        labels: {
          access_mode: 'Access mode',
          query: 'Query',
          schema_name: 'Target schema',
          table_name: 'Target table / view',
          where_clause: 'Where clause',
          split_by_column: 'Split query by key column',
          parallel: 'Max parallel connections',
        },
        placeholders: {
          schema_name: 'Select a schema',
          schema_name_rich: 'Click to view existing schemas',
          table_name: 'Select a table / view',
          table_name_rich: 'Click to view existing tables',
          split_by_column: 'Split query by key column',
          parallel: 'Max parallel connections',
        },
      },
      big_query_destination_component: {
        labels: {
          access_mode: 'Access mode',
          query: 'Query',
          schema_name: 'Target schema',
          table_name: 'Target table / view',
          where_clause: 'Where clause',
          split_by_column: 'Split query by key column',
          parallel: 'Max parallel connections',
        },
        placeholders: {
          schema_name: 'Select a schema',
          schema_name_rich: 'Click to view existing schemas',
          table_name: 'Select a table / view',
          table_name_rich: 'Click to view existing tables',
          split_by_column: 'Split query by key column',
          parallel: 'Max parallel connections',
        },
      },
      mongo_destination_component: {
        labels: {
          access_mode: 'Access mode',
          query: 'Query',
          schema_name: 'Target schema',
          table_name: 'Target collection',
          where_clause: 'Where clause',
          split_by_column: 'Split query by key column',
          parallel: 'Max parallel connections',
        },
        placeholders: {
          schema_name: 'Select a schema',
          schema_name_rich: 'Click to view existing schemas',
          table_name: 'Collection name',
          table_name_rich: 'Click to view existing tables',
          split_by_column: 'Split query by key column',
          parallel: 'Max parallel connections',
        },
      },
      spanner_destination_component: {
        labels: {
          access_mode: 'Access mode',
          query: 'Query',
          schema_name: 'Target schema',
          table_name: 'Target table',
          where_clause: 'Where clause',
          split_by_column: 'Split query by key column',
          parallel: 'Max parallel connections',
        },
        placeholders: {
          schema_name: 'Select a schema',
          schema_name_rich: 'Click to view existing schemas',
          table_name: 'Table name',
          table_name_rich: 'Click to view existing tables',
          split_by_column: 'Split query by key column',
          parallel: 'Max parallel connections',
        },
      },
      amazon_redshift_source_component: {
        labels: {
          access_mode: 'Access mode',
          query: 'Query',
          schema_name: 'Source schema',
          collection: 'Source collection',
          table_name: 'Source table/view',
          source_action: 'Source action',
          split_by_column: 'Split by column',
          parallel: 'Max Connections',
          where_clause: 'Where clause',
          null_string: 'Null string',
          replace_null: 'Replace NULL strings with:',
        },
        placeholders: {
          schema_name: 'Source schema',
          schema_name_rich: 'Click to view existing schemas',
          collection: 'Collection',
          table_name: 'Source table/view',
          table_name_rich: 'Click to view existing tables',
          split_by_column: 'Split by column',
          parallel: 'Max Connections',
          where_clause: 'Where clause',
          null_string: 'Null string',
        },
      },
      big_query_source_component: {
        labels: {
          access_mode: 'Access mode',
          query: 'Query',
          schema_name: 'Source schema',
          collection: 'Source collection',
          table_name: 'Source table',
          source_action: 'Source action',
          split_by_column: 'Split by column',
          parallel: 'Max Connections',
          where_clause: 'Where clause',
          null_string: 'Null string',
          replace_null: 'Replace NULL strings with:',
        },
        placeholders: {
          schema_name: 'Source schema',
          schema_name_rich: 'Click to view existing schemas',
          collection: 'Collection',
          table_name: 'Source table',
          table_name_rich: 'Click to view existing tables',
          split_by_column: 'Split by column',
          parallel: 'Max Connections',
          where_clause: 'Where clause',
          null_string: 'Null string',
        },
      },
      net_suite_source_component: {
        labels: {
          access_mode: 'Access mode',
          query: 'Query',
          schema_name: 'Source schema',
          collection: 'Source collection',
          table_name: 'Source table',
          source_action: 'Source action',
          split_by_column: 'Split by column',
          parallel: 'Max Connections',
          where_clause: 'Where clause',
          null_string: 'Null string',
          replace_null: 'Replace NULL strings with:',
        },
        placeholders: {
          schema_name: 'Source schema',
          schema_name_rich: 'Click to view existing schemas',
          collection: 'Collection',
          table_name: 'Source table',
          table_name_rich: 'Click to view existing tables',
          split_by_column: 'Split by column',
          parallel: 'Max Connections',
          where_clause: 'Where clause',
          null_string: 'Null string',
        },
      },
      spanner_source_component: {
        labels: {
          access_mode: 'Access mode',
          query: 'Query',
          schema_name: 'Source schema',
          collection: 'Source collection',
          table_name: 'Source table',
          source_action: 'Source action',
          split_by_column: 'Split by column',
          parallel: 'Max Connections',
          where_clause: 'Where clause',
          null_string: 'Null string',
          replace_null: 'Replace NULL strings with:',
        },
        placeholders: {
          schema_name: 'Source schema',
          schema_name_rich: 'Click to view existing schemas',
          collection: 'Collection',
          table_name: 'Source table',
          table_name_rich: 'Click to view existing tables',
          split_by_column: 'Split by column',
          parallel: 'Max Connections',
          where_clause: 'Where clause',
          null_string: 'Null string',
        },
      },

      access_mode: {
        options: {
          table: 'Table',
          view: 'View',
          query: 'Query',
        },
      },
      source_action: {
        options: {
          copy_and_process: 'Copy and process',
          process_directly: 'Process directly',
        },
      },
    },
  },
  'amazon-redshift-destination-editor': {
    titles: {
      definition: 'Definition',
      sql_actions: 'SQL actions',
    },
    labels: {
      schema_name: 'Target schema',
      table_name: 'Target table',
      create_table: 'Create table',
      add_columns: 'Add columns',
      date_format: 'Date format',
      time_format: 'Time format',
      replacement_char: 'Replacement Character',
      max_errors: 'Max errors',
      null_string: 'Null string',
      comp_update: 'Compression',
      comp_rows: 'Compression rows',
      intermediate_compression_type: 'Compression',
      operation_type: 'Operation type',
      where_clause_pre: 'Pre Action SQL',
      where_clause_post: 'Post Action SQL',
      empty_as_null: 'Empty as Null',
      blank_as_null: 'Blank as Null',
      trim_blanks: 'Trim Blanks',
      explicit_ids: 'Explicit IDs',
      truncate_columns: 'Truncate Columns',
      round_decimals: 'Round Decimals',
    },
    placeholders: {
      schema_name: 'Schema name',
      schema_name_rich: 'Click to view existing schemas',
      table_name: 'Table name',
      date_format: 'Date format',
      time_format: 'Time format',
      replacement_char: 'Replacement Character',
      max_errors: 'Max errors',
      null_string: 'Null string',
      comp_rows: 'Compression rows',
    },
    selects: {
      comp_update: {
        options: {
          auto: 'Automatic',
          on: 'ON',
          off: 'OFF',
        },
      },
      intermediate_compression_type: {
        options: {
          none: 'None',
          gzip: 'Gzip',
        },
      },
      operation_type: {
        options: {
          append: 'Insert',
          truncate_and_insert: 'Truncate and Insert',
          delete_and_insert: 'Delete and Insert',
          merge: 'Merge (Upsert)',
        },
      },
    },
  },
  'amazon-redshift-source-editor': {
    titles: {
      definition: 'Definition',
      advanced: 'Advanced',
    },
    form: {
      labels: {
        access_mode: 'Access mode',
        schema_name: 'Source schema',
        table_name: 'Source table',
        source_action: 'Source action',
        split_by_column: 'Split by column',
        parallel: 'Max Connections',
        where_clause: 'Where clause',
        null_string: 'Null string',
        replace_null: 'Replace NULL strings with:',
      },
      placeholders: {
        schema_name: 'Source schema',
        table_name: 'Source table',
        split_by_column: 'Split by column',
        parallel: 'Max Connections',
        where_clause: 'Where clause',
        null_string: 'Null string',
      },
      access_mode: {
        options: {
          table: 'Table',
          view: 'View',
          query: 'Query',
        },
      },
      source_action: {
        options: {
          copy_and_process: 'Copy and process',
          process_directly: 'Process directly',
        },
      },
    },
  },
  'analytics-source-editor': {
    title: 'Source settings',
    form: {
      labels: {
        date_range: 'Date range',
        manual_breakdown: 'Run report day by day',
        custom_fields: 'Include custom dimensions and metrics',
        profile_ids: 'Profile IDs',
        property_ids: 'Property IDs',
        dimensions: 'Dimensions',
        metrics: 'Metrics',
        segment: 'Segment',
        segment_value: 'Segment value',
        filters: 'Filters',
        sort: 'Sort',
        sampling_level: 'Sampling level',
        include_empty_rows: 'Include empty rows',
        all_profiles: 'All profiles',
        all_properties: 'All properties',
        specific_profiles: 'Specific profiles',
        specific_properties: 'Specific properties',
        custom: 'Custom',
      },
      hints: {
        manual_breakdown:
          'When checked, report will be executed for each day in the selected date range, in order to minimize data sampling. Make sure to include ga:date dimension',
        include_empty_rows: 'When unchecked, records where all metric values are zero are omitted.',
        profile_ids:
          'Use a variable or a comma separated list of profile IDs in the form ga:xxx. Type comma or press enter to add profile ID. Keep empty to read data from all profiles.',
        property_ids:
          'Use a variable or a comma separated list of property IDs in the form properties/xxx. Type comma or press enter to add property ID. Keep empty to read data from all profiles. Example: properties/xxx,properties/yyy',
        date_range: 'If you use variables, make sure to use the date format  yyyy-MM-dd.',
      },
      placeholders: {
        profile_ids: 'Profile IDs',
        property_ids: 'Property IDs',
        filters: 'Filters',
        segment_value: 'Segment value',
        sort: 'Sort',
      },
      dates: {
        title: 'Dates',
        labels: {
          date_range: 'Date range',
          profile_id_field_name: 'Profile ID field name',
          account_field_name: 'Account name field name',
          property_field_name: 'Property Name field name',
          profile_field_name: 'Profile name field name',
        },
        placeholders: {
          profile_id_field_name: 'Profile ID field name',
          account_field_name: 'Account name field name',
          property_field_name: 'Property Name field name',
          profile_field_name: 'Profile name field name',
        },
      },
    },
  },
  'big-query-destination-editor': {
    title: 'Definition',
    labels: {
      table_name: 'Target table',
      create_table: 'Create table',
      max_bad_records: 'Max bad records',
      operation_type: 'Operation type',
    },
    placeholders: {
      table_name: 'Table name',
      max_bad_records: 'Max bad records',
    },
    selects: {
      operation_type: {
        options: {
          append: 'Insert',
          truncate_and_insert: 'Truncate and Insert',
          merge: 'Merge (Upsert)',
        },
      },
    },
  },
  'bing-ads-source-editor': {
    titles: {
      definition: 'Definition',
      options: 'Options',
    },
    form: {
      labels: {
        api_version: 'API version',
        accounts_and_campaigns: 'Accounts and campaigns',
        campaigns: 'Campaigns',
        report_type: 'Report type',
        columns: 'Columns',
        period: 'Period',
        unit_of_time: 'Unit of time',
        time_period_field_name: 'Time period date field name',
        date_range: 'Date range',
        report_on: 'Report on',
        all_accounts_and_campains: 'All accounts and campaigns',
        specific_accounts_and_campains: 'Specific accounts and campaigns',
        custom: 'Custom',
      },
      placeholders: {
        time_period_field_name: 'Source table',
      },
      hints: {
        date_range:
          'If you use variables, make sure to use the date format yyyyMMdd. Calendar widget might not show correct date for variables',
        accounts_and_campaigns:
          'Use a variable or a comma separated list of accounts or accounts and campaigns in the form accountID;campaignID.Type comma or press enter to add item. Keep empty to read data from all accounts.',
      },
      selects: {
        report_aggregation_type: {
          options: {
            today: 'Today',
            yesterday: 'Yesterday',
            last_seven_days: 'Last Seven Days',
            this_week: 'This Week',
            last_week: 'Last Week',
            last_four_weeks: 'Last Four Weeks',
            this_month: 'This Month',
            last_month: 'Last Month',
            last_three_months: 'Last Three Months',
            last_six_months: 'Last Six Months',
            this_year: 'This Year',
            last_year: 'Last Year',
            custom_date: 'Custom date range ...',
          },
        },
        report_date_range_type: {
          options: {
            summary: 'Summary',
            hourly: 'Hourly',
            daily: 'Daily',
            weekly: 'Weekly',
            monthly: 'Monthly',
            yearly: 'Yearly',
            hour_of_day: 'Hour of day',
            day_of_week: 'Day of week',
          },
        },
      },
    },
  },
  'cloud-storage-destination-editor': {
    title: 'Definition',
    labels: {
      description: 'Define your destination location, format and action',
      bucket: 'Target bucket',
      container: 'Target container',
      path: 'Target directory',
      destination_type: 'Destination format',
      field_delimiter: 'Delimiter',
      string_qualifier: 'String Qualifier',
      write_header: 'Write field names in first row',
      line_ending: 'Line ending',
      compression_type: 'Compress output',
      enforce_single_file: 'Merge output to single file',
      delete_destination_path: 'Overwrite destination path',
      write_field_names: 'Write field names in first row',
      operation_type: 'Destination action',
      destination_action: 'Destination action',
      escape_character: 'Escape character',
    },
    placeholders: {
      bucket: 'Bucket',
      container: 'integrate-io',
      path: 'Destination path',
      'bucket-s3': 'Bucket name',
      'bucket-gs': 'Bucket name',
      'path-s3': 'Destination path (e.g., output)',
      'path-gs': 'Destination path (e.g., output/)',
      'path-sftp': 'Destination path (e.g., /integrate-io/output/)',
    },
    form: {
      checkbox: 'Write field names in header',
      errors: {
        replace_existing_files:
          "The selected destination action is deprecated. Please use '{suggested_option}' option",
      },
      selects: {
        string_qualifier: {
          options: {
            single_quote_contains_delimiter_or_line_break: "' (Only when the field contains delimiter or a line break)",
            double_quote_contains_delimiter_or_line_break: '" (Only when the field contains delimiter or a line break)',
          },
        },
      },
    },
    selects: {
      format: {
        csv_destination_type: 'Delimited values',
        json_destination_type: 'Line Delimited JSON',
        parquet_destination_type: 'Parquet',
      },
      line_ending: {
        unix: 'Unix/Linux (LF)',
        windows: 'Windows (CRLF)',
      },
      compression_type: {
        options: {
          none: 'None',
          gzip: 'Gzip',
          bz2: 'Bzip2',
        },
      },
      directory_exists_actions: {
        fail_if_exists: 'Write all files directly and fail the job if target directory already exists',
        delete_destination_path: 'Write all files directly and delete target directory if already exists',
        copy_files: 'Use intermediate storage and copy files to an existing directory in destination',
        replace_existing_files: 'Write all files directly and replace files in directory if they already exists',
        copy_files_new_directory: 'Use intermediate storage and copy files to a new directory in destination',
      },
    },
    hints: {
      path: 'One or more files may be created in destination directory.',
      text_qualifier:
        'Field data will be enclosed in string qualifiers when the field data contains the field delimiter or a line break.',
      enforce_single_file: 'Forces writing all output to a single file in output. File size limits may fail jobs.',
      replace_existing_files: 'WARNING: This option deletes the target directory on job failure',
      file_patterns: 'Default filename pattern is: part-[m/r]-[0-9]{5}',
      directory_exists: 'Please make sure that the target directory exists',
      escape_character: 'Escapes characters on the field data that matches with the string qualifier.',
    },
  },
  'cloud-storage-source-editor': {
    sources: {
      location: 'Source location',
      action: 'Source action',
      format: 'Source format',
    },
    form: {
      labels: {
        bucket: 'Source bucket',
        container: 'Source container',
        destination_bucket: 'Destination bucket',
        destination_container: 'Destination container',
        path: 'Source path',
        destination_path: 'Destination path',
        char_encoding: 'Character encoding',
        zip_password: 'Zip Password (optional)',
        before_action: 'Source action',
        path_field_name: 'Source path field name',
        files_manifest_path: 'Manifest path',
        files_manifest_path_connection: 'Manifest connection',
        files_manifest_bucket: 'Manifest bucket',
        delimiter_properties: 'Delimited values properties:',
        record_delimiter: 'Record delimiter',
        record_type: 'Record type',
        field_delimiter: 'Delimiter',
        field_delimiter_custom: 'Custom Delimiter',
        field_delimiter_custom_error: "Custom delimiter can't be empty and it should have only one character.",
        string_qualifier: 'String qualifier',
        maintains_manifest:
          'Prepforce maintains a manifest of processed files on your S3 bucket. Select the connection to use and the path to store the manifest in.',
        sheet_name: 'Sheet Name',
        delete_files_from_source: 'Delete files from source',
        fail_on_empty_source: 'Fail if the source is empty',
        ingest_large_excel_file: 'Ingest large Excel file',
        compression_type: 'Compress output to ZIP',
      },
      placeholders: {
        bucket: 'Bucket',
        bucket_or_container: 'Bucket or container',
        container: 'integrate-io',
        path: 'Source path',
        'file-mover-path': 'Source path',
        'dest-path': 'Destination path',
        sheet_name: 'Sheet Name',
        'bucket-s3': 'Bucket name',
        'bucket-gs': 'Bucket name',
        'path-s3': 'Source path (e.g., input/file.csv)',
        'path-gs': 'Source path (e.g., input/file.csv)',
        'path-sftp': 'Source path (e.g., /integrate-io/file.csv)',
        'file-mover-path-s3': 'Source path (e.g., integrate-io/file.csv or integrate-io/*.csv)',
        'file-mover-path-gs': 'Source path (e.g., integrate-io/file.csv or integrate-io/*.csv)',
        'file-mover-path-sftp': 'Source path (e.g., /integrate-io/file.csv or /integrate-io/*.csv)',
        'dest-path-s3': 'Destination path (e.g., integrate-io/dir/)',
        'dest-path-gs': 'Destination path (e.g., integrate-io/dir/)',
        'dest-path-sftp': 'Destination path (e.g., /integrate-io/dir/)',
      },
      hints: {
        path_field_name: 'Leave blank OR enter a name to add source path field',
        ingest_large_excel_file: 'Reads all sheets, make sure they have the same schema.'
      },
      selects: {
        char_encoding: {
          options: {
            utf_8: 'UTF-8',
            shift_jis: 'Shift_JIS',
            cp932: 'Windows-31J',
            utf_16: 'UTF-16',
          },
        },
        before_action: {
          options: {
            none: 'None',
            copy: 'Copy',
            process_all_files: 'Process all files directly from source',
            process_only: 'Process only new files (Incremental load)',
            copy_merge_and_process: 'Copy, merge and process all files',
          },
        },
        record_delimiter: {
          options: {
            new_line: 'New Line',
            eof: 'End of File',
          },
        },
        record_type: {
          options: {
            delimited: 'Delimited values',
            json: 'Json Object',
            excel: 'Excel',
            raw: 'Raw',
            xml: 'XML',
            parquet: 'Parquet',
            zip: 'ZIP',
          },
        },
        string_qualifier: {
          options: {
            none: 'None',
            none_with_line_ending: 'None (with line ending option)',
            single_quote_newline_inside: "' (newline inside)",
            double_quote_newline_inside: '" (newline inside)',
          },
        },
      },
      checkbox: 'First row contains field names',
    },
    hints: {
      escape_character: 'Omits escape characters on the field data.',
    },
  },
  'database-destination-editor': {
    labels: {
      split_by_field: 'Split by field',
      parallel: 'Max Connections',
      batch_size: 'Batch Size',
    },
    titles: {
      definition: 'Definition',
      sql_actions: 'SQL actions',
    },
    placeholders: {
      schema_name: 'Schema name',
      schema_name_rich: 'Click to view existing schemas',
      table_name: 'Table name',
      parallel: 'Max Connections',
      batch_size: 'Batch Size',
    },
  },
  'database-destination': {
    labels: {
      warehouse_name: 'Warehouse',
      database_name: 'Database',
      schema_name: 'Target schema',
      create_table: "Automatically create table if it doesn't exist",
      add_columns: 'Automatically add missing columns',
      where_clause_pre: 'Pre-action SQL',
      where_clause_post: 'Post-action SQL',
      single_transaction_per_batch: 'Transaction per batch',
      operation_type: 'Operation type',
      database_destination_component: {
        table_name: 'Target table',
      },
      amazon_redshift_destination_component: {
        table_name: 'Target table',
      },
      snowflake_destination_component: {
        table_name: 'Target table',
      },
      big_query_destination_component: {
        table_name: 'Target table',
      },
      spanner_destination_component: {
        table_name: 'Target table',
      },
      mongo_destination_component: {
        table_name: 'Target collection',
        table_name_hint: 'If collection doesn’t exist, it will be automatically created.',
      },
    },
    placeholders: {
      warehouse_name: 'Warehouse',
      database_name: 'Database',
      schema_name: 'Schema name',
      schema_name_rich: 'Click to view existing schemas',
      table_name_rich: 'Click to view existing tables',
      table_name: 'Click to view existing tables',
      parallel: 'Max Connections',
      batch_size: 'Batch Size',
      database_destination_component: {
        table_name: 'Table name',
        table_name_rich: 'Click to view existing tables',
      },
      amazon_redshift_destination_component: {
        table_name: 'Table name',
        table_name_rich: 'Click to view existing tables',
      },
      snowflake_destination_component: {
        table_name: 'Table name',
        table_name_rich: 'Click to view existing tables',
      },
      big_query_destination_component: {
        table_name: 'Table name',
      },
      spanner_destination_component: {
        table_name: 'Table name',
      },
      mongo_destination_component: {
        table_name: 'Collection name',
      },
    },
    selects: {
      operation_type: {
        options: {
          database_destination_component: {
            append: 'Append (Insert only)',
            truncate_and_insert: 'Overwrite (Truncate and insert)',
            delete_and_insert: 'Overwrite (Delete all rows on table and insert)',
            merge: 'Merge with existing data using delete and insert',
            merge_update_and_insert: 'Merge with existing data using update and insert',
          },
          amazon_redshift_destination_component: {
            append: 'Append (Insert only)',
            truncate_and_insert: 'Overwrite (Truncate and insert)',
            delete_and_insert: 'Overwrite (Delete all rows on table and insert)',
            merge: 'Merge with existing data using delete and insert',
            merge_update_and_insert: 'Merge with existing data using update and insert',
          },
          big_query_destination_component: {
            append: 'Append (Insert only)',
            truncate_and_insert: 'Overwrite (Truncate and insert)',
            merge: 'Merge with existing data',
          },
          spanner_destination_component: {
            append: 'Append (Insert only)',
            insert_or_update: 'Merge with existing data using Insert or update',
            merge: 'Merge with existing data using Replace',
          },
          snowflake_destination_component: {
            append: 'Append (Insert only)',
            truncate_and_insert: 'Overwrite (Truncate and insert)',
            delete_and_insert: 'Overwrite (Delete all rows on table and insert)',
            merge: 'Merge with existing data using delete and insert',
            merge_update_and_insert: 'Merge with existing data using update and insert',
          },
          mongo_destination_component: {
            insert: 'Insert only',
            merge_update_and_insert: 'Merge with existing data using update and insert',
          },
        },
      },
    },
  },
  'database-source-editor': {
    titles: {
      definition: 'Definition',
      advanced: 'Advanced',
    },
    form: {
      labels: {
        before_action: 'Source action',
        split_by_column: 'Split query by key column',
        parallel: 'Max parallel connections',
        null_string: 'Null string',
        replace_null: 'Replace NULL strings with:',
      },
      placeholders: {
        schema_name: 'Source schema',
        table_name: 'Source table',
        split_by_column: 'Split query by key column',
        parallel: 'Max parallel connections',
        null_string: 'Null string',
      },
      hints: {
        split_by_column_name:
          'To parallelize a query, select a key to split the queries by and the maximum number of parallel connections. When parallelizing a query, a preliminary query will get the minimum and maximum values for the column and then queries will be issued from multiple connections with a where clause that splits the data to ranges. E.g.: pk >= 1 AND pk < 1000, pk >= 1001 AND pk < 2000.',
      },
      access_mode: {
        options: {
          table: 'Table',
          view: 'View',
          query: 'Query',
        },
      },
      source_action: {
        options: {
          copy_and_process: 'Copy and process',
          process_directly: 'Process directly',
        },
      },
      before_action: {
        options: {
          none: 'None',
          copy: 'Copy',
        },
      },
    },
  },
  'join-editor': {
    titles: {
      general: 'General options',
      advanced: 'Advanced options',
    },
    labels: {
      join_type: 'Join type',
      optimization_type: 'Join optimization',
      join_keys: 'Join keys',
      join_keys_desc:
        'Inputs are joined on equal key values (equijoin). Make sure to specify keys in the same order for all inputs.',
    },
    errors: {
      replicated_optimization_error: 'Only inner or left join can be used with replicated join optimization',
    },
    selects: {
      join_type: {
        options: {
          inner: 'Inner',
          left: 'Left',
          right: 'Right',
          full: 'Full',
        },
      },
      optimization_type: {
        options: {
          default: 'Default',
          default_desc:
            'Hash join - both inputs are read, tagged by source and are sorted and put into buckets according to the join keys. Then for each key, the records are cross joined by source tags.',
          replicated: 'Replicated',
          replicated_desc:
            'Use with inner or left joins when the left input is larger and the other inputs are small enough to fit into memory to improve join efficiency. The small inputs will be read into memory and spread to worker tasks that will lookup values for each record read from left input.',
          skewed: 'Skewed',
          skewed_desc:
            'Use when underlying key values are very skewed which causes processing not to be evenly distributed between parallel worker tasks, which may cause the job to fail or run longer because of a single task. When Skewed join is used, a histogram is computed on the join key using the left source and this data is used to allocate more reducers for a given key.',
        },
      },
    },
  },
  facebook_ads_insights_source_component: {
    form: {
      labels: {
        api_version: 'API version',
        level: 'Level',
        date_range: 'Date range',
        manual_breakdown: 'Run report day by day',
        time_increment: 'Time breakdown',
        filtering: 'Filtering',
        action_report_time: 'Action report time',
        report_on: 'Report on:',
        all_accounts: 'All accounts',
        specific_accounts: 'Specific accounts',
        with_custom_fields: 'Include custom conversions fields',
      },
      hints: {
        manual_breakdown:
          'When checked, report will be executed for each day in the selected date range, in order to minimize data sampling. Make sure to include date_start and date_end dimensions',
        date_range:
          'If you use variables, make sure to use the date format yyyy-MM-dd. Calendar widget might not show correct date for variables.',
      },
      errors: {
        missing_field: "Selected {name} with value {value} doesn't exist in selected api version.",
      },
    },
  },
  sort_component: {
    fields_mapping: 'Sort input data by:',
  },
  select_component: {
    fields_mapping: 'Specify field expressions',
  },
  'limit-editor': {
    labels: {
      partition_by: 'Partition by',
      limit_to: 'Limit data to',
      rank_by: 'Rank by',
      records: 'records',
      partitioning: 'Data partitioning',
      order: 'Data order',
      records_per_partition: 'records per partition',
    },
    headers: {
      field: 'Field',
      direction: 'Direction',
    },
    placeholders: {
      limit: 'e.g. 2, 90, 120',
    },
    radiolist: {
      partitioning: {
        all: 'Treat entire input as a single partition',
        partition_by: 'Partition input data by fields',
      },
      order: {
        no_sort: 'Don’t sort input data',
        sort: 'Sort partition by fields',
      },
    },
  },
  union_component: {
    labels: {
      fields_mapping: 'Union inputs into a single output',
    },
  },
  filter_component: {
    'collection-headers': {
      right: 'Value/Expression',
      hint_right: "Strings don't have to be enclosed in quotes.",
    },
    selects: {
      match_types: {
        all: 'Match all of following conditions (AND)',
        any: 'Match any of the following conditions (OR)',
        none: 'Match none of the following conditions NOT (... OR ...)',
      },
    },
    labels: {
      conditions: 'Conditions:',
    },
  },
  assert_component: {
    'collection-headers': {
      right: 'Value/Expression',
    },
    labels: {
      description: "Throw error if an input record doesn't pass the following conditions.",
      message: 'Error message:',
      conditions: 'Conditions:',
    },
  },
  'mongo-destination-editor': {
    title: 'Definition',
    labels: {
      table_name: 'Collection target',
    },
    placeholders: {
      table_name: 'Collection target',
    },
  },
  'mongo-source-editor': {
    form: {
      titles: {
        definition: 'Definition',
        options: 'Options',
      },
      labels: {
        table_name: 'Source collection',
        where_clause: 'Filter query (MongoDB Extended Json)',
      },
      placeholders: {
        table_name: 'Source collection',
        where_clause: 'Filter query (MongoDB Extended Json)',
      },
    },
  },
  'notify-editor': {
    labels: {
      email: 'Email',
      subject: 'Subject',
      message: 'Message',
    },
  },
  'rank-editor': {
    rank: {
      settings: 'Rank settings',
      by: 'Rank by',
    },
    form: {
      labels: {
        add_rank_field: 'Add rank field',
        data_order: 'Data order',
      },
      placeholders: {
        rank: 'Rank',
      },
      checkbox: 'Use dense rank (No gaps in ranking values)',
      data_order: {
        no_sort: 'Add rank without sorting the data',
        sort: 'Rank data by fields order',
      },
    },
  },
  'run-package-editor': {
    labels: {
      operator: 'Execute task if:',
      and: 'all preceding conditions evaluate to true (AND)',
      or: 'one of the preceding conditions evaluate to true (OR)',
    },
  },
  'sample-editor': {
    labels: {
      sample: 'Output a random sample of data:',
      percentage: '% of all input records',
    },
    placeholders: {
      percentage: 'e.g 10, 15.23, 100',
    },
  },
  'select-editor': {
    actions: {
      auto_fill: 'Auto-fill fields',
    },
  },
  'cross-join-editor': {
    title1: "Cross join's output is the product of multiplying records from all inputs.",
    title2:
      "You don't have to configure anything here, but you may want to add a filter component right after the cross join.",
  },
  'distinct-editor': {
    title: 'The distinct component removes duplicate records',
    title_: '(where values in all fields exist in more than one record).',
    hint: "You don't have to configure anything here.",
  },
  'clone-editor': {
    title:
      "The clone component allows you to perform multiple transformations on the same input data. You don't have to configure anything here.",
  },
  'salesforce-source-editor': {
    title: 'Source settings',
    form: {
      labels: {
        object_name: 'Source object',
        source_action: 'Source action',
        where_clause: 'Where clause (SOQL condition expression syntax)',
        access_mode: 'Access mode',
        object: 'Object',
        query: 'Query',
        chunk_size_checkbox: 'Enable PK Chunking',
        chunk_size: 'Chunk Size',
        chunk_size_error: 'Chunk size should be a number between 1 and 250000',
        api_version: 'API Version',
        max_records: 'Max Records',
      },
      placeholders: {
        where_clause: "Enter your SOQL condition directly. You do not need to include \'WHERE\' as it\'s already implied.",
        max_records: '50000'
      },
      hints: {
        max_records: 'Number of records to retrieve per page to prevent timeout'
      },
      errors: {
        max_records: 'Value can only be a number or variable',
      }
    },
  },
  'salesforce-destination-editor': {
    title: 'Source settings',
    'advanced-options': 'Advanced options',
    form: {
      labels: {
        object_name: 'Target object',
        operation_type: 'Operation type',
        id_field: 'Upsert key',
        parallel: 'Thread count',
        id_field_update: 'Update key',
        batch_size: 'Batch size',
        max_errors: 'Maximum errors',
        track_errors: 'Output failed records (CSV)',
        enable_null_value: 'Include null fields on the payload',
        errors_output_connection: 'Errors output connection',
        errors_output_path: 'Errors output path',
      },
      'operation-type': {
        option: {
          insert: 'Insert only',
          upsert: 'Upsert',
          update: 'Update',
          delete: 'Delete',
          hard_delete: 'Hard Delete',
        },
      },
      errors: {
        object_name:
          'Selected object "{ objectName }" doesn’t exist in list of available objects. Refresh object list or select another object.\'',
        id_field: 'Upsert key "{ field } " does not exist in schema. Please choose a different key',
      },
    },
  },
  'netsuite-destination-editor': {
    title: 'Destination settings',
    'advanced-options': 'Advanced options',
    form: {
      labels: {
        object_name: 'Target object',
        operation_type: 'Operation type',
        id_field: 'ID field',
        batch_size: 'Batch size',
        max_errors: 'Maximum errors',
      },
      'operation-type': {
        option: {
          insert: 'Insert only',
          upsert: 'Upsert',
          delete: 'Delete',
        },
      },
      errors: {
        object_name:
          'Selected object "{ objectName }" doesn’t exist in list of available objects. Refresh object list or select another object.\'',
        id_field: 'ID field "{ field } " does not exist in schema. Please choose a different key',
      },
    },
  },
  'google-ads-destination-editor': {
    title: 'Destination settings',
    'advanced-options': 'Advanced options',
    form: {
      labels: {
        object_name: 'Target object',
        operation_type: 'Operation type',
        id_field: 'ID field',
        customer_id: 'Customer ID',
        login_customer_id: 'Login Customer ID',
      },
      'operation-type': {
        option: {
          insert: 'Insert only',
          upsert: 'Upsert',
          delete: 'Delete',
        },
      },
      errors: {
        object_name:
          'Selected object "{ objectName }" doesn’t exist in list of available objects. Refresh object list or select another object.\'',
        id_field: 'ID field "{ field } " does not exist in schema. Please choose a different key',
      },
    },
  },
  'facebook-destination-editor': {
    title: 'Destination settings',
    'advanced-options': 'Advanced options',
    form: {
      labels: {
        object_name: 'Target object',
        operation_type: 'Operation type',
        batch_size: 'Batch size',
        max_errors: 'Maximum errors',
        pixel_id: 'Pixel ID',
        custom_audience_id: 'Custom Audience ID',
        id_field: 'Upsert key',
        id_field_update: 'Update key',
      },
      'operation-type': {
        option: {
          insert: 'Insert only',
          replace: 'Replace',
          delete: 'Delete',
          update: 'Update',
        },
      },
      errors: {
        object_name:
          'Selected object "{ objectName }" doesn’t exist in list of available objects. Refresh object list or select another object.\'',
        id_field: 'Upsert key "{ field } " does not exist in schema. Please choose a different key',
      },
    },
  },
  'hubspot-destination-editor': {
    title: 'Destination settings',
    'advanced-options': 'Advanced options',
    form: {
      labels: {
        object_name: 'Target object',
        operation_type: 'Operation type',
        id_property: 'Id Property',
        batch_size: 'Batch size',
        max_errors: 'Maximum errors',
        track_errors: 'Output failed records (CSV)',
        errors_output_connection: 'Errors output connection',
        errors_output_path: 'Errors output path',
      },
      'operation-type': {
        option: {
          create: 'Create',
          update: 'Update',
          upsert: 'Upsert',
        },
      },
      errors: {
        object_name:
          'Selected object "{ objectName }" doesn’t exist in list of available objects. Refresh object list or select another object.\'',
      },
    },
  },
  'tiktok-ads-destination-editor': {
    title: 'Destination settings',
    'advanced-options': 'Advanced options',
    form: {
      labels: {
        object_name: 'Target object',
        operation_type: 'Operation type',
        batch_size: 'Batch size',
        max_errors: 'Maximum errors',
        pixel_id: 'Pixel ID',
        custom_audience_id: 'Custom Audience ID',
        id_field: 'Upsert key',
        id_field_update: 'Update key',
      },
      'operation-type': {
        option: {
          insert: 'Insert only',
          update: 'Update',
        },
      },
      errors: {
        object_name:
          'Selected object "{ objectName }" doesn’t exist in list of available objects. Refresh object list or select another object.\'',
        id_field: 'Upsert key "{ field } " does not exist in schema. Please choose a different key',
      },
    },
  },
  'rest-api-destination-editor': {
    form: {
      labels: {
        url: 'URL',
        method: 'Method',
        username: 'Username',
        password: 'Password',
        body: 'body',
        sleep_interval: 'Sleep interval between paginated requests (ms)',
        headers: 'Headers',
        response_type: 'Response type',
        pagination_scheme: 'Pagination scheme',
        max_requests: 'Maximum paginated requests',
        batch_size: 'Batch size',
        save_responses_to_file: 'Save responses to file',
        responses_output_path: 'Output path',
        responses_output_connection: 'Output connection',
        fail_on_error_response: 'Stop the job if an error is returned by the API',
        is_batch: 'Send records as batch',
        send_records_as_nested_attribute: 'Send record as nested attribute',
        send_records_as_nested_attribute_batch: 'Send records as nested attribute',
        nested_attribute_name: 'Nested attribute name',
        is_custom_payload: 'Use custom payload',
        set_field_name: 'Send values from one field as an array',
      },
      placeholders: {
        url: 'URL',
        username: 'Username',
        password: 'Password',
        body: 'body',
        sleep_interval: 'Sleep interval',
        max_requests: 'Unlimited',
      },
      checkbox: 'Use pagination',
      selects: {
        request_type: {
          options: {
            csv: 'CSV',
            json: 'JSON',
            'form-data': 'multipart/form-data',
            'url-encoded': 'x-www-form-urlencoded',
          },
        },
        payload_type: {
          options: {
            records: 'Records',
            custom_input: 'Custom input',
          }
        },
        number_of_requests: {
          options: {
            single_per_record: 'Single per record',
            batch: 'Batch requests',
            one_request: 'One request',
          }
        },
        pagination_scheme: {
          options: {
            auto: 'Automatic',
            jira: 'Jira',
            magento: 'Magento',
            linkheaders: 'Link Headers',
            bigcommercev2: 'BigCommerce',
            elasticsearch: 'Elasticsearch',
            elasticsearchscroll: 'Elasticsearch Scroll',
            appsyncdynamodb: 'AWS AppSync DynamoDB',
            facebookbusinessdiscovery: 'Facebook Business Discovery'
          },
        },
      },
    },
  },
  'rest-api-source-editor': {
    titles: {
      settings: 'Source settings',
      data: 'Data',
    },
    form: {
      labels: {
        url: 'URL',
        method: 'Method',
        username: 'Username',
        password: 'Password',
        body: 'body',
        sleep_interval: 'Sleep interval between paginated requests (ms)',
        headers: 'Headers',
        response_type: 'Response type',
        pagination_scheme: 'Pagination scheme',
        max_requests: 'Maximum paginated requests',
        batch_size: 'Batch size',
      },
      placeholders: {
        url: 'URL',
        username: 'Username',
        password: 'Password',
        body: 'body',
        sleep_interval: 'Sleep interval',
        max_requests: 'Unlimited',
      },
      checkbox: 'Use pagination',
      selects: {
        response_type: {
          options: {
            raw: 'Raw response',
            json: 'JSON',
            array: 'Json Array',
            line_delimited_json: 'Line Delimited JSON',
            line_delimited_data: 'Line delimited raw data',
          },
        },
        request_type: {
          options: {
            csv: 'CSV',
            json: 'JSON',
            'form-data': 'multipart/form-data',
            'url-encoded': 'x-www-form-urlencoded',
          },
        },
        pagination_scheme: {
          options: {
            auto: 'Automatic',
            jira: 'Jira',
            magento: 'Magento',
            linkheaders: 'Link Headers',
            bigcommercev2: 'BigCommerce',
            elasticsearch: 'Elasticsearch',
            elasticsearchscroll: 'Elasticsearch Scroll',
            appsyncdynamodb: 'AWS AppSync DynamoDB',
            facebookbusinessdiscovery: 'Facebook Business Discovery'
          },
        },
      },
    },
  },
  'connection-component-access-type': {
    selects: {
      tunnel_type: {
        options: {
          direct: 'Direct connection',
          reverse: 'Reverse SSH tunnel connection',
          'ssh-tunnel': 'SSH tunnel connection',
        },
      },
    },
  },
  'connection-component-ga4': {
    title: 'Google Analytics - GA4 Setup',
    text:
      'Please refer to <a href="https://www.integrate.io/docs/etl/allowing-integrateio-etl-access-to-google-analytics-4-ga4/" target="_blank"><strong>the documentation</strong></a> for details on how to generate the JSON key. Uploading the key would automatically fill-up the service account email on the left. ',
  },
  'connection-component-cloud-storage-v2': {
    title: 'Google Cloud Storage Setup',
    text:
      'Please refer to <a href="https://www.integrate.io/docs/etl/allowing-integrateio-etl-access-to-my-data-on-google-cloud-storage-v2/" target="_blank"><strong>the documentation</strong></a> for details on how to generate the JSON key. Uploading the key would automatically fill-up the service account email and project ID on the left. ',
  },
  'connection-component-bigquery-v2': {
    title: 'Google BigQuery Setup',
    text:
      'Please refer to <a href="https://www.integrate.io/docs/etl/allowing-integrateio-etl-access-to-my-google-bigquery-dataset/" target="_blank"><strong>the documentation</strong></a> for details on how to generate the JSON key. Uploading the key would automatically fill-up the service account email and project ID on the left. ',
  },
  'connection-component-hubspot': {
    title: 'Hubspot Access',
    text:
      'Please refer to <a href="https://www.integrate.io/docs/etl/allowing-integrateio-etl-access-to-hubspot/" target="_blank"><strong>this article</strong></a> for details on how to get the Private App Token.',
  },
  'connection-component-reverse-tunnel': {
    title: 'Reverse Tunnel Connection Setup',
    text:
      'Save the connection to generate the tunnel endpoint and follow the <a href="https://www.integrate.io/docs/etl/allowing-integrateio-etl-access-to-my-server-behind-a-firewall/#reverse-ssh-tunnel" target="_blank"><strong>Reverse SSH Tunnel setup instructions</strong></a>. Once you have completed the setup you can try and test the connection.',
      text_saved: 'Please follow the <a href="https://www.xplenty.com/docs/allowing-xplenty-access-to-my-server-behind-a-firewall/" target="_blank"><strong>Reverse SSH Tunnel setup instructions</strong></a>. Integrate.io ETL will listen on <strong>{ reverseTunnelEndpoint }</strong>. Once you have completed the setup you can try and test the connection.'
  },
  'connection-component-ssh-tunnel': {
    title: 'SSH Tunnel Connection Setup',
    text:
      'Save the connection to generate SSH public key and follow the <a href="https://www.xplenty.com/docs/allowing-xplenty-access-to-my-server-behind-a-firewall/" target="_blank"><strong>SSH Tunnel setup instructions</strong></a>. Once you have completed the setup you can try and test the connection.',
    text_saved:
      'Please follow the <a href="https://www.xplenty.com/docs/allowing-xplenty-access-to-my-server-behind-a-firewall/" target="_blank"><strong>SSH Tunnel setup instructions</strong></a>. Once you have completed the setup you can try and test the connection.',
  },
  'connection-component-ssh-direct': {
    title: 'Direct Connection Setup',
    text: 'Please whitelist our IP addresses in order to establish a direct connection. You can find our list of IPs in the <a href="https://www.integrate.io/docs/etl/integrateio-etls-ip-list/" target="_blank"><strong>documentation</strong></a>. Once whitelisting is complete, you can test the connection.'
  },
  'connection-component-public-key': {
    title: 'Public key authentication setup',
    text:
      'Copy your Prepforce account\'s public key above and add it to the SFTP user\'s authorized keys. Once you have completed the setup you can try and test the connection.',
  },
  'connection-component-authenticate-button': {
    authenticate: 'Authenticate',
    reconnect: 'Reconnect',
  },
  'connection-form-adwords': {
    sign_in_text: "Connect to your Google AdWords account by clicking the 'Authenticate' button.",
    actions: {
      sign_in: 'Authenticate',
    },
  },
  'connection-form-pipedrive': {
    sign_in_text: "Connect to your Pipedrive account by clicking the 'Authenticate' button.",
    actions: {
      sign_in: 'Authenticate',
    },
  },
  'connection-form-xero': {
    sign_in_text: "Connect to your Xero account by clicking the 'Authenticate' button.",
    actions: {
      sign_in: 'Authenticate',
    },
  },
  'connection-form-facebookadsinsights': {
    sign_in_text: "Connect to your Facebook Ads Insights account by clicking the 'Authenticate' button.",
    actions: {
      sign_in: 'Authenticate',
    },
  },
  'connection-form-facebook-ads': {
    sign_in_text: "Connect to your Facebook Ads account by clicking the 'Authenticate' button.",
    actions: {
      sign_in: 'Authenticate',
    },
  },
  'connection-form-hubspot-oauth': {
    sign_in_text: "Connect to your Hubspot account by clicking the 'Authenticate' button.",
    actions: {
      sign_in: 'Authenticate',
    },
  },
  'connection-form-analytics': {
    sign_in_text: "Connect to your Google Analytics account by clicking the 'Authenticate' button.",
    actions: {
      sign_in: 'Authenticate',
    },
  },
  'connection-form-youtube': {
    sign_in_text: "Connect to your YouTube account by clicking the 'Authenticate' button.",
    actions: {
      sign_in: 'Authenticate',
    },
  },
  'connection-form-shopify': {
    hints: {
      sign_in_text: "Enter store address and click the 'Authenticate' button.",
    },
    labels: {
      account: 'Store address',
    },
    actions: {
      sign_in: 'Authenticate',
    },
  },
  'connection-form-bigquery': {
    actions: {
      test: 'Test connection',
    },
    labels: {
      name: 'Name',
      host: 'Project ID',
      database: 'Dataset ID',
      region: 'Region',
      client_email: 'Service account email',
      json_key: 'Upload JSON Key',
    },
  },
  'connection-form-bingads': {
    sign_in_text: "Connect to your Bing Ads account by clicking the 'Authenticate' button.",
    actions: {
      sign_in: 'Authenticate',
    },
  },
  'connection-form-salesforce': {
    sign_in_text: "Connect to your Salesforce account by clicking the 'Authenticate' button.",
    actions: {
      sign_in: 'Authenticate',
    },
  },
  'connection-form-googlecloudsql': {
    actions: {
      test: 'Test connection',
    },
    labels: {
      name: 'Name',
      host: 'Project ID',
      database: 'Dataset ID',
      region: 'Region',
    },
    selects: {
      region: {
        options: {
          asia: 'Google Cloud - Asia (East)',
          europe: 'Google Cloud - Europe (West)',
          us: 'Google Cloud - US (Central)',
        },
      },
    },
  },
  'connection-form-intercom': {
    sign_in_text: "Connect to your Intercom account by clicking the 'Authenticate' button.",
    actions: {
      sign_in: 'Authenticate',
    },
  },
  'connection-form-instagram': {
    sign_in_text: "Connect to your Instagram account by clicking the 'Authenticate' button.",
    actions: {
      sign_in: 'Authenticate',
    },
  },
  'connection-form-googlesheets': {
    sign_in_text: "Connect to your Google Sheets account by clicking the 'Authenticate' button.",
    actions: {
      sign_in: 'Authenticate',
    },
  },
  'connection-form-googledrive': {
    sign_in_text: "Connect to your Google Drive account by clicking the 'Authenticate' button.",
    actions: {
      sign_in: 'Authenticate',
    },
  },
  'connection-form-linkedin': {
    sign_in_text: "Connect to your LinkedIn account by clicking the 'Authenticate' button.",
    actions: {
      sign_in: 'Authenticate',
    },
  },
  'connection-form-tiktok-ads': {
    sign_in_text: "Connect to your TikTok Ads account by clicking the 'Authenticate' button.",
    actions: {
      sign_in: 'Authenticate',
    },
    environment_types: {
      production: 'Production',
      sandbox: 'Sandbox',
    },
    labels: {
      environment_type: 'Environment',
      options: {
        production: 'Production',
        sandbox: 'Sandbox',
      },
    },
  },
  connections: {
    list: {
      title: 'Connections',
      actions: {
        add: 'New connection',
      },
      form: {
        actions: {
          cancel: 'Cancel',
        },
      },
    },
    form: {
      default: {
        actions: {
          test: 'Test connection',
          create: 'Create connection',
          save: 'Save changes',
          reconnect: 'Reconnect',
        },
        titles: {
          'edit-connection': 'Edit connection',
          'create-a-new-connection': 'Create a connection',
        },
        buttons: {
          create: 'Create connection',
          update: 'Save changes',
          test: 'Test connection',
          reconnect: 'Reconnect',
          cancel: 'Cancel',
        },
        notifications: {
          test: {
            success_message: 'Yay, test successful!',
            error_message: 'Sorry, test failed (error message: <samp>{ message }</samp>).',
          },
        },
      },
      gs: {
        title: 'New Google Cloud Storage Connection',
        labels: {
          name: 'Name',
          project_id: 'Project ID',
        },
        placeholders: {
          name: 'Name',
          project_id: 'Project ID',
        },
        hints: {
          name: 'Use this name to provide extra context in your list of connections.',
          project_id: 'The ID of the project that contains the storage to connect to.',
        },
        actions: {
          submit: 'Create Google Cloud Storage Connection',
          test: 'Test Connection',
        },
      },
      salesforce: {
        action: 'Authenticate your Salesforce account',
        environment_types: {
          production: 'Production',
          sandbox: 'Sandbox',
        },
        labels: {
          environment_type: 'Environment',
          options: {
            production: 'Production',
            sandbox: 'Sandbox',
          },
        },
        hints: {
          name: 'Use this name to provide extra context in your list of connections.',
          environment: 'The environment of the Salesforce organization.',
        },
        actions: {
          submit: 'Create Salesforce Connection',
          test: 'Test Connection',
        },
      },
      s3: {
        title: 'New Amazon S3 connection',
        labels: {
          name: 'Name',
          username: 'Access key ID',
          password: 'Secret access key',
        },
        placeholders: {
          name: 'Name',
          username: 'Access key ID',
          password: 'Secret access key',
        },
        hints: {
          name: 'Use this name to provide extra context in your list of connections.',
          username:
            'The Access Key ID that you generated in Amazon IAM for your user account. Available in the credentials.csv file if you downloaded the User Security credentials.',
          password:
            'The Secret Access Key that you generated in Amazon IAM for your user account. Available in the credentials.csv file if you downloaded the User Security credentials.',
        },
        actions: {
          submit: 'Create Amazon S3 Connection',
          test: 'Test Connection',
        },
      },
      azureblobstorage: {
        title: 'New Azure Blob Storage connection',
        labels: {
          name: 'Name',
          username: 'Storage account name',
          password: 'Access key',
        },
        placeholders: {
          name: 'Name',
          username: 'Storage Account Name',
          password: 'Access Key',
        },
      },
      hdfs: {
        title: 'New HDFS Connection',
        labels: {
          name: 'name',
          username: 'User name',
          name_node_host: 'NameNode hostname',
          name_node_port: 'NameNode port',
          httpfs_host: 'HttpFS hostname',
          httpfs_port: 'HttpFS port',
        },
        hints: {
          name: 'Use this name to provide extra context in your list of connections.',
          username: 'The Hadoop user name.',
          name_node_host: 'The name of the NameNode host to connect to.',
          name_node_port:
            'The TCP port of the NameNode to connect to. Leave blank if cluster HDFS High Availability (HA) is enabled. Common values are 8020 or 9000.',
          httpfs_host: 'The name of the Hadoop HDFS gatweay node to connect to.',
          httpfs_port: 'The TCP port of the Hadoop HDFS gatweay node to connect to. Default is 14000.',
        },
        actions: {
          submit: 'Create HDFS Connection',
          test: 'Test connection',
        },
      },
      rackspace: {
        title: 'New Rackspace Cloud Files Connection',
        labels: {
          name: 'Name',
          username: 'User name',
          password: 'API key (Password)',
          region: 'Region',
        },
        hints: {
          name: 'Use this name to provide extra context in your list of connections.',
          username: 'The user name as defined in the Rackspace Cloud Files account credentials.',
          password: 'The API Key (Password) as defined in the Rackspace Cloud Files account credentials.',
          region: 'Select the geographical location of your Rackspace Cloud Files container.',
        },
        actions: {
          submit: 'Create Rackspace Cloud Files Connection',
          test: 'Test connection',
        },
      },
      segment: {
        labels: {
          region: 'Region',
        },
      },
      redshift: {
        title: 'New Amazon Redshift Connection',
        labels: {
          name: 'Name',
          tunnel_type: 'Access Type',
          host: 'Hostname',
          username: 'User name',
          password: 'Password',
          port: 'Port',
          database: 'Database',
          region: 'Region',
          ssl: 'Connect using SSL',
        },
        hints: {
          name: 'Use this name to provide extra context in your list of connections.',
          tunnel_type: 'The method to use for accessing the database.',
          host: 'The name of the host to connect to.',
          username: 'The database user name.',
          password: 'The database user password.',
          port: 'The TCP port to connect to. The default is 5439.',
          database: 'The name of database to use.',
          region: 'The geographical location of your Redshift cluster.',
          ssl:
            'Determines whether to connect to the database using SSL. SSL allows encryption of client/server communications for increased security.',
        },
        selects: {
          tunnel_type: {
            options: {
              direct: 'Direct connection',
              reverse: 'Reverse SSH tunnel connection',
              'ssh-tunnel': 'SSH tunnel connection',
            },
          },
        },
        actions: {
          submit: 'Create Amazon Redshift Connection',
          test: 'Test connection',
        },
      },
      sftp: {
        title: 'New SFTP Connection',
        labels: {
          name: 'Name',
          host: 'Hostname',
          auth_method: 'Authentication method',
          username: 'User name',
          password: 'Password',
          port: 'Port',
        },
        hints: {
          name: 'Use this name to provide extra context in your list of connections.',
          host: 'The name of the SFTP server to connect to.',
          auth_method: 'The authentication method to use.',
          username: 'The SFTP server user name.',
          password: 'The SFTP server password. Only required for Password Authentication method.',
          port: 'The TCP port to connect to. Default is 22.',
        },
        select: {
          options: {
            password: 'Password authentication',
            key: 'Public key authentication',
          },
        },
        actions: {
          submit: 'Create SFTP Connection',
          test: 'Test connection',
          copy_key: 'Click to copy public key to clipboard',
        },
      },
      ftps: {
        title: 'New FTPS Connection',
        labels: {
          name: 'Name',
          host: 'Hostname',
          username: 'User name',
          password: 'Password',
          port: 'Port',
        },
        hints: {
          name: 'Use this name to provide extra context in your list of connections.',
          host: 'The name of the FTPS server to connect to.',
          username: 'The FTPS server user name.',
          password: 'The FTPS server password.',
          port: 'The TCP port to connect to. Default is 21.',
        },
        actions: {
          submit: 'Create FTPS Connection',
          test: 'Test connection',
        },
      },
      softlayer: {
        title: 'New SoftLayer Object Storage Connection',
        labels: {
          name: 'Name',
          username: 'User name',
          password: 'API key (Password)',
          region: 'Region',
        },
        hints: {
          name: 'Use this name to provide extra context in your list of connections.',
          username: 'The user name as defined in the SoftLayer Object Storage account credentials.',
          password: 'The API Key (Password) as defined in the SoftLayer Object Storage account credentials.',
          region: 'Select the geographical location of your SoftLayer Object Storage cluster.',
        },
        actions: {
          submit: 'Create SoftLayer Object Storage Connection',
          test: 'Test connection',
        },
      },
      swift: {
        title: 'New Swift Connection',
        labels: {
          name: 'Name',
          username: 'User name',
          password: 'API key (Password)',
          authentication_service: 'Authentication Endpoint',
          auth_method: 'Authentication Method',
          tenant_name: 'Tenant Name',
        },
        hints: {
          name: 'Use this name to provide extra context in your list of connections.',
          username:
            'The username you use to access the Swift service. If required by your provider, you might also have to enter the account in the following format: account:username. This format is not required when using a Tenant Name (see below).',
          password: 'The password assigned to your account.',
          authentication_service: 'The url of the authentication service used to authenticate you.',
          auth_method: 'The authorization system used by the identity service.',
          tenant_name:
            'A container used to group or isolate resources and/or identity objects, as defined by your Swift service provider.',
        },
        select: {
          options: {
            keystone: 'Keystone (v2.0)',
            swauth: 'Swauth (v1.0)',
          },
        },
        actions: {
          submit: 'Create Swift Connection',
          test: 'Test connection',
        },
      },
      mongo: {
        labels: {
          name: 'Name',
          tunnel_type: 'Access Type',
          hostname: 'Hostname',
          port: 'Port',
          read_preference: 'Read Preference',
          database: 'Database',
          username: 'User name',
          password: 'Password',
          unique_id: 'Unique ID',
          authentication_database: 'Authentication Database',
          connect_using_ssl: 'Connect using SSL',
          replica_member: 'Replica member hostname(s)',
          connection_type: "Connection Scheme"
        },
        hints: {
          name: 'Use this name to provide extra context in your list of connections.',
          tunnel_type: 'The method to use for accessing the database.',
          hostname: 'The name of the host to connect to.',
          port: 'The TCP port to connect to. The default is 27017.',
          read_preference: 'Determines how the connection should route read operations to members of a replica set.',
          database: 'The name of database to use.',
          username: 'The database user name.',
          password: 'The database user password.',
          authentication_database:
            'The name of the database to use for authentication. Leave empty to use default database.',
        },
        selects: {
          tunnel_type: {
            options: {
              direct: 'Direct Connection',
              reverse: 'Reverse SSH Tunnel Connection',
              'ssh-tunnel': 'SSH Tunnel Connection',
            },
          },
          connection_scheme: {
            options: {
              "dns-seed-list": "DNS Seed List (SRV)",
              "replica-members": "Replica Set Members"
            }
          }
        },
        actions: {
          submit: 'Create MongoDB Connection',
          test: 'Test connection',
        },
        buttons: {
          remove_replica: 'Remove Replica Member',
          add_replica: 'Add Replica Member',
        },
      },
      netsuite: {
        labels: {
          name: 'Name',
          port: 'Service port',
          database: 'Service data source',
          role_id: 'Role ID',
          account_id: 'Account ID',
          unique_id: 'Unique ID',
          consumer_key: 'Consumer Key',
          consumer_secret: 'Consumer Secret',
          token_id: 'Token ID',
          token_secret: 'Token Secret',
        },
      },
      'google-ads': {
        labels: {
          name: 'Name',
          port: 'Service port',
          database: 'Service data source',
          role_id: 'Role ID',
          account_id: 'Account ID',
          unique_id: 'Unique ID',
          consumer_key: 'Consumer Key',
          consumer_secret: 'Consumer Secret',
          token_id: 'Token ID',
          token_secret: 'Token Secret',
        },
      },
      netsuitesoap: {
        labels: {
          name: 'Name',
          account_id: 'Account ID',
          unique_id: 'Unique ID',
          consumer_key: 'Consumer Key',
          consumer_secret: 'Consumer Secret',
          token_id: 'Token ID',
          token_secret: 'Token Secret',
        },
      },
      labels: {
        name: 'Name',
        tunnel_type: 'Access type',
        hostname: 'Hostname',
        ssh_host: 'SSH Hostname',
        ssh_username: 'SSH User name',
        ssh_port: 'SSH Port',
        warehouse: 'Warehouse',
        account_name: 'Account name',
        region: 'Region',
        port: 'Port',
        read_preference: 'Read preference',
        database: 'Database',
        username: 'User name',
        password: 'Password',
        unique_id: 'Unique ID',
        authentication_database: 'Authentication database',
        ssh_public_key: 'SSH Public Key',
        public_key: 'Public Key',
        connect_using_ssl: 'Connect using SSL',
        connect_using_certificate: 'Connect using mTLS',
        certificate_file: 'Certificate file <span class="text-muted">(postgres.crt)</span>',
        certificate_file_key: 'Private key <span class="text-muted">(postgres.key)</span>',
        certificate_file_root: 'CA cert <span class="text-muted">(root.crt)</span>',
        change: 'change',
        cancel: 'cancel',
        security_token: 'Security Token',
        instance_url: 'Instance URL',
        private_app_token: 'Private App Token',
        data_boost: 'Enable Data Boost',
        service_name: 'Service Name'
      },
      hints: {
        name: 'Use this name to provide extra context in your list of connections.',
        azure_user_name: 'For Azure DB, please use the following format: user@xp.database.windows.net',
      },
      googlecloudspanner: {
        labels: {
          host: 'Project ID',
          instance_id: 'Instance ID',
          database: 'Database',
        },
        sign_in_text: "Connect to your Google Cloud Spanner account by clicking the 'Authenticate' button.",
      },
      athena: {
        labels: {
          region: 'Region',
          s3_staging_dir: 'S3 staging directory',
          username: 'Access key ID',
          password: 'Secret access key',
        },
      },
      marketing_cloud: {
        labels: {
          client_id: 'Client ID',
          client_secret: 'Client Secret',
          subdomain: 'Subdomain',
          account_id: 'Account ID'
        }
      }
    },
  },
  designer: {
    controls: {
      actions: {
        zoom_in: 'Zoom in',
        zoom_out: 'Zoom out',
        full_screen: 'Full screen',
        fit_to_screen: 'Fit to Screen',
        run_job: 'Run job',
        save: 'Save',
        auto_align: 'Auto Align',
        x_console: 'X-Console',
        create_major_version: {
          success: 'Successfully created major version {version}',
        },
        import_json_package: {
          success: 'Successfully imported JSON package',
        },
        save_package: {
          success: 'Successfully saved package',
        },
      },
      menus: {
        file: {
          actions: {
            error_list: 'Show error list ...',
            import_package: 'Import package...',
            set_variables: 'Set variables...',
            save_and_copy: 'Save and make a copy',
          },
        },
        select: {
          title: 'Select',
          actions: {
            all: 'All',
            none: 'None',
            connected: 'Connected',
            copy: 'use <strong>^C</strong> to copy',
            paste: 'use <strong>^V</strong> to paste',
          },
        },
        add_component: {
          title: 'Add component',
          hint: '',
        },
      },
    },
    messages: {
      saved: 'The package has been saved.',
    },
  },
  'generic-list': {
    connections: {
      name: 'Name',
      type: 'Type',
      owner: 'Owner',
      date: 'Last modified',
    },
    workspaces: {
      id: '',
      name: 'Name',
      owner: 'Owner',
      last_modified: 'Last modified',
      status: '',
    },
    resources: {
      schedules: 'Schedules',
      packages: 'Packages',
      workspaces: 'Workspaces',
      jobs: 'Jobs',
      hooks: 'Service hooks',
      clusters: 'Clusters',
      connections: 'Connections',
    },
    labels: {
      search_btn_text: 'Search',
      sort: 'Sort by:',
      empty_search_title: 'No {type} found matching your query',
      empty_search_description: 'No {type} found matching:',
    },
    defaults: {
      search_placeholder: 'Search',
      empty_title: '',
      empty_description: '',
      new: '',
    },
    schedules: {
      owner: 'Owner',
      name: 'Name',
      repeat: 'Frequency',
      last_run: 'Last run',
      next_run: 'Next due',
    },
    packages: {
      owner: 'Owner',
      name: 'Name',
      workspace: 'Workspace',
      date: 'Last modified',
      run_job: '',
    },
    jobs: {
      id: 'ID',
      job: 'Job',
      package: 'Package',
      cluster: 'Cluster',
      runtime: 'Runtime',
      execution_time: 'Execution Time',
      status: 'Status',
    },
    members: {
      name: 'Name',
      role: 'Role',
    }
  },
  'component-form': {
    notify: {
      labels: {
        email: 'Recipients',
        subject: 'Subject',
        message: 'Message',
      },
    },
    'run-package': {
      title: 'Choose package',
    },
  },
  'form-controls': {
    'variable-control': {
      actions: {
        use_default: 'use default',
        system_default: 'system default',
      },
    },
  },
  shortcuts: {
    labels: {
      then: 'then',
      or: 'or',
    },
    list: {
      go_to_dashboard: 'Go to Dashboard',
      go_to_connections: 'Go to Connections',
      go_to_clusters: 'Go to Clusters',
      go_to_jobs: 'Go to Jobs',
      go_to_packages: 'Go to Packages',
      go_to_schedules: 'Go to Schedules',
      shortcuts: 'Open keyboard shortcut help',
      quick_find: 'Quick find',
      toggle_terminal: 'Toggle X-Console',
      category: {
        application: 'Application',
        navigation: 'Navigation',
        designer: 'Designer',
      },
      designer: {
        save: 'Save',
        select_all: 'Select all components',
        vertical_align: 'Auto-align components',
        undo: 'Undo',
        redo: 'Redo',
        cut: 'Cut',
        copy: 'Copy',
        paste: 'Paste',
        deselect_components: 'Deselect all components',
      },
    },
  },
  'assisted-search': {
    help: {
      title: 'Search for { resource }',
      prefix: 'Narrow your results with search modifiers ',
      suffix:
        "Press plus key <span assisted-search-modifier='+'' class='modifier'>+</span> to get all available modifiers.",
    },
  },
  'package-designer': {
    'edge-type-selector': {
      labels: {
        on: 'on',
        success: 'on {open}success{close}',
        failure: 'on {open}failure{close}',
        completion: 'on {open}completion{close}',
      },
    },
    'package-validation': {
      labels: {
        complete: 'Complete',
      },
    },
    'package-variables': {
      labels: {
        user_variables: 'User variables',
        system_variables: 'System variables',
      },
    },
  },
  'cluster-picker': {
    hints: {
      pick: 'Choose a cluster to run the job on or',
    },
    actions: {
      new: 'create a new one',
    },
    modals: {
      new_cluster: {
        title: 'New cluster',
        close: 'Back',
        save: 'Create Cluster',
      },
    },
  },
  'components-list': {
    labels: {
      sources: 'Sources',
      transformations: 'Transformations',
      destinations: 'Destinations',
      task: 'Choose task',
    },
  },
  debug: {
    labels: {
      components: 'Component',
      selected: 'Selected',
      edges: 'Edges',
      source: 'Source:',
      target: 'Target:',
      errors: 'Errors',
      history: 'History',
    },
  },
  'name-description-editor': {
    labels: {
      name: 'Name',
      description: 'Description',
    },
    actions: {
      add: 'Add a description',
      remove: 'Hide description',
    },
    placeholders: {
      name: '',
      description: '',
    },
  },
  navbar: {
    placeholders: {
      search: 'Filter',
    },
    actions: {
      new: 'New',
    },
  },
  plan: {
    checkout: {
      labels: {
        title: 'Prepforce',
        description: 'Data Integration Service. Simplified.',
        subscribe: 'Subscribe',
      },
    },
    checkout_confirmation: {
      labels: {
        title: 'Change your plan',
        hint: 'You are changing your current plan to the <b>{name}</b> plan. Plan changes take effect immediately',
        yes: 'Alright, change my plan',
        no: 'Cancel',
      },
      success_message: 'Your subscription has been updated.',
    },
    body: {
      labels: {
        node_hours: 'Node hours included',
        sandbox: 'Sandbox cluster included',
      },
    },
    details: {
      integrations: 'Unlimited integrations',
      additional_nodes: 'Additional node bundles <small>(packs of 100 node hours)</small>:',
      data_transfer: 'Unlimited data transfer',
      yes_you_get_that_right: 'Yes, you read that right!',
      accounts: 'Unlimited account users',
    },
    footer: {
      notes: {
        scheduler: '* Scheduler not available with sandbox clusters.',
        additional_nodes:
          '** If you exceed your monthly hours you will automatically be billed for an additional node bundle for your plan.',
      },
      features: {
        labels: {
          sandbox: 'Sandbox',
          clusters: 'Clusters',
          nodes_per_cluster: 'Nodes per cluster',
          members: 'Members',
        },
        values: {
          up_to: 'Up to',
          unlimited: 'Unlimited',
        },
      },
    },
    actions: {
      labels: {
        choose: 'Upgrade',
        active: 'Your Plan',
        integrations: 'See our integrations',
      },
    },
  },
  sidebar: {
    header: {
      title: 'Your accounts:',
      labels: {
        switch: 'Switch to',
      },
    },
    menu: {
      items: {
        dashboard: 'Dashboard',
        connections: 'Connections',
        clusters: 'Clusters',
        packages: 'Packages',
        jobs: 'Jobs',
        schedules: 'Schedules',
        settings: 'Settings',
        workspaces: 'Workspaces',
      },
    },
    'sub-menu': {
      headers: {
        'account-settings': 'Account Settings',
        'your-settings': 'Your Settings',
        'developer-settings': 'Developer Settings',
      },
      items: {
        switch: 'Switch to <br><strong>{ name }</strong>',
        information: 'Profile',
        billing: 'Billing',
        members: 'User Management',
        hooks: 'Service hooks',
        personal_information: 'Profile',
        usage: 'Usage',
        change_password: 'Password',
        mfa: 'Two-Factor Auth',
        notifications: 'Notifications',
        ssh_keys: 'SSH public keys',
        accounts: 'Accounts',
        language: 'Language',
        leave: 'Leave <br><strong>{ name }</strong>',
        tokens: 'Access tokens',
        'global-variables': 'Global Variables',
      },
    },
    accounts: {
      title: 'Accounts',
    },
    help: 'Help',
  },
  'cluster-view': {
    labels: {
      close: 'Back to clusters',
      cluster: 'Cluster',
      runtime: 'Runtime',
      execution_time: 'Execution Time',
      started: 'Started',
      completed: 'Compeleted',
      status: 'Status',
      creator: 'Creator',
      running_jobs: '<strong>Jobs:</strong> {count} running, {queued} queued',
      statuses: {
        pending: 'Pending',
        error: 'Error',
        creating: 'Creating',
        available: 'Available',
        scaling: 'Scaling',
        pending_terminate: 'Terminating',
        terminating: 'Terminating',
        terminated: 'Terminated',
        idle: 'Idle',
      },
    },
  },
  'job-view': {
    titles: {
      general: 'Job',
      variables: 'Job variables',
      progress: 'Job progress',
      errors: 'Job errors',
      outputs: 'Job outputs',
      tasks: 'Job tasks',
    },
    labels: {
      close: 'Back to jobs',
      cluster: 'Cluster',
      job: 'Job',
      runtime: 'Runtime',
      execution_time: 'Execution Time',
      started: 'Started',
      enqueued: 'Enqueued',
      completed: 'Compeleted',
      status: 'Status',
      creator: 'Creator',
      by: 'by',
      id: 'id',
      component: 'Component',
      records: 'Records',
      statuses: {
        idle: 'Idle',
        error: 'Error',
        stopped: 'Stopped',
        completed: 'Done',
        pending: 'Pending',
        running: 'Running',
        pending_stoppage: 'Stopping',
        stopping: 'Stopping',
        queued: 'Queued',
      },
    },
    variables: {
      'empty-text': 'Variables will be available on job completion.',
      headers: {
        variable: 'Variable name',
        expression: 'Expression',
        string_value: 'Value',
      },
    },
    tasks: {
      'empty-text': 'No tasks have been created yet',
    },
    outputs: {
      'empty-text': 'No outputs have been generated yet',
    },
  },
  'schema-editor': {
    lead: 'No fields have been added yet',
    actions: {
      add: 'Add item',
    },
    labels: {
      field: 'Field',
      alias: 'Alias',
      data_type: 'Data type',
    },
    types: {
      string: 'String',
      integer: 'Integer',
      int: 'Integer',
      long: 'Long',
      float: 'Float',
      double: 'Double',
      binary: 'Binary',
      boolean: 'Boolean',
      date_time: 'DateTime',
      datetime: 'DateTime',
      json: 'Map',
      array: 'Bag',
    },
  },
  'component-previewer': {
    actions: {
      preview_button: 'Preview',
    },
  },
  'sort-editor': {
    select: {
      options: {
        asc: 'Ascending',
        desc: 'Descending',
      },
    },
  },
  'packages-selector': {
    title: 'Packages',
    leads: {
      plural: "All packages will be executed in parallel making use of the cluster's parallel processing capacity.",
      single: 'Packages to Run',
    },
    hints: {
      single: 'Packages list must include at least one package.',
      plural: 'Add package to Run',
    },
    actions: {
      add: 'Add package',
    },
    modals: {
      edit_variables: {
        title: 'Edit package variables',
        close: 'Back to schedule',
        save: 'Save',
      },
    },
  },
  'variables-editor': {
    labels: {
      window: '',
      'union-1': 'Source 1 field name',
      'union-2': 'Source 2 field name',
      'cube-type': 'Group by',
      'cube-fields': 'Fields',
      'sort-by': 'Sort by',
      'partition-by': 'Partition by',
      'sort-direction': 'Direction',
      add_new: 'Add new',
      add_another: 'Add another',
      name: 'Field Name',
      alias: 'Alias',
      datatype: 'Datatype',
      variable: 'Variable',
      expression: 'Expression',
      string_value: 'String Value',
      'empty-list': 'The list is empty',
    },
    'empty-message': {
      'user-variables': 'No package variables are defined in package.',
      'secret-variables': 'No secrets are defined in package.'
    },
  },
  'schema-fields-importer': {
    'get-schema': 'Get schema',
    'refresh-schema': 'Refresh schema',
    'available-fields': 'Available fields',
    'selected-fields': 'Selected fields',
    'remove-all': 'remove all',
    dimensions: 'Dimensions',
    metrics: 'Metrics',
    'field-name': 'Field name',
    alias: 'Alias',
    'data-type': 'Data type',
  },
  'aggregate-variables-editor': {
    title: 'Functions',
  },
  'cube-variables-editor': {
    title: 'Cube and Rollup',
  },
  'fileter-variables-editor': {
    title: 'Filters',
  },
  'headers-editor': {
    title: 'Headers',
    key: 'Key',
    value: 'Value',
  },
  'join-variables-editor': {
    title: 'Join',
  },
  'package-variables-editor': {
    title: 'Edit package variables',
    buttons: {
      save: 'Save',
      cancel: 'Cancel',
      close: 'Close',
    },
    tabs: {
      user: 'Package',
      system: 'System',
      global: 'Global',
      secrets: 'Secrets',
    },
  },
  'partition-variables-editor': {
    title: 'Partition by',
  },
  'schema-fields-editor': {
    title: 'Selected fields',
  },
  'select-variables-editor': {
    title: 'Select',
  },
  'sort-variables-editor': {
    title: 'Sort by',
  },
  'union-variables-editor': {
    title: 'Union',
  },
  'variables-editor-row': {
    selects: {
      group_type: {
        options: {
          cube: 'Cube',
          rollup: 'Rollup',
        },
      },
      operator: {
        options: {
          teq: 'text equals',
          tneq: 'text not equals',
          matches: 'text maches',
          tise: 'text is empty',
          tisne: 'text is not empty',
          eq: '=',
          neq: '!',
          gt: '&gt;',
          gte: '&gt;=',
          lt: '&lt;',
          lte: '&lt;=',
          isn: 'is null',
          isnn: 'is not null',
        },
      },
      function_name: {
        options: {
          count: 'Count',
          count_distinct: 'Count distinct',
          count_star: 'Count all',
          hll: 'HLL',
          avg: 'Average',
          sum: 'Sum',
          min: 'Min',
          min_by: 'Min by',
          max: 'Max',
          max_by: 'Max by',
          var: 'VAR',
          varp: 'VARP',
          stdev: 'STDEV',
          stdevp: 'STDEVP',
          collect: 'Collect',
          first_value: 'First value',
          last_value: 'Last value',
          lead: 'Lead',
          lag: 'Lag',
          row_number: 'Row number',
          ntile: 'NTILE',
        },
      },
      order_type: {
        options: {
          asc: 'Ascending',
          desc: 'Descending',
        },
      },
      data_type: {
        options: {
          string: 'String',
          int: 'Integer',
          long: 'Long',
          float: 'Float',
          double: 'Double',
          binary: 'Binary',
          boolean: 'Boolean',
          datetime: 'DateTime',
          json: 'Map',
          array: 'Bag',
        },
      },
    },
    'package-default': 'Package default',
    'system-default': 'System default',
  },
  'window-variables-editor': {
    title: 'Window',
  },
  'generic-object': {
    ordering: {
      recently_created: 'Recently created',
      recently_updated: 'Recently updated',
      oldest_created: 'Oldest created',
      oldest_updated: 'Oldest updated',
      by_name: 'By name',
    },
  },
  'account-usage': {
    'current-usage-text':
      ' { distributed } distributed and { sandbox } sandbox node hours since { date }',
    'current-usage-label': 'Current usage:',
    distributed: ' { hours } distributed node hours in the last { days } days',
    sandbox: ' { hours } sandbox node hours in the last { days } days',
    alert: 'No data available',
    'distributed-node-hours': 'distributed node hours',
    'sandbox-node-hours': 'sandbox node hours',
    'time-period': {
      'last-7-days': 'Last 7 days',
      'last-28-days': 'Last 28 days',
      'last-90-days': 'Last 90 days',
      'last-365-days': 'Last 365 days',
    },
  },
  roles: {
    admin: {
      name: 'Admin',
      description: 'View, Update, Operate, Manage',
    },
    member: {
      name: 'Member (legacy)',
      description: 'View, Update, Operate',
    },
    owner: {
      name: 'Owner',
      description: 'Owner of the account',
    },
    reader: {
      name: 'Reader',
      description: 'View',
    },
    editor: {
      name: 'Editor',
      description: 'View, Update',
    },
    operator: {
      name: 'Operator',
      description: 'View, Update, Operate',
    },
  },
  terminal: {
    greetings: 'Welcome to X-Console!',
  },
  auth: {
    thank_you: {
      title: 'Thank you for signing up for Prepforce by Integrate.io.',
      subtitle: 'Please check your inbox for an email from Prepforce by Integrate.io that includes an activation link for your account.',
    },
    sign_in: {
      title: 'Sign in to Prepforce by Integrate.io.',
      labels: {
        dont_have_account: "Don't have an account?",
        invalid_response: 'Invalid credentials.',
        enter_mfa: 'Enter a 2FA code to complete sign-in.',
        sign_up: 'Not already a user? Sign up here',
      },
      actions: {
        forgot_password: 'Forgot password?',
        sign_up: 'Sign up',
        use_sso: 'Sign in with SSO',
        use_password: 'Sign in with password',
      },
      form: {
        title: 'Sign in to Prepforce by Integrate.io.',
        labels: {
          email: 'Email',
          password: 'Password',
        },
        placeholders: {
          email: 'Email',
          password: 'Password',
        },
        actions: {
          sign_in: 'Sign in',
        },
      },
    },
    sign_up: {
      title: 'Sign Up',
      form: {
        title: 'Get started with Prepforce by Integrate.io',
        title_dpwc: 'Get started with Prepforce for the Data Pipeline World Championship',
        labels: {
          name: 'Name',
          email: 'Email',
          'business-email': 'Business email',
          company: 'Company',
          phone: 'Phone',
          have_account: 'Have an account? ',
        },
        placeholders: {
          name: 'Your name',
          email: "You'll use this to login",
          company: "Company name",
          phone: "Phone number",
        },
        actions: {
          sign_up: 'Sign up',
          sign_in: 'Sign in',
        },
      },
    },
    forgot_password: {
      title: 'Forgot password',
      form: {
        'sub-title': 'To reset your password, enter the email address you use to sign in Prepforce by Integrate.io',
        title: 'Password reset',
        labels: {
          email: 'Email',
        },
        placeholders: {
          email: 'Email',
        },
        actions: {
          reset_password: 'Get reset link',
        },
        success_message_title: 'Reset link sent!',
        success_message:
          "You will receive an email shortly with a password recovery link. If you don't receive an email, and it's not in your spam folder this could mean you signed up with a different address.",
      },
    },
    confirmation: {
      title: 'Welcome!',
      form: {
        title: 'Welcome!',
        labels: {
          name: 'Account name',
          region: 'Account region',
          email: 'Email',
          password: 'Password',
          password_confirmation: 'Password confirmation',
          user_receive_newsletter: 'Send me a monthly newsletter featuring Prepforce news and events.',
        },
        placeholders: {
          name: 'Account name',
          region: 'Select region',
          password: 'Password',
          password_confirmation: 'Password confirmation',
        },
        hints: {
          name: 'Name your account with your business name or organization.',
          region: 'Contact support@integrate.io if you would like to use a different region',
          password: 'To set up your account, please enter a password. Password must contain at least 12 characters, at least one uppercase letter, one lowercase letter and one number.',
        },
        actions: {
          create_user: 'Create user',
        },
      },
    },
    'reset-password': {
      title: 'Choose a new password',
      labels: {
        pass: 'Type new password',
        confirm: 'Retype new password',
      },
      actions: {
        reset: 'Reset My Password',
      },
    },
  },
  hook: {
    'generic-object': {
      title: 'Create a service hook',
      empty: {
        title: 'No service hooks have been created yet',
        description: "You can create new service hooks by clicking the 'New service hook' button.",
      },
      placeholders: {
        search: 'Search for service hooks',
      },
      buttons: {
        new: 'New service hook',
        close: 'Back to service hooks',
        save: 'Create service hook',
      },
    },
    'generic-list': {
      item: {
        actions: {
          edit: 'Edit service hook ...',
          delete: 'Delete service hook',
          ping: 'Ping service hook',
        },
        labels: {
          success_ping: 'Ping event was sent.',
          inactive: 'Inactive',
          active: 'Active',
        },
        modals: {
          edit_hook: {
            title: 'Edit service hook',
            close: 'Back to service hooks',
            save: 'Save changes',
          },
          confirm: {
            title: 'Delete Service Hook',
            hint: 'Are you sure you want to delete this service hook? This cannot be undone.',
            yes: 'Yes, delete this service hook',
            no: 'Cancel',
          },
        },
      },
    },
    form: {
      title: 'Choose hook type',
      titles: {
        create: 'Create a service hook',
        edit: 'Edit service hook',
      },
      buttons: {
        create: 'Create service hook',
        update: 'Save changes',
      },
      state: {
        active: 'ON',
        inactive: 'OFF',
      },
      hint: 'Which events would you like to trigger this service hook?',
      web: {
        title: 'Webhook',
        labels: {
          name: 'Name',
          url: 'Webhook URL',
          salt: 'Secret',
        },
        hints: {
          name: 'Use this name to provide extra context in your list of service hooks.',
          url: 'The URL for the webhook.',
          salt:
            "The secret salt for the webhook.",
        },
        checkbox: 'Active',
      },
      slack: {
        title: 'Slack',
        labels: {
          name: 'Name',
          team: 'Team',
          channel: 'Channel',
          url: 'Slack webhook URL',
        },
        hints: {
          name: 'Use this name to provide extra context in your list of service hooks.',
          team: 'The name of the Slack team to post in.',
          channel: 'The name of the channel to post in.',
          url: 'The full URL for the Slack API.',
        },
        checkbox: 'Active',
      },
      pagerduty: {
        title: 'PagerDuty',
        labels: {
          name: 'Name',
          pd_account: 'PagerDuty account',
          service_key: 'Service Key',
          service_name: 'Service Name',
        },
        hints: {
          name: 'Use this name to provide extra context in your list of service hooks.',
          pd_account: 'Your PagerDuty account name.',
          service_key: 'Unique service identifier, used by Prepforce to trigger incidents.',
          service_name: 'The name of the PagerDuty service to post to.',
        },
        checkbox: 'Active',
      },
      email: {
        title: 'Email',
        labels: {
          name: 'Name',
          emails: 'Emails',
        },
        hints: {
          name: 'Use this name to provide extra context in your list of service hooks.',
          emails: 'The recipient email address. Separate multiple addresses with commas.',
        },
        checkbox: 'Active',
      },
    },
    types: {
      web: 'Webhook',
      slack: 'Slack',
      pagerduty: 'Pagerduty',
      email: 'Email',
    },
  },
  workspace: {
    controller: {
      modals: {
        edit: {
          actions: {
            save: 'Done',
            close: 'Back to workspaces',
          },
        },
        component_menu: {
          actions: {
            description: '',
            title: '',
            close: 'Back to workspaces',
            save: 'Done',
          },
        },
        edit_packages: {
          actions: {
            title: 'Edit workspace',
            close: 'Back to workspaces',
            save: 'Save changes',
          },
        },
      },
    },
    'generic-object': {
      title: 'New workspace',
      empty: {
        title: 'No workspaces have been created yet',
        description: "",
      },
      placeholders: {
        search: 'Search for workspaces',
      },
      buttons: {
        new: 'New workspace',
        close: 'Back to workspaces',
        save: 'Create workspace',
      },
    },
    'generic-list': {
      item: {
        actions: {
          edit: 'Edit workspace',
          rename: 'Rename workspace',
          delete: 'Delete workspace',
        },
        labels: {
          modified: 'Modified',
          owned: 'Owned by',
          back: 'Back to workspaces',
          'last-edit': "Last edit ",
          by: " by ",
          'packages-length':'{length, plural, one {1 package} other{# packages}} in this workspace',
          'packages-failed': '{length, plural, one {1 package} other{# packages}} failed on last run',
          'packages-stopped': '{length, plural, one {1 package} other{# packages}} stopped on last run',
          'packages-completed': '{length, plural, one {1 package} other{# packages}} completed on last run',
        },
        modals: {
          confirm: {
            title: 'Delete Workspace',
            hint: 'Are you sure you want to delete the workspace? <br/> Note: This would only delete the workspace, not the packages.',
            yes: 'Yes, delete this workspace',
            no: 'Cancel',
          },
        },
      },
    },
    list: {
      title: 'Workspaces',
    },
    form: {
      new: {
        title: 'Create a Workspace',
        actions: {
          create: 'Create workspace',
        },
        placeholders: {
          name: 'Untitled workspace',
        },
      },
      edit: {
        title: 'Edit Workspace',
        actions: {
          cancel: 'Cancel',
          submit: 'Okay',
        },
      },
      buttons: {
        create: 'Create workspace',
        update: 'Save changes',
        rollback: 'Rollback version',
      },
    },
  },
  package: {
    controller: {
      modals: {
        edit: {
          actions: {
            save: 'Done',
            close: 'Back to package designer',
          },
        },
        edit_variables: {
          actions: {
            title: 'Edit package variables',
            close: 'Back to package designer',
            save: 'Done',
          },
        },
        component_menu: {
          actions: {
            description: '',
            title: '',
            close: 'Back to package designer',
            save: 'Done',
          },
        },
        edit_name: {
          actions: {
            title: 'Rename this package',
            close: 'Back to package designer',
            save: 'Rename package',
          },
        },
        change_workspace: {
          actions: {
            title: 'Workspace',
            close: 'Back to package designer',
            save: 'Save changes',
          },
        },
        run_job: {
          actions: {
            title: 'Run job',
            close: 'Back to package designer',
            save: 'Run now',
          },
        },
        import_json: {
          actions: {
            title: 'Package JSON',
            save: 'Import',
          },
        },
        major_version: {
          actions: {
            title: 'Package Version',
            save: 'Create',
          },
        },
      },
    },
    'generic-object': {
      title: 'Create a package',
      empty: {
        title: 'No packages have been created yet',
        description: "You can create new packages by clicking the 'New package' button.",
      },
      placeholders: {
        search: 'Search for packages',
        'search-workspaces': 'Search for packages in {workspace} workspace',
      },
      buttons: {
        new: 'New package',
        close: 'Back to packages',
        close_to_workspaces: 'Back to workspaces',
        save: 'Create package',
      },
    },
    'package-designer': {
      buttons: {
        close: 'Back to package designer',
      }
    },
    'generic-list': {
      item: {
        actions: {
          run: 'Run job ...',
          edit: 'Edit package ...',
          'edit-new': 'Edit package (BETA)',
          rename: 'Rename package ...',
          duplicate: 'Duplicate package',
          'add-to-workspace': 'Add to workspace',
          'change-workspace': 'Change workspace',
          archive: 'Archive package',
          delete: 'Delete package',
          rollback: 'Rollback version',
        },
        labels: {
          modified: 'Modified',
          owned: 'Owned by',
          run_job: 'Run Job',
          inactive: 'Archived',
          version: 'Package versioning',
        },
        modals: {
          run_job: {
            title: 'Run Job',
            description: 'Choose package and cluster',
            close_to_packages: 'Back to packages',
            close_to_clusters: 'Back to clusters',
            save: 'Run job',
          },
          confirm: {
            title: 'Archive Package',
            hint: 'Are you sure you want to archive this package?',
            yes: 'Yes, archive this package',
            no: 'Cancel',
          },
        },
      },
    },
    list: {
      title: 'Packages',
      actions: {
        variables: 'variables',
      },
    },
    templates: {
      title: 'Templates',
    },
    form: {
      new: {
        title: 'Create a package',
        labels: {
          template: 'Template',
          choose_type: 'Choose type',
          blank_template: 'Blank',
          flow_type: 'Type',
          dataflow: 'Dataflow',
          workflow: 'Workflow',
          workflows: 'Workflows',
          dataflows: 'Dataflows',
        },
        actions: {
          create: 'Create package',
        },
        placeholders: {
          name: 'Untitled package',
        },
        hints: {
          template: 'Pick a template that suits your use case.',
          flow_type: "What's the purpose of this package?",
        },
      },
      edit: {
        title: 'Edit package',
        actions: {
          cancel: 'Cancel',
          submit: 'Okay',
        },
      },
      buttons: {
        create: 'Create package',
        update: 'Save changes',
        rollback: 'Rollback version',
      },
    },
    validation: {
      start: "We're validating your package, it should take about a minute.",
      failed: 'Package validation failed.',
      running: '',
      completed: 'Package validation completed and no errors found.',
      modal: {
        title: 'Package validation',
        cancel: 'Cancel',
      },
    },
  },
  connection: {
    'generic-object': {
      title: 'Create a connection',
      empty: {
        title: 'No connections have been created yet',
        description: "You can create new connections by clicking the 'New connection' button.",
      },
      placeholders: {
        search: 'Search for connections',
      },
      buttons: {
        new: 'New connection',
        close: 'Back to connections',
        save: 'Create connection',
        edit: 'Edit connection',
      },
    },
    'generic-list': {
      item: {
        actions: {
          edit: 'Edit connection ...',
          duplicate: 'Duplicate connection',
          delete: 'Delete connection',
        },
        modals: {
          confirm: {
            title: 'Delete Connection',
            hint: 'Are you sure you want to delete this connection? This cannot be undone.',
            yes: 'Yes, delete this connection',
            no: 'Cancel',
          },
        },
        tooltips: {
          'copy-unique-id': 'Copy unique ID',
        },
      },
    },
  },
  cluster: {
    'generic-object': {
      title: 'Create a cluster',
      empty: {
        title: 'No clusters have been created yet',
        description: "You can create new clusters by clicking the 'New cluster' button.",
      },
      placeholders: {
        search: 'Search for clusters',
      },
      buttons: {
        new: 'New cluster',
        close: 'Back to clusters',
        save: 'Create cluster',
      },
    },
    'generic-list': {
      item: {
        actions: {
          run: 'Run job',
          edit: 'Edit',
          terminate: 'Terminate',
        },
        hints: {
          running_jobs: 'running jobs',
        },
        labels: {
          sandbox: 'Sandbox',
          production: 'Production',
          managed: 'Managed',
          nodes: 'Nodes',
          confirm: 'Are you sure?',
          running_jobs: '<strong>Jobs:</strong> {count} running, {queued} queued',
          created_at: 'Created',
          by: 'by',
          time_to_idle: ' and will be terminated after ',
          time_to_idle_end: ' of inactivity',
          statuses: {
            pending: 'Pending',
            error: 'Error',
            creating: 'Creating',
            available: 'Available',
            scaling: 'Scaling',
            pending_terminate: 'Terminating',
            terminating: 'Terminating',
            terminated: 'Terminated',
            idle: 'Idle',
          },
        },
        modals: {
          run_job: {
            title: 'Run Job',
            description: 'CHOOSE PACKAGE AND CLUSTER',
            close_to_clusters: 'Back to clusters',
            close: 'Back to packages',
            save: 'Run Job',
          },
          edit_cluster: {
            title: 'Edit cluster',
            close: 'Back to clusters',
            save: 'Save',
          },
          confirm: {
            title: 'Terminate Cluster',
            hint: 'Are you sure you want to terminate this cluster? <br> This cannot be undone.',
            yes: 'Yes, terminate this cluster',
            no: 'Cancel',
          },
        },
        tooltips: {
          run_job: 'Run job',
          terminate: 'Terminate this cluster',
        },
      },
    },
    form: {
      lead: 'Choose the size of the cluste',
      titles: {
        new: 'Create a cluster',
        edit: 'Edit cluster',
      },
      labels: {
        re_use: 'Reuse',
        name: 'Name',
        node: 'Node',
        nodes: 'Nodes',
        sandbox: 'Sandbox',
        production: 'Production',
        after: 'After',
        slider: 'Choose the size of the cluster',
      },
      hints: {
        name: "Leave blank and we'll choose one for you.",
        timeout: 'Choose what to do with this cluster after being idle for some time',
        nodes: 'The more compute nodes you have running, the more parallel processing power you get.',
        sandbox: 'For development purposes, use the free sandbox cluster.',
        strategy: {
          self: 'Use a cluster created by this schedule if one is available. Otherwise, create a cluster.',
          any:
            "Use any existing cluster so long as it's at least as big as you set in the schedule's cluster size. Otherwise, create a cluster.",
          same_node:
            "Use any existing cluster with the same node count as you set in the schedule's cluster size. Otherwise, create a cluster.",
          least_jobs: "Use a cluster with the least number of jobs running and node size at least as big as the schedule's cluster size.",
          none: 'Create a new cluster every time the schedule is running.',
        },
      },
      placeholders: {
        name: 'Cluster name',
      },
      checkbox: 'Automatically terminate clusters when jobs complete',
      buttons: {
        create: 'Create cluster',
        update: 'Save changes',
      },
      select: {
        values: {
          minutes: '{number, plural, one {1 minute} other {# minutes}} of inactivity',
          hours: '{number, plural, one {1 hour} other {# hours}} of inactivity',
          days: '{number, plural, one {1 day} other {# days}} of inactivity',
        },
      },
      strategies: {
        self: 'Any cluster created by this schedule',
        any: 'Any similar cluster',
        same_node: 'Any similar cluster with the same node count',
        least_jobs: 'Cluster with the least number of jobs running',
        none: 'Never',
      },
      tooltips: {
        nodes: '{number, plural, =0{Sandbox (free)} other{# compute nodes}}',
      },
    },
    list: {
      title: 'Clusters',
      item: {
        labels: {
          running_jobs: 'running jobs',
          created_at: 'created at',
        },
      },
    },
    labels: {
      jobs: 'Jobs',
    },
  },
  delivery: {
    form: {
      title: 'New Delivery',
      subtitle:
        'Need help setting a data delivery? Read more about our <a target="_blank" href="https://www.xplenty.com/docs/how-to-create-a-delivery/">data delivery process</a> or ',
      'intercom-trigger': 'talk to human',
      steps: {
        source: {
          title: 'Choose your source',
          subtitle: 'First, choose the source to pull the data from:',
          properties: {
            salesforce: {
              info:
                'We will deliver all of the Salesforce objects (including custom objects and their corresponding fields) listed <a target="_blank" href="https://www.xplenty.com/docs/list-of-salesforce-objects/">here</a>.',
            },
            common: {
              package_designer_note:
                '<b>Note</b>: you can choose which objects or fields get loaded using our advanced <a target="_blank" href="https://www.xplenty.com/docs/working-in-the-new-package-designer/">package designer</a>.',
            },
          },
        },
        destination: {
          title: 'Choose your destination',
          subtitle: 'Next, choose the destination to store the data to:',
          properties: {
            redshift: {
              schema_name: 'Set a schema name',
              hints: {
                schema_name: "The target table's schema to be created. Leave blank and we'll use the default.",
              },
            },
          },
        },
        review: {
          title: 'Review and finish',
          button_label: 'Finish',
          greeting: 'Alright! 👏',
          summary:
            'You are a click away from getting your <b>{source}</b> data delivered into your <b>{destination}</b> <b>{interval}</b>.',
          finish: 'Clicking <b>Finish</b> will create all the required resources to keep your data in sync.',
        },
      },
    },
    notifications: {
      created: {
        title: 'Success',
        message: 'New Delivery has been created.',
      },
      error: {
        title: 'Error',
        message: 'Oops, something went wrong creating your delivery.',
      },
    },
  },
  schedule: {
    'generic-object': {
      title: 'Create a schedule',
      empty: {
        title: 'No schedules have been created yet',
        description: "You can create new schedules by clicking the 'New schedule' button.",
      },
      placeholders: {
        search: 'Search for schedules',
      },
      buttons: {
        new: 'New schedule',
        close: 'Back to schedules',
        save: 'Create schedule',
      },
    },
    'generic-list': {
      item: {
        titles: {
          edit: 'Edit schedule',
        },
        labels: {
          never: 'Never',
          package: 'Package',
          packages_count: '{count, plural, =0{0 packages} one{1 package} other{# packages}}',
          interval: 'every {interval_amount} {interval_unit}',
          intervals: {
            minutes: 'every {interval_amount, plural, =0{0 minutes} one{minute} other{# minutes}}',
            hours: 'every {interval_amount, plural, =0{0 hours} one{hour} other{# hours}}',
            days: 'every {interval_amount, plural, =0{0 days} one{day} other{# days}}',
            weeks: 'every {interval_amount, plural, =0{0 weeks} one{week} other{# weeks}}',
            months: 'every {interval_amount, plural, =0{0 months} one{month} other{# months}}',
          },
          inactive: 'Inactive',
          active: 'Active',
        },
        actions: {
          edit: 'Edit schedule ...',
          delete: 'Delete schedule',
          duplicate: 'Duplicate schedule',
          save: 'Save schedule',
          close: 'Back to schedules',
          run: 'Run one-off',
          set_active: 'Set <b>on</b>',
          set_inactive: 'Set as <b>inactive</b>',
        },
        modals: {
          confirm: {
            title: 'Delete Schedule',
            hint: 'Are you sure you want to delete this schedule? This cannot be undone.',
            yes: 'Yes, delete this schedule',
            no: 'Cancel',
          },
          run: {
            confirm: {
              title: 'Run Schedule One-Off',
              hint: 'This will trigger a one-off execution of this schedule. <br><b>This will not impact next due.</b>',
              yes: 'Alright, trigger this schedule',
              no: 'Cancel',
            },
          },
        },
      },
    },
    form: {
      titles: {
        new: 'New schedule',
        edit: 'Edit schedule',
        new_task: 'New task',
        edit_task: 'Edit task',
      },
      labels: {
        status: 'Status',
        start_at: 'Starts on (UTC)',
        repeat: 'Repeat every',
        cron: 'Cron expression',
        at: 'starts at',
      },
      tabs: {
        schedule: 'Schedule',
        cluster: 'Cluster',
        packages: 'Packages to run',
      },
      buttons: {
        create: 'Create schedule',
        update: 'Save changes',
      },
      checkbox: 'Allow concurrent schedule executions',
      state: {
        active: 'ON',
        inactive: 'OFF',
      },
      placeholders: {
        name: 'Untitled schedule',
      },
    },
    notifications: {
      submitted: {
        title: 'Schedule Submitted',
        message:
          '<strong>{ name }</strong> schedule one-off execution has been submitted.',
      },
    },
  },
  job: {
    'generic-object': {
      title: 'Run job',
      description: 'CHOOSE PACKAGE AND CLUSTER',
      empty: {
        title: 'No jobs have been executed yet',
        description: "You can start new jobs by clicking the 'New job' button.",
      },
      placeholders: {
        search: 'Search for jobs',
      },
      buttons: {
        new: 'Run job',
        close: 'Back to jobs',
        save: 'Run now',
      },
    },
    'generic-list': {
      item: {
        labels: {
          submitted: 'Submitted on',
          started: 'Started',
          created: 'Created',
          completed: 'Completed',
          confirmation: 'Are you sure?',
          pending: 'Pending',
          stopped: 'Stopped',
          pending_stoppage: 'Stopping',
          stopping: 'Stopping',
          queued: 'Queued',
          enqueued: 'Enqueued',
          idle: 'Idle',
          failed: 'Failed',
          running: 'Running',
          view_details: 'Details',
          nodes: '{count, plural, =0{Sandbox} one {1 node} other{# nodes}}',
        },
        actions: {
          variables: 'Job variables',
          schedule: 'Schedule this job',
          error: 'View errors',
          output: 'View outputs',
          progress: 'View progress',
          stop: 'Stop job',
        },
        modals: {
          output: {
            title: 'Job: #{ id }',
            close: 'Back to jobs',
            close_details: 'Back to parent job',
            save: 'Close',
          },
          error: {
            title: 'Job: #{ id }',
            close: 'Back to jobs',
            save: 'Close',
          },
          job_variables: {
            title: 'Edit job variables',
            close: 'Back to job list',
            save: 'Save',
          },
          schedule_job: {
            title: 'Schedule Job',
            description: 'CHOOSE PACKAGE AND CLUSTER',
            close: 'Back to jobs',
            save: 'Create Schedule',
          },
          confirm: {
            title: 'Stop Job',
            hint: 'Are you sure you want to stop this job?',
            yes: 'Yes, stop this job',
            no: 'Cancel',
          },
        },
      },
    },
    form: {
      title: 'Run a new Job',
      description: 'Choose package and cluster',
      labels: {
        package: 'Package',
        cluster: 'Cluster',
      },
      hints: {
        package: 'Choose a package to run',
      },
      buttons: {
        create: 'Run job',
        update: 'Run job',
      },
    },
    list: {
      item: {
        status: {
          completed: 'completed',
          stopped: 'stopped (warning)',
          in_progress: 'in progress',
          failed: 'failed',
        },
        labels: {
          started_at: 'started at',
        },
      },
    },
    labels: {
      creator: 'Creator',
      owner: 'Owner:',
      package: 'Package',
      output: 'Outputs',
      error_log: 'Error log',
      close: 'Back to jobs',
      cluster: 'Cluster',
      job: 'Job',
      runtime: 'Runtime',
      execution_time: 'Execution Time',
      started: 'Started',
      completed: 'Completed',
      status: 'Status',
    },
    notifications: {
      submitted: {
        title: 'Job Submitted',
        message:
          'Job <strong>#{ id }</strong> (<strong>{ package }</strong>) on cluster <strong>{ cluster }</strong> was submitted for execution.',
      },
    },
  },
  member: {
    'generic-object': {
      title: 'Invite new member',
      empty: {
        title: 'No members have been invited yet',
        description: "You can invite new members by clicking the 'Invite new member' button.",
      },
      placeholders: {
        search: 'Search for members',
      },
      buttons: {
        new: 'Invite new member',
        close: 'Back to members',
        save: 'Invite member',
        edit: 'Edit member roles',
        update: 'Update member',
      },
    },
    'generic-list': {
      item: {
        current: '(you)',
        actions: {
          delete: 'Remove this member',
          leave: 'Leave this account',
          edit: 'Edit this member',
        },
        modals: {
          leave: {
            confirm: {
              title: 'Leave Account',
              hint: 'Are you sure you want to leave this account?',
              yes: 'Yes, leave this account',
              no: 'Cancel',
            },
          },
          delete: {
            confirm: {
              title: 'Remove Member',
              hint: 'Are you sure you want to remove this member?',
              yes: 'Yes, remove this member',
              no: 'Cancel',
            },
          },
        },
        notifications: {
          role_updated: {
            title: 'Member Role Updated',
            message:
              '<strong>{ name }</strong> is now { role }. Reloading the page, please wait ...',
          },
        },
      },
    },
    form: {
      text: 'Add member to your account',
      labels: {
        name: 'Full name',
        email: 'Email',
        role: 'Role',
      },
      placeholders: {
        name: 'Full name',
        email: 'name@domain.com',
      },
      buttons: {
        create: 'Invite member',
        update: 'Save changes',
      },
      success_message: 'Your invitation has been sent.',
    },
  },
  account: {
    'generic-object': {
      title: 'Create an account',
      empty: {
        title: 'No accounts have been created yet',
        description: "You can create new accounts by clicking the 'New account' button.",
      },
      placeholders: {
        search: 'Search for accounts',
      },
      buttons: {
        new: 'New account',
        close: 'Back to accounts',
        save: 'Create account',
      },
    },
    'generic-list': {
      item: {
        current: '(current)',
        labels: {
          settings: 'Settings',
          members: 'Members',
          connections: 'Connections',
          leave: 'Leave',
        },
      },
    },
    form: {
      title: 'Create a new account',
      labels: {
        name: 'Account name',
        region: 'Region',
      },
      hints: {
        name: 'Name your account with your business name or organization.',
        region: 'Contact support@integrate.io if you would like to use a different region',
        trial:
          'The newly created account will be in 7 day trial mode. You can set it up and activate it at your own pace.',
      },
      placeholders: {
        name: 'Account name',
      },
      buttons: {
        create: 'Create account',
        update: 'Save changes',
      },
    },
    settings: {
      success_message: 'Your account settings have been updated.',
      addons: {
        title: 'Add-Ons',
        actions: {
          new: 'New Add-On',
        },
        lead: 'No add-ons.',
        hint: 'Use the new add-on button to add one.',
      },
      delete: {
        title: 'is this really goodbye? :(',
        hints: {
          confirm:
            "Deleting your account is irreversible. Enter your account's name (<code>{ name }</code>) below to confirm you want to permanently delete it:",
        },
        placeholders: {
          'account-name': 'Account name',
        },
        actions: {
          delete: 'Delete account',
          cancel: 'Cancel',
        },
      },
      hooks: {
        title: 'Service Hooks',
        labels: {
          web_hook_url: 'Webhook URL',
        },
        hints: {
          events: 'Which events would you like to trigger this service hook?',
        },
        descriptions: {
          web:
            'Our Webhooks integration enable you to receive real-time updates about your account activity from Prepforce',
          slack:
            'Our Slack integration enables you to receive real-time updates about your account activity into your team inbox',
          pagerduty: 'Our PagerDuty integration enables you to receive real-time alerts about your account activity',
          email: 'Our Email integration enables you to receive real-time email alerts about your account activity',
        },
        events: {
          job: {
            all: 'All job notifications',
            submitted: 'Job submitted',
            started: 'Job started',
            stopped: 'Job stopped',
            completed: 'Job completed',
            failed: 'Job failed',
          },
          cluster: {
            all: 'All cluster notifications',
            requested: 'Cluster requested',
            available: 'Cluster available',
            terminated: 'Cluster terminated',
            idled: 'Cluster idled',
            error: 'Cluster error',
          },
        },
        actions: {
          submit: 'Add',
        },
        list: {
          empty: {
            lead: 'No service hooks.',
            hint: "Use the 'New service hook' button to add one.",
          },
        },
      },
      info: {
        title: 'Information',
        labels: {
          name: 'Account name',
          account_id: 'Account ID',
          region: 'Region',
          location: 'Location',
          billing_email: 'Billing email',
          gravatar_email: 'Gravatar email (private)',
          public_key: 'Public key',
        },
        hints: {
          name: 'Name your account with your business name or organization.',
          account_id: 'Used to uniquely identify your account.',
          account_id_change: 'Changing account id can have unintended side effects.',
          region: 'Contact support@integrate.io if you would like to use a different region. To use a region not on the dropdown list above, contact <a href="mailto:support@integrate.io">support@integrate.io</a>',
          location: 'Let others on your team know where your organization is located.',
          gravatar_email:
            "We will use your <a href='http://en.gravatar.com/'>Gravatar</a> profile photo if one exists with this email address.",
          public_key:
            "You'll need this key to allow Prepforce access for SSH tunnel connection type and for data repositories that require key-based authentication (e.g. SFTP).",
        },
        actions: {
          submit: 'Save changes',
        },
        owner: {
          title: 'Close Account',
          actions: {
            delete: 'delete your account',
          },
          hints: {
            'pre-action': "We'd be sorry to see you go, but you can",
            'post-action': 'at any time.',
          },
        },
      },
      members: {
        title: 'Members',
      },
      usage: {
        title: 'Account usage',
      },
      plans: {
        title: 'Available Plans',
        hint:
          "Billing or plan queries? We're here to help! Write to us <a data-track-event='click' data-category='Billing' data-action='Live support' data-label='Give us a shout' data-behavior='contact-support' href='javascript:'>here</a> or schedule a time for a call <a href='https://calendly.com/xplenty-etl-pipelines/xplenty-call'>here</a>.",
        billing: {
          title: 'Billing information',
          labels: {
            partner: 'This account is billed through',
            no_credit_card:
              "No credit card on file. Click <a data-behavior='card-payment' ng-click='updateCreditCard()' href='javascript:void(0)' >here</a> to add a credit card.",
            account_is_billed_to_card:
              'This account is billed to <b>{ card_type } ending in { card_last_4 }</b> • <b>{ expiration_date }</b>',
            update_credit_card: 'Update payment method',
            view_invoices: 'View billing history',
          },
        },
        qa: {
          title: 'Pricing FAQs:',
          q1: 'So, what is a node hour?',
          a1:
            'Your cluster size, measured in nodes, multiplied by the number of hours that the cluster was up and running, equals the total node hours. Partial hours are billed as a full hour. For example, you have a nightly job that requires a two-node cluster and that finishes after 1.5 hours. This would be calculated at 2 hours per node, meaning that your nightly job is consuming 4 node hours every night. This comes out to about 120 node hours per month. Our Starter plan would be the way to go for this volume of usage.',
          q2: 'What is a cluster?',
          a2:
            "An Prepforce cluster is a group of machines (aka nodes) that is allocated exclusively to your account's users. You can create one or more clusters, and you can run one or more jobs concurrently on each cluster. A cluster that you have created is 'owned' by your account until you request that we terminate your cluster. The more nodes you have running, the more parallel processing power you get.",
          q3: 'How do I know how many node hours I need?',
          a3:
            "That's what our trial is good for, and because every case is different when it comes to data size, complexity of processes, number of processes, network latency and bandwidth, we can help you work it out. Drop us a note or <a data-track-event='click' data-category='Billing FAQ' data-action='Live support' data-label='speak to a live support engineer now' data-behavior='contact-support' data-message='Hey there! I would like to get some information on cluster sizing. Thanks!' href='javascript:'>speak to a live support engineer now</a>.",
          q4: 'Why does Prepforce charge per hour instead of per event (record or data volume)?',
          a4:
            'We are all about providing you with the most powerful and flexible solution, and with Prepforce, you can do a lot more than just move your data. Your data can be compressed or uncompressed, you can join it with data from another data sources and tons more.<br>For example, you might need to read 200 million records to extract a specific record. So, if we charged you per record, you would end up paying a lot more. Instead, we provide you with unlimited record processing and provide a pack of hours for you to use for whatever data flows you want to run.',
          q5: 'What happens if I use more than my monthly pack of hours?',
          a5:
            'Your jobs will keep on running and the Prepforce service will continue to run your jobs. You will automatically be charged for an additional bundle of 100 node hours. Each plan has a different rate for these bundles.',
          q6: 'Are unused prepaid node hours rolled over to following month?',
          a6: 'No, unused node hours are not rolled over.',
          q7: 'What about my additional bundle hours, will unused hours be rolled over to the following month?',
          a7: 'Yes, additional bundle hours that are unused will be rolled over to the following month.',
          q8: 'A sandbox cluster is included in all plans. How is this cluster type different from a regular cluster?',
          a8:
            "All plans include a free sandbox cluster for testing jobs with relatively small amounts of data during the package development cycle. The only difference between a sandbox cluster and a single node cluster is that you can't schedule jobs to execute on it automatically.",
          q9: 'What if cluster goes bad?',
          a9:
            "Send it to its room for a time-out. No, if the cluster goes bad, we won't charge you for that period of time. If the cluster time is mistakenly counted against your hours, just let us know.",
          q10: 'How can I pay for your service?',
          a10:
            'We accept Visa, MasterCard and American Express. We charge a monthly subscription fee, billed annually.',
          q11: 'Do you offer discounts for annual subscriptions?',
          a11:
            "We sure do. <a data-track-event='click' data-category='Billing FAQ' data-action='Live support' data-label='Contact us' data-behavior='contact-support' data-message='Hey there! I would like to get more information on discounts for annual subscriptions. Thanks!' href='javascript:'>Contact us</a> for more details.",
          q12: 'We are an educational institution or a non-profit. Is special pricing available?',
          a12:
            "Yes, of course. <a data-track-event='click' data-category='Billing FAQ' data-action='Live support' data-label='Contact us' data-behavior='contact-support' data-message='Hey there! I would like to get more information on special pricing for educational institution or a non-profit. Thanks!' href='javascript:'>Contact us</a> for more details.",
          q13: 'How can I cancel my subscription?',
          a13:
            "We hate to see you go, but of course, you can cancel your Prepforce plan anytime. Just <a data-behavior='freeze-account' href='javascript:'>click here</a> to freeze/cancel your account. The cancellation is immediate. You can still set up packages but you will no longer be able to create clusters or run jobs. At the end of your subscription cycle, we will automatically terminate any clusters 'owned' by your account. You can restart your subscription anytime with all your packages, connections, web hooks and other settings intact.",
        },
      },
      leave: {
        title: 'Leave Account',
        lead: 'You are about to leave the account <strong>{name }</strong>.',
        confirmation: 'You will lose any access to the account. Are you SURE?',
        actions: {
          leave: 'Leave',
          cancel: 'Cancel',
        },
      },
    },
    item: {
      title: 'Profile',
      header: {
        list: {
          item: {
            information: 'Information',
            plans_and_billing: 'Plans & Billing',
            members: 'Members',
          },
        },
      },
      form: {
        labels: {
          member_since: 'Member since',
          region: 'Region',
        },
        placeholders: {
          name: 'Account name',
          id: 'Account ID',
          location: 'Location',
          billing_email: 'Billing email (Private)',
          gravatar_email: 'Gravatar email (Private)',
        },
        actions: {
          save: 'Save changes',
          delete: 'Delete your account',
          gravatar_email: 'Change gravatar',
        },
        hints: {
          d1: "We'd be sorry to see you go, but you can",
          d2: 'at any time.',
        },
      },
    },
    labels: {
      accounts: 'Accounts',
    },
    usage: {
      tooltip: {
        labels: {
          distributed_node_hours: 'distributed node hours',
          sandbox_node_hours: 'sandbox node hours',
        },
      },
      time_periods: {
        last_x_days: 'Last {x} days',
      },
    },
  },
  tokens: {
    title: 'API key',
    description:
      "These credentials allow applications to access the <a target='_blank' href='https://github.com/xplenty/xplenty-api-doc-v2'>Prepforce API</a>. They can be used to <a href='https://github.com/xplenty/xplenty-api-doc-v2#authentication' target='_blank'>authenticate to the Prepforce API over Basic Authentication</a>. Please don't share your credentials with anyone, include them in public code repositories, or store them in insecure ways. If you think your credentials might have been compromised, you should generate a new one.",
    confirmation: 'Are you sure?',
    confirm: {
      title: 'Regenerate API key',
      hint:
        'Are you sure you want to regenerate your API key? This action will cause any applications using it to stop functioning.',
      yes: 'Yes, regenerate API key',
      no: 'Cancel',
    },
    form: {
      'error-message-text': 'Sorry, seems like the password is incorrect.',
      'sso-error-message-text': 'You cannot reveal your API key if you use Single Sign-On.',
      label: 'Enter your password below to reveal your API key:',
      placeholder: 'Password',
      button: 'Reveal API key',
      'button-reset': 'Regenerate API key ...',
    },
  },
  global_variables: {
    title: 'GLOBAL VARIABLES',
    description: 'Global variables are automatically added to all packages on this account. Package variables take precedence over global variables.',
    success_message: 'Global variables have been updated',
  },
  ssh_key: {
    'generic-object': {
      title: 'Create a SSH public key',
      empty: {
        title: 'No SSH public keys have been created yet',
        description: "You can create new SSH public keys by clicking the 'New SSH public key' button.",
      },
      placeholders: {
        search: 'Search for keys',
      },
      buttons: {
        new: 'New SSH public key',
        close: 'Back to SSH public keys',
        save: 'Create SSH public key',
      },
    },
    'generic-list': {
      item: {
        labels: {
          added: 'Added ',
        },
        actions: {
          delete: 'Delete this SSH public key',
        },
        modals: {
          confirm: {
            title: 'Delete SSH Public Key',
            hint:
              'Are you sure you want to delete this SSH public key? This will invalidate any access authorized to Prepforce by this key.',
            yes: 'Yes, delete this SSH public key',
            no: 'Cancel',
          },
        },
      },
    },
    form: {
      title: 'Create a SSH public key',
      buttons: {
        create: 'Create SSH public key',
        update: 'Save changes',
      },
      labels: {
        name: 'Name',
        key: 'Public key',
      },
      hints: {
        name:
          "Use this name to provide extra context in your list of keys. Leave blank and we'll use the public key comment part.",
        key: "Public key should begin with 'ssh-rsa' or 'ssh-dss'.",
      },
      placeholders: {
        name: 'Name',
        key: "Begin with 'ssh-rsa'",
      },
    },
    labels: {
      ssh_keys: 'SSH Public Keys',
    },
  },
  user: {
    settings: {
      info: {
        title: 'Personal information',
        labels: {
          email: 'Email',
          name: 'Full name',
          location: 'Location',
          time_zone: 'Time zone',
          gravatar_email: 'Gravatar email (private)',
        },
        checkbox: 'Send me a monthly newsletter featuring Prepforce news and events.',
        actions: {
          submit: 'Save changes',
        },
        hints: {
          time_zone: 'Prepforce uses your time zone for times in your activity feeds.',
          location: 'Let others on your team know where you are located.',
          gravatar_email:
            "We will use your <a href='http://en.gravatar.com/'>Gravatar</a> profile photo if one exists with this email address.",
        },
        success_message: 'Your profile has been updated.',
        email_update_message: 'A confirmation link has been sent to your new email address. Please click on the link to complete the address change.',
      },
      language: {
        title: 'Language',
      },
      notifications: {
        title: 'Notifications',
        lead: 'Get notifications on important updates to any of the clusters or jobs I am watching:',
        actions: {
          submit: 'Save settings',
        },
        checkboxes: {
          email: 'Email',
          xplenty: 'On Prepforce by Integrate.io',
        },
        success_message: 'Your notification settings have been updated.',
      },
      password: {
        labels: {
          current_password: 'Current password',
          new_password: 'New password',
          new_password_confirm: 'Confirm new password',
        },
        actions: {
          submit: 'Save password',
        },
        validations: {
          not_confirmed: 'Your password and confirmation password do not match.',
          password_blank: 'Please enter new password',
          minlength: 'Password must contain at least 10 characters.',
        },
        success_message: 'Your password has been updated successfully.',
      },
      mfa: {
        title: 'Two-Factor Authentication',
        labels: {
          mfa_enabled: 'Two-factor authentication is <b>enabled</b>',
          encouragement: 'Enable Two-Factor Authentication to give your Prepforce account an extra layer of security.',
          lost_device:
            'Lost your authentication device? Simply disable Two-Factor authentication below, then re-enable it with a new device.',
        },
        steps: {
          get_app: {
            title: 'Get the app.',
            subtitle:
              'Download <a class="linkOpensNewTab" target="_blank" href="https://support.google.com/accounts/answer/1066447">Google Authenticator</a>, <a class="linkOpensNewTab" target="_blank" href="https://authy.com/download/">Authy</a>, or <a class="linkOpensNewTab" target="_blank" href="https://www.salesforce.com/solutions/mobile/app-suite/security/">Salesforce Authenticator</a> on your phone.',
          },
          scan_qr: {
            title: 'Scan the QR code below.',
          },
          verify_device: {
            title: 'Verify your device.',
            subtitle: 'Enter the code to confirm enrolment.',
          },
        },
        actions: {
          enable: 'Enable',
          disable: 'Disable',
        },
      },
    },
    menu: {
      title: 'Your accounts',
      actions: {
        sign_out: 'Sign out',
      },
    },
  },
  'url-editor': {
    placeholder: 'https://swapi.dev/api/planets',
    method: {
      get: 'GET',
      post: 'POST',
      patch: 'PATCH',
      put: 'PUT',
      delete: 'DELETE',
    },
  },
  'form-submit-button': {
    'create-text': 'Create',
    'update-text': 'Save changes',
  },
  'package-selector': {
    placeholder: 'Search by name',
    label: 'Package',
  },
  adblock: {
    title: "Please disable Ad Blocker on Prepforce's domain",
    description:
      "Don't worry, there are no ads in Prepforce. However, ad blockers may block legitimate requests in XPlenty when you connect to ad related data sources, so we encourage you to disable ad blocker on Prepforce's domain.",
  },
  'errors-viewer': {
    title: 'The following validation errors occurred:',
    'success-message': 'Package validation completed and no errors found.',
    close: 'Close',
    revalidate: 'Revalidate',
  },
  about: {
    connections: {
      sections: {
        '1': {
          title: 'Connect and Integrate',
          description:
            "Applications, databases, files, data warehouses. We've them all. Connect and integrate a wide set of data repositories and SaaS applications.",
        },
        '2': {
          title: 'Set & Forget',
          description: 'Configure your connections once and use the setup for all your data integrations.',
        },
        '3': {
          title: 'Flexibile',
          description: 'Use our REST API component to connect any RESTful service.',
        },
      },
    },
    packages: {
      sections: {
        '1': {
          title: 'What is a package?',
          description: 'A package is an executable, user-defined pipeline that moves data from one place to another.',
        },
        '2': {
          title: 'Powerful, yet simple',
          description:
            'Implement simple replication or complex data preparation and transformation tasks, with a point-and-click interface.',
        },
        '3': {
          title: 'Data that makes sense',
          description: 'Aggregate, join, and script to process and prepare your data for analytics.',
        },
      },
    },
    clusters: {
      sections: {
        '1': {
          title: 'What is a cluster?',
          description:
            "An Prepforce cluster is a group of machines (aka nodes) that is allocated exclusively to your account's users, and it is used to run jobs.",
        },
        '2': {
          title: 'Infinitely scalable',
          description:
            'You can create one or more clusters and run one or more jobs concurrently on each cluster. The more nodes you have running, the more parallel processing power you get.',
        },
        '3': {
          title: 'Dedicated',
          description:
            "A cluster that you create is 'owned' by your account until you request that we terminate your cluster.",
        },
      },
    },
    jobs: {
      sections: {
        '1': {
          title: 'From package to job',
          description:
            'You have defined a package, now you can run it either from the UI, the API or using a schedule.',
        },
        '2': {
          title: 'Jobs in action',
          description: 'As the data moves you can monitor its progress and status.',
        },
        '3': {
          title: 'See the results',
          description:
            'When a job completes, your data will be written to the destination. You can even preview that data in-app. Time to party.',
        },
      },
    },
    schedules: {
      sections: {
        '1': {
          title: 'Set a schedule',
          description:
            "Run your packages when you want. Set a start time and frequency and we'll take care of the rest for you.",
        },
        '2': {
          title: 'Hands-off',
          description: 'Let Prepforce by Integrate.io keep your data up to date. Always.',
        },
        '3': {
          title: 'A natural cadence',
          description: 'Define the intervals that best fit your data needs.',
        },
      },
    },
    workspaces: {
      sections: {
        '1': {
          title: 'What is a workspace?',
          description:
            "A workspace provides a way to group and organize packages together. Think of workspaces like folders.",
        },
        '2': {
          title: 'Group packages based on your requirements.',
          description: 'Want to group pipelines by team? Need to segregate pipelines by customer? Use workspaces to group packages together based on your requirements.',
        },
        '3': {
          title: '',
          description: '',
        },
      },
    },
  },
  'job-form': {
    steps: {
      cluster: 'Cluster',
      'cluster-edit': 'Choose a cluster',
      package: 'Package',
      'package-edit': 'Choose a package',
      'schedule-package-version': 'Package version',
      'schedule-package-version-edit': 'Choose a package version',
      variables: 'Variables',
      'variables-edit': 'Edit package variables',
    },
  },
  'package-version-form': {
    steps: {
      package: 'Package',
      'package-edit': 'Rollback to previous version',
    },
  },
  'note-form': {
    title: 'Edit note',
    labels: {
      note_description: 'Note description',
    },
  },
  'file-names-pattern': {
    label: {
      type: 'Target file names',
      prefix: 'File name prefix',
      suffix: 'File name suffix',
    },
    placeholder: {
      prefix: '(default)',
      suffix: '(default)',
    },
    select: {
      option: {
        default: 'Default pattern',
        custom: 'Custom pattern',
      },
    },
  },
  invoices: {
    title: 'Invoices',
    'empty-table-text': 'No invoices found.',
    'table-titles': {
      id: '#',
      date: 'Date',
      amount: 'Amount',
      status: 'Status',
      link: 'Link',
    },
    pagination: {
      prev: 'Previous',
      next: 'Next',
    },
    status: {
      successful: 'Paid',
      pending: 'Pending',
      failed: 'Failed',
    },
  },
  'fields-collection': {
    headers: {
      'alias-editor': 'Alias',
      'sort-direction-picker': 'Direction',
      'datatype-picker': 'Data type',
      'field-picker': 'Field',
      'function-picker': 'Function',
      'condition-operator-picker': 'Operator',
      'cube-rollup-picker': 'Grouping',
      'window-arguments-editor': 'Arguments',
      'ordered-fields-picker': 'Fields',
      'merge-key': 'Key',
      'bson': 'BSON',
      'bag': 'Bag',
      'json': 'JSON',
      'database-column-editor': 'Destination column',
      'field-expression-editor': 'Expression',
      'field-argument': 'Field Argument',
      'projected-field': 'Projected Field',
      'bson-tooltip': 'Check this for bag or map data types. BSON columns are inserted to MongoDB as nested BSON documents.',
      'bag-tooltip': 'Check this for bag data types.',
      'json-tooltip': 'Check this for Object/Array data types.',
    },
    errors: {
      empty_collection: 'Collection must contain at least 1 valid record',
      duplicate_field: "{ fieldName } must be unique",
    },
    hints: {
      find: 'Press Enter to move to the next match or Esc to focus on current match.',
    },
    editors: {
      'alias-editor': {
        errors: {
          empty: "Alias can't be empty.",
          illegal_characters: 'Alias contains illegal characters',
          reserved_keywords: 'Alias uses a reserved keyword',
        },
      },
      'field-picker': {
        errors: {
          missing_field: 'Field name "{ fieldName }" not found in input schema',
          no_input_schema: 'No input schema',
        },
      },
      'ordered-fields-picker': {
        errors: {
          empty: 'Select at least one field',
          missing_fields: 'Fields not found in input component',
          no_input_schema: 'No input schema',
        },
      },
      'field-expression-editor': {
        placeholders: {
          expression: 'Write an expression or pick a field',
          text: '',
          none: '',
        },
        errors: {
          empty: 'Value can’t be empty',
        },
      },
      'rest-api-headers-key': {
        errors: {
          empty: "Headers key can't be empty.",
        },
      },
      'rest-api-headers-value': {
        errors: {
          empty: "Headers value can't be empty.",
        },
      },
      'condition-operator-picker': {
        teq: 'Text equals',
        tneq: 'Text not equals',
        matches: 'Text matches (regex)',
        tise: 'Text is empty',
        tisne: 'Text is not empty',
        eq: '=',
        neq: '!=',
        gt: '>',
        gte: '>=',
        lt: '<',
        lte: '<=',
        isn: 'Is null',
        isnn: 'Is not null',
        ist: 'Is true',
      },
      'function-picker': {
        count: 'Count',
        count_distinct: 'Count Distinct',
        count_star: 'Count All',
        hll: 'HyperLogLog++',
        avg: 'Average',
        sum: 'Sum',
        min: 'Min',
        min_by: 'Min By',
        max: 'Max',
        max_by: 'Max By',
        var: 'VAR',
        varp: 'VARP',
        stdev: 'STDEV',
        stdevp: 'STDEVP',
        collect: 'Collect',
        first_value: 'First Value',
        last_value: 'Last Value',
        lead: 'Lead',
        lag: 'Lag',
        row_number: 'Row Number',
        ntile: 'NTILE',
      },
      'sort-direction-picker': {
        ASC: 'Ascending',
        DESC: 'Descending',
      },
      'datatype-picker': {
        string: 'String',
        int: 'Integer',
        long: 'Long',
        float: 'Float',
        double: 'Double',
        binary: 'Binary',
        boolean: 'Boolean',
        datetime: 'DateTime',
        json: 'Map',
        array: 'Bag',
      },
      'cube-rollup-picker': {
        cube: 'Cube',
        rollup: 'Rollup',
      },
    },
  },
  'onboarding-toolbar': {
    welcome: 'Welcome',
    'get-started': 'Get Started',
    'bottom-text': 'Not sure where to start? Try getting our getting started guide.',
    'trial-days-left':
      '{days, plural, =0{Your trial period has expired} one{Your free trial expires today} other{# trial days left}}',
    upgrade: 'Upgrade',
    'get-help': 'Get Help',
    great: "That's great",
    keep_going: 'Keep going!',
    'step-1': 'Create a valid connection',
    'step-2': 'Build a valid package',
    'step-3': 'Successfully execute a job',
    'step-4': 'Create a schedule',
  },
  'account-campaign-selector': {
    selected: {
      analytics_source_component: {
        empty: 'No profiles have been selected, Thus all profiles will be included in results',
      },
      analytics_ga4_source_component: {
        empty: 'No profiles have been selected, Thus all profiles will be included in results',
      },
      adwords_source_component: {
        empty: 'No customers have been selected, Thus all customers will be included in results',
      },
      bing_ads_source_component: {
        empty: 'No account or campaigns have been selected, Thus all accounts will be included in results',
      },
      facebook_ads_insights_source_component: {
        empty: '',
      },
    },
  },
  'members-invitation': {
    title: 'Welcome to Prepforce by Integrate.io!',
    labels: {
      email: 'Email',
      password: 'Password',
      password_confirmation: 'Password confirmation',
      user_receive_newsletter: 'Send me a monthly newsletter featuring Prepforce by Integrate.io news and events.',
    },
    placeholders: {
      email: 'Email',
      password: 'Password',
      password_confirmation: 'Password confirmation',
    },
    hints: {
      password:
        'You have been invited to join Prepforce by Integrate.io. To create your user, please enter a password. Password must contain at least 6 characters.',
    },
    submit_button: "Okay, let's go!",
  },
  package_major_version_form: {
    title: 'Version Description',
  },
};
